(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(39022);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uriToHttp; }
/* harmony export */ });
/* eslint-disable no-case-declarations */ /**
 * Given a URI that may be ipfs, ipns, http, or https protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */ function uriToHttp(uri) {
    var protocol = uri.split(":")[0].toLowerCase();
    switch(protocol){
        case "https":
            return [
                uri
            ];
        case "http":
            return [
                "https".concat(uri.substring(4)),
                uri
            ];
        case "ipfs":
            var ref;
            var hash = (ref = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || ref === void 0 ? void 0 : ref[2];
            return [
                "https://cloudflare-ipfs.com/ipfs/".concat(hash, "/"),
                "https://ipfs.io/ipfs/".concat(hash, "/")
            ];
        case "ipns":
            var ref1;
            var name = (ref1 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || ref1 === void 0 ? void 0 : ref1[2];
            return [
                "https://cloudflare-ipfs.com/ipns/".concat(name, "/"),
                "https://ipfs.io/ipns/".concat(name, "/")
            ];
        default:
            return [];
    }
}


/***/ }),

/***/ 39022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var src = __webpack_require__(86338);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Box_Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var hooks_useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./node_modules/jsbi/dist/jsbi-umd.js
var jsbi_umd = __webpack_require__(39499);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var utils_wrappedCurrency = __webpack_require__(73938);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(41166);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/utils/trades.ts

// returns whether tradeB is better than tradeA by at least a threshold percentage amount
function isTradeBetter(tradeA, tradeB) {
    var minimumDelta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : exchange/* ZERO_PERCENT */.fI;
    if (tradeA && !tradeB) return false;
    if (tradeB && !tradeA) return true;
    if (!tradeA || !tradeB) return undefined;
    if (tradeA.tradeType !== tradeB.tradeType || !tradeA.inputAmount.currency.equals(tradeB.inputAmount.currency) || !tradeA.outputAmount.currency.equals(tradeB.outputAmount.currency)) {
        throw new Error("Trades are not comparable");
    }
    if (minimumDelta.equalTo(exchange/* ZERO_PERCENT */.fI)) {
        return tradeA.executionPrice.lessThan(tradeB.executionPrice);
    }
    return tradeA.executionPrice.asFraction.multiply(minimumDelta.add(exchange/* ONE_HUNDRED_PERCENT */.yC)).lessThan(tradeB.executionPrice);
}
/* harmony default export */ var trades = ((/* unused pure expression or super */ null && (isTradeBetter)));

// EXTERNAL MODULE: ./node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(94654);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx + 4 modules
var hooks = __webpack_require__(36055);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(71633);
;// CONCATENATED MODULE: ./src/hooks/Trades.ts
/* eslint-disable no-param-reassign */ 











function useAllCommonPairs(currencyA, currencyB) {
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,src_sliced_to_array/* default */.Z)(chainId ? [
        (0,utils_wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId),
        (0,utils_wrappedCurrency/* wrappedCurrency */.pu)(currencyB, chainId)
    ] : [
        undefined,
        undefined
    ], 2), tokenA = ref[0], tokenB = ref[1];
    var bases = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!chainId) return [];
        var _chainId;
        var common = (_chainId = exchange/* BASES_TO_CHECK_TRADES_AGAINST */.lM[chainId]) !== null && _chainId !== void 0 ? _chainId : [];
        var ref2;
        var additionalA = tokenA ? (ref2 = (ref = exchange/* ADDITIONAL_BASES */.ck[chainId]) === null || ref === void 0 ? void 0 : ref[tokenA.address]) !== null && ref2 !== void 0 ? ref2 : [] : [];
        var ref3;
        var additionalB = tokenB ? (ref3 = (ref1 = exchange/* ADDITIONAL_BASES */.ck[chainId]) === null || ref1 === void 0 ? void 0 : ref1[tokenB.address]) !== null && ref3 !== void 0 ? ref3 : [] : [];
        return (0,src_to_consumable_array/* default */.Z)(common).concat((0,src_to_consumable_array/* default */.Z)(additionalA), (0,src_to_consumable_array/* default */.Z)(additionalB));
    }, [
        chainId,
        tokenA,
        tokenB
    ]);
    var basePairs = (0,react.useMemo)(function() {
        return flatMap_default()(bases, function(base) {
            return bases.map(function(otherBase) {
                return [
                    base,
                    otherBase
                ];
            });
        });
    }, [
        bases
    ]);
    var allPairCombinations = (0,react.useMemo)(function() {
        return tokenA && tokenB ? [
            // the direct pair
            [
                tokenA,
                tokenB
            ], 
        ].concat(// token A against all bases
        (0,src_to_consumable_array/* default */.Z)(bases.map(function(base) {
            return [
                tokenA,
                base
            ];
        })), // token B against all bases
        (0,src_to_consumable_array/* default */.Z)(bases.map(function(base) {
            return [
                tokenB,
                base
            ];
        })), // each base against all bases
        (0,src_to_consumable_array/* default */.Z)(basePairs)).filter(function(tokens) {
            return Boolean(tokens[0] && tokens[1]);
        }).filter(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), t0 = _param[0], t1 = _param[1];
            return t0.address !== t1.address;
        }).filter(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), tokenA_ = _param[0], tokenB_ = _param[1];
            if (!chainId) return true;
            var customBases = exchange/* CUSTOM_BASES */.IP[chainId];
            var customBasesA = customBases === null || customBases === void 0 ? void 0 : customBases[tokenA_.address];
            var customBasesB = customBases === null || customBases === void 0 ? void 0 : customBases[tokenB_.address];
            if (!customBasesA && !customBasesB) return true;
            if (customBasesA && !customBasesA.find(function(base) {
                return tokenB_.equals(base);
            })) return false;
            if (customBasesB && !customBasesB.find(function(base) {
                return tokenA_.equals(base);
            })) return false;
            return true;
        }) : [];
    }, [
        tokenA,
        tokenB,
        bases,
        basePairs,
        chainId
    ]);
    var allPairs = (0,usePairs/* usePairs */.z$)(allPairCombinations);
    // only pass along valid pairs, non-duplicated pairs
    return (0,react.useMemo)(function() {
        return Object.values(allPairs// filter out invalid pairs
        .filter(function(result) {
            return Boolean(result[0] === usePairs/* PairState.EXISTS */._G.EXISTS && result[1]);
        })// filter out duplicated pairs
        .reduce(function(memo, param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), curr = _param[1];
            var _address;
            memo[curr.liquidityToken.address] = (_address = memo[curr.liquidityToken.address]) !== null && _address !== void 0 ? _address : curr;
            return memo;
        }, {}));
    }, [
        allPairs
    ]);
}
var MAX_HOPS = 3;
/**
 * Returns the best trade for the exact amount of tokens in to the given token out
 */ function Trades_useTradeExactIn(currencyAmountIn, currencyOut) {
    var allowedPairs = useAllCommonPairs(currencyAmountIn === null || currencyAmountIn === void 0 ? void 0 : currencyAmountIn.currency, currencyOut);
    var ref = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    return (0,react.useMemo)(function() {
        if (currencyAmountIn && currencyOut && allowedPairs.length > 0) {
            if (singleHopOnly) {
                var ref;
                return (ref = src/* Trade.bestTradeExactIn */.ho.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, {
                    maxHops: 1,
                    maxNumResults: 1
                })[0]) !== null && ref !== void 0 ? ref : null;
            }
            // search through trades with varying hops, find best trade out of them
            var bestTradeSoFar = null;
            for(var i = 1; i <= MAX_HOPS; i++){
                var ref1;
                var currentTrade = (ref1 = src/* Trade.bestTradeExactIn */.ho.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, {
                    maxHops: i,
                    maxNumResults: 1
                })[0]) !== null && ref1 !== void 0 ? ref1 : null;
                // if current trade is best yet, save it
                if (isTradeBetter(bestTradeSoFar, currentTrade, exchange/* BETTER_TRADE_LESS_HOPS_THRESHOLD */.Ru)) {
                    bestTradeSoFar = currentTrade;
                }
            }
            return bestTradeSoFar;
        }
        return null;
    }, [
        allowedPairs,
        currencyAmountIn,
        currencyOut,
        singleHopOnly
    ]);
}
/**
 * Returns the best trade for the token in to the exact amount of token out
 */ function Trades_useTradeExactOut(currencyIn, currencyAmountOut) {
    var allowedPairs = useAllCommonPairs(currencyIn, currencyAmountOut === null || currencyAmountOut === void 0 ? void 0 : currencyAmountOut.currency);
    var ref = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    return (0,react.useMemo)(function() {
        if (currencyIn && currencyAmountOut && allowedPairs.length > 0) {
            if (singleHopOnly) {
                var ref;
                return (ref = src/* Trade.bestTradeExactOut */.ho.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, {
                    maxHops: 1,
                    maxNumResults: 1
                })[0]) !== null && ref !== void 0 ? ref : null;
            }
            // search through trades with varying hops, find best trade out of them
            var bestTradeSoFar = null;
            for(var i = 1; i <= MAX_HOPS; i++){
                var ref1;
                var currentTrade = (ref1 = src/* Trade.bestTradeExactOut */.ho.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, {
                    maxHops: i,
                    maxNumResults: 1
                })[0]) !== null && ref1 !== void 0 ? ref1 : null;
                if (isTradeBetter(bestTradeSoFar, currentTrade, exchange/* BETTER_TRADE_LESS_HOPS_THRESHOLD */.Ru)) {
                    bestTradeSoFar = currentTrade;
                }
            }
            return bestTradeSoFar;
        }
        return null;
    }, [
        currencyIn,
        currencyAmountOut,
        allowedPairs,
        singleHopOnly
    ]);
}
function useIsTransactionUnsupported(currencyIn, currencyOut) {
    var unsupportedTokens = (0,Tokens/* useUnsupportedTokens */.l6)();
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var tokenIn = (0,utils_wrappedCurrency/* wrappedCurrency */.pu)(currencyIn, chainId);
    var tokenOut = (0,utils_wrappedCurrency/* wrappedCurrency */.pu)(currencyOut, chainId);
    // if unsupported list loaded & either token on list, mark as unsupported
    if (unsupportedTokens) {
        if (tokenIn && Object.keys(unsupportedTokens).includes(tokenIn.address)) {
            return true;
        }
        if (tokenOut && Object.keys(unsupportedTokens).includes(tokenOut.address)) {
            return true;
        }
    }
    return false;
}
function useIsTransactionWarning(currencyIn, currencyOut) {
    var unsupportedTokens = useWarningTokens();
    var chainId = useActiveWeb3React().chainId;
    var tokenIn = wrappedCurrency(currencyIn, chainId);
    var tokenOut = wrappedCurrency(currencyOut, chainId);
    // if unsupported list loaded & either token on list, mark as unsupported
    if (unsupportedTokens) {
        if (tokenIn && Object.keys(unsupportedTokens).includes(tokenIn.address)) {
            return true;
        }
        if (tokenOut && Object.keys(unsupportedTokens).includes(tokenOut.address)) {
            return true;
        }
    }
    return false;
}

;// CONCATENATED MODULE: ./src/views/LimitOrders/utils/getPriceForOneToken.ts

/**
 * Given certain amount if input and output tokens
 * calculate the price for 1 input token in terms of output tokens
 */ var getPriceForOneToken_getPriceForOneToken = function(inputAmount, outputAmount) {
    if (!inputAmount || !outputAmount || inputAmount.equalTo(0) || outputAmount.equalTo(0)) {
        return undefined;
    }
    return new Price({
        baseAmount: inputAmount,
        quoteAmount: outputAmount
    });
};
/* harmony default export */ var utils_getPriceForOneToken = ((/* unused pure expression or super */ null && (getPriceForOneToken_getPriceForOneToken)));

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
;// CONCATENATED MODULE: ./packages/utils/tryParseAmount.ts


// try to parse a user entered amount for a given token
function tryParseAmount_tryParseAmount(value, currency) {
    if (!value || !currency) {
        return undefined;
    }
    try {
        var typedValueParsed = (0,lib_esm.parseUnits)(value, currency.decimals).toString();
        if (typedValueParsed !== "0") {
            return src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(currency, src/* JSBI.BigInt */.QA.BigInt(typedValueParsed));
        }
    } catch (error) {
        // should fail if the user specifies too many decimal places of precision (or maybe exceed max uint?)
        console.debug('Failed to parse input amount: "'.concat(value, '"'), error);
    }
    // necessary for all paths to return a value
    return undefined;
}
/* harmony default export */ var utils_tryParseAmount = (tryParseAmount_tryParseAmount);

// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/config/abi/erc20.ts + 1 modules
var erc20 = __webpack_require__(56309);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(36963);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/hooks/useNativeCurrency.ts
var useNativeCurrency = __webpack_require__(19915);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var multicall_hooks = __webpack_require__(410);
;// CONCATENATED MODULE: ./src/state/wallet/hooks.ts










/**
 * Returns a map of the given addresses to their eventually consistent BNB balances.
 */ function useNativeBalances(uncheckedAddresses) {
    var native = (0,useNativeCurrency/* default */.Z)();
    var multicallContract = (0,useContract/* useMulticallContract */.gq)();
    var addresses = (0,react.useMemo)(function() {
        return uncheckedAddresses ? orderBy_default()(uncheckedAddresses.map(utils/* isAddress */.UJ).filter(function(a) {
            return a !== false;
        })) : [];
    }, [
        uncheckedAddresses
    ]);
    var results = (0,multicall_hooks/* useSingleContractMultipleData */.es)(multicallContract, "getEthBalance", (0,react.useMemo)(function() {
        return addresses.map(function(address) {
            return [
                address
            ];
        });
    }, [
        addresses
    ]));
    return (0,react.useMemo)(function() {
        return addresses.reduce(function(memo, address, i) {
            var ref, ref1;
            var value = results === null || results === void 0 ? void 0 : (ref = results[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
            if (value) memo[address.toLocaleLowerCase()] = src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(native, src/* JSBI.BigInt */.QA.BigInt(value.toString()));
            return memo;
        }, {});
    }, [
        addresses,
        results,
        native
    ]);
}
/**
 * Returns a map of token addresses to their eventually consistent token balances for a single account.
 */ function useTokenBalancesWithLoadingIndicator(address, tokens) {
    var ref;
    var validatedTokens = (0,react.useMemo)(function() {
        return (ref = tokens === null || tokens === void 0 ? void 0 : tokens.filter(function(t) {
            return (0,utils/* isAddress */.UJ)(t === null || t === void 0 ? void 0 : t.address) !== false;
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        tokens
    ]);
    var validatedTokenAddresses = (0,react.useMemo)(function() {
        return validatedTokens.map(function(vt) {
            return vt.address;
        });
    }, [
        validatedTokens
    ]);
    var balances = (0,multicall_hooks/* useMultipleContractSingleData */._Y)(validatedTokenAddresses, erc20/* default */.ZP, "balanceOf", (0,react.useMemo)(function() {
        return [
            address
        ];
    }, [
        address
    ]));
    var anyLoading = (0,react.useMemo)(function() {
        return balances.some(function(callState) {
            return callState.loading;
        });
    }, [
        balances
    ]);
    return [
        (0,react.useMemo)(function() {
            return address && validatedTokens.length > 0 ? validatedTokens.reduce(function(memo, token, i) {
                var ref, ref1;
                var value = balances === null || balances === void 0 ? void 0 : (ref = balances[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
                var amount = value ? src/* JSBI.BigInt */.QA.BigInt(value.toString()) : undefined;
                if (amount) {
                    memo[token.address] = src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(token, amount);
                }
                return memo;
            }, {}) : {};
        }, [
            address,
            validatedTokens,
            balances
        ]),
        anyLoading, 
    ];
}
function useTokenBalances(address, tokens) {
    return useTokenBalancesWithLoadingIndicator(address, tokens)[0];
}
// get the balance for a single token/account combo
function useTokenBalance(account, token) {
    var tokenBalances = useTokenBalances(account, [
        token
    ]);
    if (!token) return undefined;
    return tokenBalances[token.address];
}
function hooks_useCurrencyBalances(account, currencies) {
    var ref;
    var tokens = (0,react.useMemo)(function() {
        return (ref = currencies === null || currencies === void 0 ? void 0 : currencies.filter(function(currency) {
            return currency === null || currency === void 0 ? void 0 : currency.isToken;
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        currencies
    ]);
    var tokenBalances = useTokenBalances(account, tokens);
    var ref1;
    var containsNative = (0,react.useMemo)(function() {
        return (ref1 = currencies === null || currencies === void 0 ? void 0 : currencies.some(function(currency) {
            return currency === null || currency === void 0 ? void 0 : currency.isNative;
        })) !== null && ref1 !== void 0 ? ref1 : false;
    }, [
        currencies
    ]);
    var uncheckedAddresses = (0,react.useMemo)(function() {
        return containsNative ? [
            account
        ] : [];
    }, [
        containsNative,
        account
    ]);
    var nativeBalance = useNativeBalances(uncheckedAddresses);
    var ref2;
    return (0,react.useMemo)(function() {
        return (ref2 = currencies === null || currencies === void 0 ? void 0 : currencies.map(function(currency) {
            if (!account || !currency) return undefined;
            if (currency === null || currency === void 0 ? void 0 : currency.isToken) return tokenBalances[currency.address];
            if (currency === null || currency === void 0 ? void 0 : currency.isNative) return nativeBalance[account.toLocaleLowerCase()];
            return undefined;
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        account,
        currencies,
        nativeBalance,
        tokenBalances
    ]);
}
function useCurrencyBalance(account, currency) {
    return hooks_useCurrencyBalances(account, [
        currency
    ])[0];
}
// mimics useAllBalances
function useAllTokenBalances() {
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var allTokens = (0,Tokens/* useAllTokens */.e_)();
    var allTokensArray = (0,react.useMemo)(function() {
        return Object.values(allTokens !== null && allTokens !== void 0 ? allTokens : {});
    }, [
        allTokens
    ]);
    var balances = useTokenBalances(account !== null && account !== void 0 ? account : undefined, allTokensArray);
    return balances !== null && balances !== void 0 ? balances : {};
}

// EXTERNAL MODULE: ./src/state/limitOrders/actions.ts
var actions = __webpack_require__(47330);
// EXTERNAL MODULE: ./src/state/limitOrders/types.ts
var types = __webpack_require__(91392);
// EXTERNAL MODULE: ./src/state/index.ts + 46 modules
var state = __webpack_require__(88555);
;// CONCATENATED MODULE: ./src/state/limitOrders/hooks.ts



















// Get desired input amount in output basis mode
var getDesiredInput = function(outputValue, exchangeRate, inputCurrency, outputCurrency, isInverted) {
    if (!outputValue || !inputCurrency || !outputCurrency) {
        return undefined;
    }
    var parsedOutAmount = tryParseAmount(outputValue, isInverted ? inputCurrency : outputCurrency);
    var parsedExchangeRate = tryParseAmount(exchangeRate, isInverted ? inputCurrency : outputCurrency);
    if (!parsedOutAmount || !parsedExchangeRate) {
        return undefined;
    }
    if (isInverted) {
        var invertedResultAsFraction = parsedOutAmount.multiply(parsedExchangeRate.asFraction).multiply(JSBI.exponentiate(BIG_INT_TEN, JSBI.BigInt(inputCurrency.decimals)));
        var invertedResultAsAmount = CurrencyAmount.fromRawAmount(inputCurrency, invertedResultAsFraction.toFixed(0));
        return invertedResultAsAmount;
    }
    var resultAsFraction = parsedOutAmount.divide(parsedExchangeRate.asFraction).multiply(JSBI.exponentiate(BIG_INT_TEN, JSBI.BigInt(inputCurrency.decimals)));
    return CurrencyAmount.fromRawAmount(inputCurrency, resultAsFraction.quotient.toString());
};
// Get desired output amount in input basis mode
var getDesiredOutput = function(inputValue, exchangeRate, inputCurrency, outputCurrency, isInverted) {
    if (!inputValue || !inputCurrency || !outputCurrency) {
        return undefined;
    }
    var parsedInputAmount = tryParseAmount(inputValue, isInverted ? outputCurrency : inputCurrency);
    var parsedExchangeRate = tryParseAmount(exchangeRate, isInverted ? inputCurrency : outputCurrency);
    if (!parsedExchangeRate || !parsedInputAmount) {
        return undefined;
    }
    if (isInverted) {
        var invertedResultAsFraction = parsedInputAmount.multiply(JSBI.exponentiate(BIG_INT_TEN, JSBI.BigInt(inputCurrency.decimals))).divide(parsedExchangeRate.asFraction);
        return CurrencyAmount.fromRawAmount(outputCurrency, invertedResultAsFraction.quotient);
    }
    var resultAsFraction = parsedInputAmount.divide(JSBI.exponentiate(BIG_INT_TEN, JSBI.BigInt(inputCurrency.decimals))).multiply(parsedExchangeRate.asFraction);
    return CurrencyAmount.fromRawAmount(outputCurrency, resultAsFraction.quotient.toString());
};
// Just returns Redux state for limitOrders
var useOrderState = function() {
    return useSelector(function(state) {
        return state.limitOrders;
    });
};
// Returns handlers to change user-defined parts of limitOrders state
var useOrderActionHandlers = function() {
    var dispatch = useDispatch();
    var onCurrencySelection = useCallback(function(field, currency) {
        dispatch(selectCurrency({
            field: field,
            currencyId: currency.isToken ? currency.address : currency.isNative ? "BNB" : ""
        }));
    }, [
        dispatch
    ]);
    var onSwitchTokens = useCallback(function() {
        dispatch(switchCurrencies());
    }, [
        dispatch
    ]);
    var onUserInput = useCallback(function(field, typedValue) {
        dispatch(typeInput({
            field: field,
            typedValue: typedValue
        }));
    }, [
        dispatch
    ]);
    var onChangeRateType = useCallback(function(rateType) {
        dispatch(setRateType({
            rateType: rateType
        }));
    }, [
        dispatch
    ]);
    return {
        onSwitchTokens: onSwitchTokens,
        onCurrencySelection: onCurrencySelection,
        onUserInput: onUserInput,
        onChangeRateType: onChangeRateType
    };
};
var getErrorMessage = function(account, wrappedCurrencies, currencies, currencyBalances, parsedAmounts, trade, price, rateType, t) {
    if (!account) {
        return t("Connect Wallet");
    }
    if (wrappedCurrencies.input && wrappedCurrencies.output && wrappedCurrencies.input.address.toLowerCase() === wrappedCurrencies.output.address.toLowerCase()) {
        return t("Order not allowed");
    }
    var hasBothTokensSelected = currencies.input && currencies.output;
    if (!hasBothTokensSelected) {
        return t("Select a token");
    }
    var hasAtLeastOneParsedAmount = parsedAmounts.input || parsedAmounts.output;
    var tradeIsNotAvailable = !trade || !(trade === null || trade === void 0 ? void 0 : trade.route);
    if (hasAtLeastOneParsedAmount && tradeIsNotAvailable) {
        return t("Insufficient liquidity for this trade.");
    }
    var someParsedAmountIsMissing = !parsedAmounts.input || !parsedAmounts.output;
    if (someParsedAmountIsMissing) {
        return t("Enter an amount");
    }
    if (currencyBalances.input && currencyBalances.input.lessThan(parsedAmounts.input)) {
        return t("Insufficient %symbol% balance", {
            symbol: currencyBalances.input.currency.symbol
        });
    }
    if (price) {
        if (rateType === Rate.MUL && (price.lessThan(trade.executionPrice.asFraction) || price.equalTo(trade.executionPrice.asFraction))) {
            return t("Only possible to place sell orders above market rate");
        }
        if (rateType === Rate.DIV && (price.invert().greaterThan(trade.executionPrice.invert().asFraction) || price.invert().equalTo(trade.executionPrice.invert().asFraction))) {
            return t("Only possible to place buy orders below market rate");
        }
    }
    return undefined;
};
// from the current swap inputs, compute the best trade and return it.
var useDerivedOrderInfo = function() {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = useActiveWeb3React(), account = ref5.account, chainId = ref5.chainId;
    var t = useTranslation().t;
    var ref6 = useOrderState(), independentField = ref6.independentField, basisField = ref6.basisField, typedValue = ref6.typedValue, _INPUT = ref6[Field.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref6[Field.OUTPUT], outputCurrencyId = _OUTPUT.currencyId, rateType = ref6.rateType, inputValue = ref6.inputValue, outputValue = ref6.outputValue;
    // Get Currency objects based on currencyId strings
    var inputCurrency = useCurrency(inputCurrencyId);
    var outputCurrency = useCurrency(outputCurrencyId);
    var currencies = useMemo(function() {
        return {
            input: inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
            output: outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined
        };
    }, [
        inputCurrency,
        outputCurrency
    ]);
    var wrappedCurrencies = useMemo(function() {
        return {
            input: wrappedCurrency(currencies.input, chainId),
            output: wrappedCurrency(currencies.output, chainId)
        };
    }, [
        currencies.input,
        currencies.output,
        chainId
    ]);
    // Get user balance for selected Currencies
    var relevantTokenBalances = useCurrencyBalances(account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, 
    ]);
    var currencyBalances = {
        input: relevantTokenBalances[0],
        output: relevantTokenBalances[1]
    };
    // Get CurrencyAmount for the inputCurrency amount specified by user
    var inputAmount = useMemo(function() {
        return tryParseAmount(inputValue, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
    }, [
        inputValue,
        inputCurrency
    ]);
    // Get CurrencyAmount for the outputCurrency amount specified by user
    var outputAmount = useMemo(function() {
        return tryParseAmount(outputValue, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    }, [
        outputValue,
        outputCurrency
    ]);
    // Whether user modified the INPUT field most recently (also default initial state)
    var isExactIn = independentField === Field.INPUT;
    // Whether to base calculations on output field
    var isOutputBasis = basisField === Field.OUTPUT;
    // Whether user modified the PRICE field most recently
    var isDesiredRateUpdate = independentField === Field.PRICE;
    // Get the amount of outputCurrency you'd receive at the desired price
    var desiredOutputAsCurrencyAmount = isDesiredRateUpdate ? getDesiredOutput(inputValue, typedValue, inputCurrency, outputCurrency, rateType === Rate.DIV) : undefined;
    var desiredInputAsCurrencyAmount = isDesiredRateUpdate ? getDesiredInput(outputValue, typedValue, inputCurrency, outputCurrency, rateType === Rate.DIV) : undefined;
    // Convert output to string representation to parse later
    var desiredOutputAsString = isDesiredRateUpdate && desiredOutputAsCurrencyAmount ? desiredOutputAsCurrencyAmount === null || desiredOutputAsCurrencyAmount === void 0 ? void 0 : desiredOutputAsCurrencyAmount.toSignificant(6) : typedValue;
    var ref7;
    // If independentField === Field.PRICE -> this won't be used
    var parsedTypedAmount = !isDesiredRateUpdate ? tryParseAmount(typedValue, (ref7 = isExactIn ? inputCurrency : outputCurrency) !== null && ref7 !== void 0 ? ref7 : undefined) : undefined;
    // If not price - cast input or output typing to CurrencyAmount
    // if price - whatever amount of tokens received on the desired price
    var tradeAmount = isDesiredRateUpdate ? isOutputBasis ? outputAmount : tryParseAmount(desiredOutputAsString, outputCurrency) : tryParseAmount(typedValue, isExactIn ? inputCurrency : outputCurrency);
    // Get trade object
    // gonna be null if not isExactIn or if there is no outputCurrency selected
    var bestTradeExactIn = useTradeExactIn(isExactIn ? tradeAmount : undefined, outputCurrency);
    // Works similarly to swap when you modify outputCurrency
    // But also is used when desired rate is modified
    // in other words it looks for a trade of inputCurrency for whatever the amount of tokens would be at desired rate
    var bestTradeExactOut = useTradeExactOut(inputCurrency, !isExactIn || isOutputBasis ? tradeAmount : undefined);
    var trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    // Get swap price for single token disregarding slippage and price impact
    // needed for chart's latest value
    var oneInputToken = tryParseAmount("1", currencies.input);
    var singleTokenTrade = useTradeExactIn(oneInputToken, currencies.output);
    var singleTokenPrice = parseFloat(singleTokenTrade === null || singleTokenTrade === void 0 ? void 0 : (ref = singleTokenTrade.executionPrice) === null || ref === void 0 ? void 0 : ref.toSignificant(6));
    var inverseSingleTokenPrice = 1 / singleTokenPrice;
    // Get "final" amounts
    var parsedAmounts = useMemo(function() {
        // Use trade amount as default
        var input = trade === null || trade === void 0 ? void 0 : trade.inputAmount;
        if (!isOutputBasis) {
            // If we're not in output basis mode then we're in input basis mode
            // hence - no matter what keep input as specified by user
            input = inputAmount;
        } else if (independentField === Field.INPUT) {
            // If user touching input field -> whatever they type currently
            input = parsedTypedAmount;
        } else if (isDesiredRateUpdate) {
            // If user modifies the price AND is wishing for specific output amount -> hypothetical input amount at better price
            input = desiredInputAsCurrencyAmount;
        }
        // Use trade amount as default
        // If we're in output basis mode - no matter what keep output as specified by user
        var output;
        if (isOutputBasis) {
            output = outputAmount;
        } else if (independentField === Field.OUTPUT) {
            // If user touching input field -> whatever they type currently
            output = parsedTypedAmount;
        } else if (isDesiredRateUpdate) {
            // If user modifies the price AND is wishing for specific input amount -> hypothetical input amount at better price
            output = desiredOutputAsCurrencyAmount;
        } else {
            output = trade === null || trade === void 0 ? void 0 : trade.outputAmount;
        }
        return {
            input: input,
            output: output
        };
    }, [
        independentField,
        parsedTypedAmount,
        inputAmount,
        outputAmount,
        trade,
        isDesiredRateUpdate,
        isOutputBasis,
        desiredInputAsCurrencyAmount,
        desiredOutputAsCurrencyAmount, 
    ]);
    // Calculate the price for specified swap
    var price = useMemo(function() {
        return getPriceForOneToken(parsedAmounts.input, parsedAmounts.output);
    }, [
        parsedAmounts.input,
        parsedAmounts.output
    ]);
    var ref8, ref9, ref10, ref11;
    // Formatted amounts to use in the UI
    var formattedAmounts = {
        input: !isOutputBasis && inputValue && inputValue !== "" ? inputValue : (ref8 = (ref1 = parsedAmounts.input) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "",
        output: isOutputBasis && outputValue && outputValue !== "" ? outputValue : (ref9 = (ref2 = parsedAmounts.output) === null || ref2 === void 0 ? void 0 : ref2.toSignificant(6)) !== null && ref9 !== void 0 ? ref9 : "",
        price: independentField === Field.PRICE ? typedValue : rateType === Rate.MUL ? (ref10 = price === null || price === void 0 ? void 0 : price.toSignificant(6)) !== null && ref10 !== void 0 ? ref10 : "" : (ref11 = price === null || price === void 0 ? void 0 : price.invert().toSignificant(6)) !== null && ref11 !== void 0 ? ref11 : ""
    };
    // Get raw amounts that will be used in smart contract call
    var rawAmounts = useMemo(function() {
        var ref, ref1;
        return {
            input: inputCurrency ? (ref = parsedAmounts.input) === null || ref === void 0 ? void 0 : ref.multiply(JSBI.exponentiate(BIG_INT_TEN, JSBI.BigInt(inputCurrency.decimals))).toFixed(0) : undefined,
            output: outputCurrency ? (ref1 = parsedAmounts.output) === null || ref1 === void 0 ? void 0 : ref1.multiply(JSBI.exponentiate(BIG_INT_TEN, JSBI.BigInt(outputCurrency.decimals))).toFixed(0) : undefined
        };
    }, [
        inputCurrency,
        outputCurrency,
        parsedAmounts
    ]);
    var _obj;
    return {
        currencies: currencies,
        currencyBalances: currencyBalances,
        inputError: getErrorMessage(account, wrappedCurrencies, currencies, currencyBalances, parsedAmounts, trade, price, rateType, t),
        formattedAmounts: formattedAmounts,
        trade: trade !== null && trade !== void 0 ? trade : undefined,
        parsedAmounts: parsedAmounts,
        price: price,
        rawAmounts: rawAmounts,
        wrappedCurrencies: wrappedCurrencies,
        singleTokenPrice: (_obj = {}, _define_property(_obj, (ref3 = wrappedCurrencies.input) === null || ref3 === void 0 ? void 0 : ref3.address, singleTokenPrice), _define_property(_obj, (ref4 = wrappedCurrencies.output) === null || ref4 === void 0 ? void 0 : ref4.address, inverseSingleTokenPrice), _obj),
        currencyIds: {
            input: inputCurrencyId,
            output: outputCurrencyId
        }
    };
};
function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? types/* Field.OUTPUT */.g.OUTPUT : types/* Field.INPUT */.g.INPUT;
}
function parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === "string") {
        var valid = (0,utils/* isAddress */.UJ)(urlParam);
        if (valid) return valid;
        if (urlParam.toUpperCase() === "BNB") return "BNB";
        if (valid === false) return "BNB";
    }
    return "";
}
// TODO: combine with swap's version but use generic type. Same for helpers above
// Note: swap has recipient and other things. Merging these 2 would probably be much easier if we get rid of recipient
// Also the whole thing doesn't make sense, in swap inputValue is not initialized but typedValue is. WTF
var queryParametersToSwapState = function(parsedQs) {
    var inputCurrency = parseCurrencyFromURLParameter(parsedQs.inputCurrency) || exchange/* DEFAULT_INPUT_CURRENCY */.VN;
    var outputCurrency = parseCurrencyFromURLParameter(parsedQs.outputCurrency) || exchange/* DEFAULT_OUTPUT_CURRENCY */.g$;
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var _obj;
    return _obj = {}, (0,src_define_property/* default */.Z)(_obj, types/* Field.INPUT */.g.INPUT, {
        currencyId: inputCurrency
    }), (0,src_define_property/* default */.Z)(_obj, types/* Field.OUTPUT */.g.OUTPUT, {
        currencyId: outputCurrency
    }), (0,src_define_property/* default */.Z)(_obj, "inputValue", ""), (0,src_define_property/* default */.Z)(_obj, "outputValue", ""), (0,src_define_property/* default */.Z)(_obj, "typedValue", parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,src_define_property/* default */.Z)(_obj, "independentField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,src_define_property/* default */.Z)(_obj, "basisField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,src_define_property/* default */.Z)(_obj, "rateType", types/* Rate.MUL */.j.MUL), _obj;
};
// updates the swap state to use the defaults for a given network
var useDefaultsFromURLSearch = function() {
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var query = (0,next_router.useRouter)().query;
    var ref = (0,react.useState)(), result = ref[0], setResult = ref[1];
    (0,react.useEffect)(function() {
        if (!chainId) return;
        var parsed = queryParametersToSwapState(query);
        dispatch((0,actions/* replaceLimitOrdersState */.sQ)(parsed));
        setResult({
            inputCurrencyId: parsed[types/* Field.INPUT */.g.INPUT].currencyId,
            outputCurrencyId: parsed[types/* Field.OUTPUT */.g.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query
    ]);
    return result;
};

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/index.tsx
var Menu_GlobalSettings = __webpack_require__(69425);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal_Modal = __webpack_require__(85937);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(15426);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text_Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(7739);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(56906);
// EXTERNAL MODULE: ./src/state/transactions/actions.ts
var transactions_actions = __webpack_require__(44824);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 17 modules
var wagmi = __webpack_require__(87995);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
;// CONCATENATED MODULE: ./src/components/Layout/Row.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  margin: ",
        ";\n  justify-content: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  margin: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Row = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-a99b64d2-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "center";
}, function(param) {
    var justify = param.justify;
    return justify !== null && justify !== void 0 ? justify : "flex-start";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "0";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
});
var RowBetween = (0,styled_components_browser_esm/* default */.ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-1"
})(_templateObject1());
var RowFlat = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a99b64d2-2"
})(_templateObject2());
var AutoRow = (0,styled_components_browser_esm/* default */.ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-3"
})(_templateObject3(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var gap = param.gap;
    return gap;
});
var RowFixed = (0,styled_components_browser_esm/* default */.ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-4"
})(_templateObject4(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var gap = param.gap;
    return gap;
});
/* harmony default export */ var Layout_Row = (Row);

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Checkmark.tsx
var Checkmark = __webpack_require__(12851);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Close.tsx
var Close = __webpack_require__(81641);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/Loader/CircleLoader.tsx




function CircleLoader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    CircleLoader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CircleLoader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: 2s ",
        " linear infinite;\n  height: ",
        ";\n  width: ",
        ";\n  path {\n    stroke: ",
        ";\n  }\n"
    ]);
    CircleLoader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(CircleLoader_templateObject());
var StyledSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-fa227f0-0"
})(CircleLoader_templateObject1(), rotate, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var stroke = param.stroke, theme = param.theme;
    return stroke !== null && stroke !== void 0 ? stroke : theme.colors.primary;
});
/**
 * Takes in custom size and stroke for circle color, default to primary color as fill,
 * need ...rest for layered styles on top
 */ function CircleLoader(_param) {
    var _size = _param.size, size = _size === void 0 ? "16px" : _size, stroke = _param.stroke, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "size",
        "stroke"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSVG, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        size: size,
        stroke: stroke
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.27455 20.9097 6.80375 19.1414 5",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
}

;// CONCATENATED MODULE: ./src/components/App/Transactions/Transaction.tsx

function Transaction_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-decoration: none !important;\n  border-radius: 0.5rem;\n  padding: 0.25rem 0rem;\n  font-weight: 500;\n  font-size: 0.825rem;\n  color: ",
        ";\n"
    ]);
    Transaction_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Transaction_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    Transaction_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var TransactionState = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c944346-0"
})(Transaction_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2c944346-1"
})(Transaction_templateObject1(), function(param) {
    var pending = param.pending, success = param.success, theme = param.theme;
    return pending ? theme.colors.primary : success ? theme.colors.success : theme.colors.failure;
});
function Transaction(param) {
    var tx = param.tx, chainId = param.chainId;
    var ref, ref1;
    var summary = tx === null || tx === void 0 ? void 0 : tx.summary;
    var pending = !(tx === null || tx === void 0 ? void 0 : tx.receipt);
    var success = !pending && tx && (((ref = tx.receipt) === null || ref === void 0 ? void 0 : ref.status) === 1 || typeof ((ref1 = tx.receipt) === null || ref1 === void 0 ? void 0 : ref1.status) === "undefined");
    if (!chainId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionState, {
        pending: pending,
        success: success,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                href: (0,utils/* getBlockExploreLink */.C)(tx.hash, "transaction", chainId),
                children: summary !== null && summary !== void 0 ? summary : tx.hash
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                pending: pending,
                success: success,
                children: pending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleLoader, {}) : success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                    color: "success"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                    color: "failure"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx + 1 modules
var ConnectWalletButton = __webpack_require__(72409);
;// CONCATENATED MODULE: ./src/components/App/Transactions/TransactionsModal.tsx















function renderTransactions(transactions, chainId) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
        flexDirection: "column",
        children: transactions.map(function(tx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Transaction, {
                tx: tx,
                chainId: chainId
            }, tx.hash + tx.addedTime);
        })
    });
}
var TransactionsModal_TransactionsModal = function(param) {
    var onDismiss = param.onDismiss;
    var account = (0,hooks_useActiveWeb3React/* default */.Z)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var sortedRecentTransactions = (0,transactions_hooks/* useAllSortedRecentTransactions */.Fn)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var hasTransactions = !isEmpty_default()(sortedRecentTransactions);
    var clearAllTransactionsCallback = (0,react.useCallback)(function() {
        dispatch((0,transactions_actions/* clearAllTransactions */.fY)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        title: t("Recent Transactions"),
        headerBackground: "gradientCardHeader",
        onDismiss: onDismiss,
        children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
            children: hasTransactions ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                        mb: "1rem",
                        style: {
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                children: t("Recent Transactions")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "tertiary",
                                scale: "xs",
                                onClick: clearAllTransactionsCallback,
                                children: t("clear all")
                            })
                        ]
                    }),
                    Object.entries(sortedRecentTransactions).map(function(param) {
                        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), chainId = _param[0], transactions = _param[1];
                        var ref;
                        var chainIdNumber = Number(chainId);
                        var groupedTransactions = groupBy_default()(Object.values(transactions), function(trxDetails) {
                            return Boolean(trxDetails.receipt);
                        });
                        var _true;
                        var confirmed = (_true = groupedTransactions.true) !== null && _true !== void 0 ? _true : [];
                        var _false;
                        var pending = (_false = groupedTransactions.false) !== null && _false !== void 0 ? _false : [];
                        var ref1;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    mb: "4px",
                                    children: (ref1 = (ref = wagmi/* chains.find */.p5.find(function(c) {
                                        return c.id === chainIdNumber;
                                    })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : "Unknown network"
                                }),
                                renderTransactions(pending, chainIdNumber),
                                renderTransactions(confirmed, chainIdNumber)
                            ]
                        });
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                children: t("No recent transactions")
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
    });
};
/* harmony default export */ var Transactions_TransactionsModal = (TransactionsModal_TransactionsModal);

;// CONCATENATED MODULE: ./src/components/App/Transactions/index.tsx




var Transactions_Transactions = function() {
    var ref = _sliced_to_array(useModal(/*#__PURE__*/ _jsx(TransactionsModal, {})), 1), onPresentTransactionsModal = ref[0];
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(IconButton, {
            scale: "sm",
            variant: "text",
            onClick: onPresentTransactionsModal,
            children: /*#__PURE__*/ _jsx(HistoryIcon, {
                color: "textSubtle",
                width: "24px"
            })
        })
    });
};
/* harmony default export */ var App_Transactions = ((/* unused pure expression or super */ null && (Transactions_Transactions)));

// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var components_QuestionHelper = __webpack_require__(72566);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/types.ts
var GlobalSettings_types = __webpack_require__(47756);
;// CONCATENATED MODULE: ./src/components/App/AppHeader.tsx


function AppHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    AppHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var AppHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-9a635b87-0"
})(AppHeader_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var AppHeader = function(param) {
    var title = param.title, subtitle = param.subtitle, helper = param.helper, backTo = param.backTo, _noConfig = param.noConfig, noConfig = _noConfig === void 0 ? false : _noConfig;
    var ref = _sliced_to_array(useExpertModeManager(), 1), expertMode = ref[0];
    return /*#__PURE__*/ _jsx(AppHeaderContainer, {
        children: /*#__PURE__*/ _jsxs(Flex, {
            alignItems: "center",
            width: "100%",
            style: {
                gap: "16px"
            },
            children: [
                backTo && (typeof backTo === "string" ? /*#__PURE__*/ _jsx(Link, {
                    passHref: true,
                    href: backTo,
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        as: "a",
                        scale: "sm",
                        children: /*#__PURE__*/ _jsx(ArrowBackIcon, {
                            width: "32px"
                        })
                    })
                }) : /*#__PURE__*/ _jsx(IconButton, {
                    scale: "sm",
                    variant: "text",
                    onClick: backTo,
                    children: /*#__PURE__*/ _jsx(ArrowBackIcon, {
                        width: "32px"
                    })
                })),
                /*#__PURE__*/ _jsxs(Flex, {
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            mb: "8px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ _jsxs(Flex, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Heading, {
                                            as: "h2",
                                            children: title
                                        }),
                                        helper && /*#__PURE__*/ _jsx(QuestionHelper, {
                                            text: helper,
                                            ml: "4px",
                                            placement: "top-start"
                                        })
                                    ]
                                }),
                                !noConfig && /*#__PURE__*/ _jsxs(Flex, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(NotificationDot, {
                                            show: expertMode,
                                            children: /*#__PURE__*/ _jsx(GlobalSettings, {
                                                mode: SettingsMode.SWAP_LIQUIDITY
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Transactions, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Flex, {
                            alignItems: "center",
                            children: /*#__PURE__*/ _jsx(Text, {
                                color: "textSubtle",
                                fontSize: "14px",
                                children: subtitle
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var App_AppHeader = ((/* unused pure expression or super */ null && (AppHeader)));

// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(20353);
;// CONCATENATED MODULE: ./src/components/App/AppBody.tsx

function AppBody_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 24px;\n  max-width: 436px;\n  width: 100%;\n  z-index: 1;\n"
    ]);
    AppBody_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var BodyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-e8e91a75-0"
})(AppBody_templateObject());
/**
 * The styled container element that wraps the content of most pages and the tabs.
 */ function AppBody(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyWrapper, {
        children: children
    });
}

;// CONCATENATED MODULE: ./src/components/App/index.tsx



// EXTERNAL MODULE: ./src/state/swap/actions.ts
var swap_actions = __webpack_require__(15103);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var graphql_request_dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(6680);
;// CONCATENATED MODULE: ./src/utils/graphql.ts
/* provided dependency */ var process = __webpack_require__(34155);


// Extra headers
// Mostly for dev environment
// No production env check since production preview might also need them
var getGQLHeaders = function(endpoint) {
    if (endpoint === endpoints/* INFO_CLIENT */.JY) {
        return {
            "X-Sf": process.env.NEXT_PUBLIC_SF_HEADER || // hack for inject CI secret on window
             true && // @ts-ignore
            window.sfHeader
        };
    }
    return undefined;
};
var infoClient = new graphql_request_dist.GraphQLClient(endpoints/* INFO_CLIENT */.JY, {
    headers: getGQLHeaders(endpoints/* INFO_CLIENT */.JY)
});
var infoServerClient = new graphql_request_dist.GraphQLClient(endpoints/* INFO_CLIENT */.JY, {
    headers: {
        "X-Sf": process.env.SF_HEADER
    },
    timeout: 5000
});
var stableSwapClient = new graphql_request_dist.GraphQLClient(endpoints/* STABLESWAP_SUBGRAPH_CLIENT */.gr, {
    headers: getGQLHeaders(endpoints/* STABLESWAP_SUBGRAPH_CLIENT */.gr)
});
var bitQueryServerClient = new graphql_request_dist.GraphQLClient(endpoints/* BIT_QUERY */.d$, {
    headers: {
        // only server, no `NEXT_PUBLIC` not going to expose in client
        "X-API-KEY": process.env.BIT_QUERY_HEADER
    },
    timeout: 5000
});

;// CONCATENATED MODULE: ./src/utils/requestWithTimeout.ts
var requestWithTimeout = function(graphQLClient, request, variables) {
    var timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30000;
    return Promise.race([
        variables ? graphQLClient.request(request, variables) : graphQLClient.request(request),
        new Promise(function(_, reject) {
            setTimeout(function() {
                reject(new Error("Request timed out after ".concat(timeout, " milliseconds")));
            }, timeout);
        }), 
    ]);
};
/* harmony default export */ var utils_requestWithTimeout = (requestWithTimeout);

;// CONCATENATED MODULE: ./src/views/Info/utils/infoQueryHelpers.ts






/**
 * Helper function to get large amount GraphQL subqueries
 * @param queryConstructor constructor function that combines subqueries
 * @param subqueries individual queries
 * @param endpoint GraphQL endpoint
 * @param skipCount how many subqueries to fire at a time
 * @returns
 */ var multiQuery = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(queryConstructor, subqueries, endpoint) {
        var skipCount, fetchedData, allFound, skip, client, end, subqueriesSlice, result, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    skipCount = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 1000;
                    fetchedData = {};
                    allFound = false;
                    skip = 0;
                    client = new graphql_request_dist.GraphQLClient(endpoint, {
                        headers: getGQLHeaders(endpoint)
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!!allFound) return [
                        3,
                        3
                    ];
                    end = subqueries.length;
                    if (skip + skipCount < subqueries.length) {
                        end = skip + skipCount;
                    }
                    subqueriesSlice = subqueries.slice(skip, end);
                    return [
                        4,
                        utils_requestWithTimeout(client, queryConstructor(subqueriesSlice))
                    ];
                case 2:
                    result = _state.sent();
                    fetchedData = (0,src_object_spread/* default */.Z)({}, fetchedData, result);
                    allFound = Object.keys(result).length < skipCount || skip + skipCount > subqueries.length;
                    skip += skipCount;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        fetchedData
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetch info data", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function multiQuery(queryConstructor, subqueries, endpoint) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/getBlocksFromTimestamps.ts



function getBlocksFromTimestamps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "query blocks {\n    ",
        "\n  }"
    ]);
    getBlocksFromTimestamps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getBlockSubqueries = function(timestamps) {
    return timestamps.map(function(timestamp) {
        return "t".concat(timestamp, ":blocks(first: 1, orderBy: timestamp, orderDirection: desc, where: { timestamp_gt: ").concat(timestamp, ", timestamp_lt: ").concat(timestamp + 600, " }) {\n      number\n    }");
    });
};
var blocksQueryConstructor = function(subqueries) {
    return (0,graphql_request_dist.gql)(getBlocksFromTimestamps_templateObject(), subqueries);
};
/**
 * @notice Fetches block objects for an array of timestamps.
 * @param {Array} timestamps
 */ var getBlocksFromTimestamps_getBlocksFromTimestamps = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(timestamps) {
        var sortDirection, skipCount, fetchedData, blocks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sortDirection = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "desc", skipCount = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 500;
                    if ((timestamps === null || timestamps === void 0 ? void 0 : timestamps.length) === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        multiQuery(blocksQueryConstructor, getBlockSubqueries(timestamps), endpoints/* BLOCKS_CLIENT */.I0, skipCount)
                    ];
                case 1:
                    fetchedData = _state.sent();
                    blocks = [];
                    if (fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // eslint-disable-next-line no-restricted-syntax
                            for(_iterator = Object.keys(fetchedData)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                if (fetchedData[key].length > 0) {
                                    blocks.push({
                                        timestamp: key.split("t")[1],
                                        number: parseInt(fetchedData[key][0].number, 10)
                                    });
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // graphql-request does not guarantee same ordering of batched requests subqueries, hence manual sorting
                        return [
                            2,
                            orderBy_default()(blocks, function(block) {
                                return block.number;
                            }, sortDirection)
                        ];
                    }
                    return [
                        2,
                        blocks
                    ];
            }
        });
    });
    return function getBlocksFromTimestamps(timestamps) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/config/abi/IPancakeRouter02.json
var IPancakeRouter02_namespaceObject = JSON.parse('[{"inputs":[],"name":"WETH","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"amountADesired","type":"uint256"},{"internalType":"uint256","name":"amountBDesired","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountTokenDesired","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountIn","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountOut","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsIn","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsOut","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"reserveA","type":"uint256"},{"internalType":"uint256","name":"reserveB","type":"uint256"}],"name":"quote","outputs":[{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETHSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermit","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermitSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityWithPermit","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapETHForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETHSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"}]');
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(56797);
;// CONCATENATED MODULE: ./src/utils/exchange.ts







// converts a basis points value to a sdk percent
function basisPointsToPercent(num) {
    return new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(num), exchange/* BIPS_BASE */.PM);
}
function calculateSlippageAmount(value, slippage) {
    if (slippage < 0 || slippage > 10000) {
        throw Error("Unexpected slippage value: ".concat(slippage));
    }
    return [
        JSBI.divide(JSBI.multiply(value.quotient, JSBI.BigInt(10000 - slippage)), BIPS_BASE),
        JSBI.divide(JSBI.multiply(value.quotient, JSBI.BigInt(10000 + slippage)), BIPS_BASE), 
    ];
}
function useRouterContract() {
    var chainId = (0,useActiveChainId/* useActiveChainId */.gi)().chainId;
    return (0,useContract/* useContract */.cq)(exchange/* ROUTER_ADDRESS */.bR[chainId], IPancakeRouter02_namespaceObject, true);
}
// computes price breakdown for the trade
function computeTradePriceBreakdown(trade) {
    // for each hop in our trade, take away the x*y=k price impact from 0.3% fees
    // e.g. for 3 tokens/2 hops: 1 - ((1 - .03) * (1-.03))
    var realizedLPFee = !trade ? undefined : exchange/* ONE_HUNDRED_PERCENT.subtract */.yC.subtract(trade.route.pairs.reduce(function(currentFee) {
        return currentFee.multiply(exchange/* INPUT_FRACTION_AFTER_FEE */.Zw);
    }, exchange/* ONE_HUNDRED_PERCENT */.yC));
    // remove lp fees from price impact
    var priceImpactWithoutFeeFraction = trade && realizedLPFee ? trade.priceImpact.subtract(realizedLPFee) : undefined;
    // the x*y=k impact
    var priceImpactWithoutFeePercent = priceImpactWithoutFeeFraction ? new src/* Percent */.gG(priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.numerator, priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.denominator) : undefined;
    // the amount of the input that accrues to LPs
    var realizedLPFeeAmount = realizedLPFee && trade && src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(trade.inputAmount.currency, realizedLPFee.multiply(trade.inputAmount.quotient).quotient);
    return {
        priceImpactWithoutFee: priceImpactWithoutFeePercent,
        realizedLPFee: realizedLPFeeAmount
    };
}
// computes the minimum amount out and maximum amount in for a trade given a user specified allowed slippage in bips
function computeSlippageAdjustedAmounts(trade, allowedSlippage) {
    var pct = basisPointsToPercent(allowedSlippage);
    var _obj;
    return _obj = {}, (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, trade === null || trade === void 0 ? void 0 : trade.maximumAmountIn(pct)), (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, trade === null || trade === void 0 ? void 0 : trade.minimumAmountOut(pct)), _obj;
}
function warningSeverity(priceImpact) {
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* BLOCKED_PRICE_IMPACT_NON_EXPERT */.lN))) return 4;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_HIGH */.Uf))) return 3;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_MEDIUM */.p9))) return 2;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_LOW */.Bz))) return 1;
    return 0;
}
function formatExecutionPrice(trade, inverted) {
    if (!trade) {
        return "";
    }
    return inverted ? "".concat(trade.executionPrice.invert().toSignificant(6), " ").concat(trade.inputAmount.currency.symbol, " / ").concat(trade.outputAmount.currency.symbol) : "".concat(trade.executionPrice.toSignificant(6), " ").concat(trade.outputAmount.currency.symbol, " / ").concat(trade.inputAmount.currency.symbol);
}

// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 6 modules
var tokens_src = __webpack_require__(16219);
// EXTERNAL MODULE: ./src/utils/getLpAddress.ts
var utils_getLpAddress = __webpack_require__(80462);
;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/constants.ts
// BNB Address
var BNB_ADDRESS = "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c";


;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/utils.ts

var MIN_VALUE_DISPLAYED = 0.001;
var getTimeWindowChange = function(lineChartData) {
    if (lineChartData.length > 0) {
        var ref;
        var ref1;
        var firstValue = (ref1 = (ref = lineChartData.find(function(param) {
            var value = param.value;
            return !!value && value > 0;
        })) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : 0;
        var lastValue = lineChartData[lineChartData.length - 1].value;
        var changeValue = lastValue - firstValue;
        return {
            changeValue: changeValue > 0 ? Math.max(changeValue, MIN_VALUE_DISPLAYED) : Math.min(changeValue, MIN_VALUE_DISPLAYED * -1),
            changePercentage: (changeValue / firstValue * 100).toFixed(2)
        };
    }
    return {
        changeValue: 0,
        changePercentage: 0
    };
};
var getTokenAddress = function(tokenAddress) {
    if (!tokenAddress) {
        return "";
    }
    var lowerCaseAddress = tokenAddress.toLowerCase();
    if (lowerCaseAddress === "bnb") {
        return BNB_ADDRESS;
    }
    return lowerCaseAddress;
};

;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairDayId.ts

function lastPairDayId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairDayId($pairId: String) {\n    pairDayDatas(first: 1, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    lastPairDayId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairDayId = (0,graphql_request_dist.gql)(lastPairDayId_templateObject());
/* harmony default export */ var queries_lastPairDayId = (lastPairDayId);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatas.ts

function pairHourDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatas($pairId: String, $first: Int) {\n    pairHourDatas(first: $first, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatas = (0,graphql_request_dist.gql)(pairHourDatas_templateObject());
/* harmony default export */ var queries_pairHourDatas = (pairHourDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatasByIdsQuery.ts

function pairDayDatasByIdsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatasByIdsQuery($pairIds: [String]) {\n    pairDayDatas(where: { id_in: $pairIds }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatasByIdsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatasByIdsQuery = (0,graphql_request_dist.gql)(pairDayDatasByIdsQuery_templateObject());
/* harmony default export */ var queries_pairDayDatasByIdsQuery = (pairDayDatasByIdsQuery);

;// CONCATENATED MODULE: ./src/state/swap/types.ts
var types_PairDataTimeWindowEnum;
(function(PairDataTimeWindowEnum) {
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["DAY"] = 0] = "DAY";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["WEEK"] = 1] = "WEEK";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["MONTH"] = 2] = "MONTH";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["YEAR"] = 3] = "YEAR";
})(types_PairDataTimeWindowEnum || (types_PairDataTimeWindowEnum = {}));

;// CONCATENATED MODULE: ./src/state/swap/fetch/constants.ts


var _obj;
// Specifies the amount of data points to query for specific time window
var timeWindowIdsCountMapping = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.DAY, 24), (0,src_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.WEEK, 28), (0,src_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.MONTH, 30), (0,src_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.YEAR, 24), _obj);
var _obj1;
// How many StreamingFast ids to skip when querying the data
var timeWindowGapMapping = (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.DAY, null), (0,src_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.WEEK, 6), (0,src_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.MONTH, 1), (0,src_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.YEAR, 15), _obj1);

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
;// CONCATENATED MODULE: ./src/state/swap/fetch/utils.ts



var getPairSequentialId = function(param) {
    var id = param.id, pairId = param.pairId;
    return id.replace("".concat(pairId, "-"), "");
};
var getIdsByTimeWindow = function(param) {
    var pairAddress = param.pairAddress, pairLastId = param.pairLastId, timeWindow = param.timeWindow, idsCount = param.idsCount;
    var pairLastIdAsNumber = Number(pairLastId);
    if (timeWindow === types_PairDataTimeWindowEnum.DAY) {
        return [];
    }
    return times_default()(idsCount, function(value) {
        return "".concat(pairAddress, "-").concat(pairLastIdAsNumber - value * timeWindowGapMapping[timeWindow]);
    });
};
var utils_pairHasEnoughLiquidity = function(data, timeWindow) {
    var liquidityThreshold = 10000;
    switch(timeWindow){
        case PairDataTimeWindowEnum.DAY:
        case PairDataTimeWindowEnum.WEEK:
            {
                var ref, ref1;
                var ref2;
                var amountOfDataPoints = (ref2 = data === null || data === void 0 ? void 0 : (ref = data.pairHourDatas) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 1;
                var totalUSD = data === null || data === void 0 ? void 0 : (ref1 = data.pairHourDatas) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD / amountOfDataPoints > liquidityThreshold;
            }
        case PairDataTimeWindowEnum.MONTH:
        case PairDataTimeWindowEnum.YEAR:
            {
                var ref3, ref4;
                var ref5;
                var amountOfDataPoints1 = (ref5 = data === null || data === void 0 ? void 0 : (ref3 = data.pairDayDatas) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref5 !== void 0 ? ref5 : 1;
                var totalUSD1 = data === null || data === void 0 ? void 0 : (ref4 = data.pairDayDatas) === null || ref4 === void 0 ? void 0 : ref4.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD1 / amountOfDataPoints1 > liquidityThreshold;
            }
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatas.ts

function pairDayDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatas($pairId: String, $first: Int) {\n    pairDayDatas(first: $first, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatas = (0,graphql_request_dist.gql)(pairDayDatas_templateObject());
/* harmony default export */ var queries_pairDayDatas = (pairDayDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatasByIds.ts

function pairHourDatasByIds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatasByIds($pairIds: [String]) {\n    pairHourDatas(where: { id_in: $pairIds }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatasByIds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatasByIds = (0,graphql_request_dist.gql)(pairHourDatasByIds_templateObject());
/* harmony default export */ var queries_pairHourDatasByIds = (pairHourDatasByIds);

;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairHourId.ts

function lastPairHourId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairHourId($pairId: String) {\n    pairHourDatas(first: 1, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    lastPairHourId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairHourId = (0,graphql_request_dist.gql)(lastPairHourId_templateObject());
/* harmony default export */ var queries_lastPairHourId = (lastPairHourId);

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchPairPriceData.ts













var fetchPairPriceData_fetchPairPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var pairId, timeWindow, client, data, ref, lastPairHourIdData, lastId, pairHourId, pairHourIds, pairHoursData, data1, ref1, lastPairDayIdData, lastId1, pairLastId, pairDayIds, pairDayData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pairId = param.pairId, timeWindow = param.timeWindow;
                    client = infoClient;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        14,
                        ,
                        15
                    ]);
                    switch(timeWindow){
                        case types_PairDataTimeWindowEnum.DAY:
                            return [
                                3,
                                2
                            ];
                        case types_PairDataTimeWindowEnum.WEEK:
                            return [
                                3,
                                4
                            ];
                        case types_PairDataTimeWindowEnum.MONTH:
                            return [
                                3,
                                7
                            ];
                        case types_PairDataTimeWindowEnum.YEAR:
                            return [
                                3,
                                9
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairHourDatas, {
                            pairId: pairId,
                            first: timeWindowIdsCountMapping[timeWindow]
                        })
                    ];
                case 3:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 4:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_lastPairHourId, {
                            pairId: pairId
                        })
                    ];
                case 5:
                    lastPairHourIdData = _state.sent();
                    lastId = (lastPairHourIdData === null || lastPairHourIdData === void 0 ? void 0 : lastPairHourIdData.pairHourDatas) ? (ref = lastPairHourIdData.pairHourDatas[0]) === null || ref === void 0 ? void 0 : ref.id : null;
                    if (!lastId) {
                        return [
                            2,
                            {
                                data: {
                                    pairHourDatas: []
                                },
                                error: false
                            }
                        ];
                    }
                    pairHourId = getPairSequentialId({
                        id: lastId,
                        pairId: pairId
                    });
                    pairHourIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairHourId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairHourDatasByIds, {
                            pairIds: pairHourIds
                        })
                    ];
                case 6:
                    pairHoursData = _state.sent();
                    return [
                        2,
                        {
                            data: pairHoursData,
                            error: false
                        }
                    ];
                case 7:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairDayDatas, {
                            pairId: pairId,
                            first: timeWindowIdsCountMapping[timeWindow]
                        })
                    ];
                case 8:
                    data1 = _state.sent();
                    return [
                        2,
                        {
                            data: data1,
                            error: false
                        }
                    ];
                case 9:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_lastPairDayId, {
                            pairId: pairId
                        })
                    ];
                case 10:
                    lastPairDayIdData = _state.sent();
                    lastId1 = (lastPairDayIdData === null || lastPairDayIdData === void 0 ? void 0 : lastPairDayIdData.pairDayDatas) ? (ref1 = lastPairDayIdData.pairDayDatas[0]) === null || ref1 === void 0 ? void 0 : ref1.id : null;
                    if (!lastId1) {
                        return [
                            2,
                            {
                                data: {
                                    pairDayDatas: []
                                },
                                error: false
                            }
                        ];
                    }
                    pairLastId = getPairSequentialId({
                        id: lastId1,
                        pairId: pairId
                    });
                    pairDayIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairLastId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairDayDatasByIdsQuery, {
                            pairIds: pairDayIds
                        })
                    ];
                case 11:
                    pairDayData = _state.sent();
                    return [
                        2,
                        {
                            data: pairDayData,
                            error: false
                        }
                    ];
                case 12:
                    return [
                        2,
                        {
                            data: null,
                            error: false
                        }
                    ];
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    error = _state.sent();
                    console.error("Failed to fetch price chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPairPriceData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchPairPriceData = ((/* unused pure expression or super */ null && (fetchPairPriceData_fetchPairPriceData)));

// EXTERNAL MODULE: ./node_modules/lodash/fromPairs.js
var lodash_fromPairs = __webpack_require__(17204);
;// CONCATENATED MODULE: ./src/state/swap/normalizers.ts



var normalizers_normalizeChartData = function(data, timeWindow) {
    switch(timeWindow){
        case PairDataTimeWindowEnum.DAY:
        case PairDataTimeWindowEnum.WEEK:
            var ref;
            return data === null || data === void 0 ? void 0 : (ref = data.pairHourDatas) === null || ref === void 0 ? void 0 : ref.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.hourStartUnix,
                    token0Id: fetchPairEntry.pair.token0.id,
                    token1Id: fetchPairEntry.pair.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        case PairDataTimeWindowEnum.MONTH:
        case PairDataTimeWindowEnum.YEAR:
            var ref1;
            return data === null || data === void 0 ? void 0 : (ref1 = data.pairDayDatas) === null || ref1 === void 0 ? void 0 : ref1.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.date,
                    token0Id: fetchPairEntry.pairAddress.token0.id,
                    token1Id: fetchPairEntry.pairAddress.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        default:
            return null;
    }
};
var normalizers_normalizeDerivedChartData = function(data) {
    var ref;
    if (!(data === null || data === void 0 ? void 0 : data.token0DerivedBnb) || (data === null || data === void 0 ? void 0 : data.token0DerivedBnb.length) === 0) {
        return [];
    }
    var ref1;
    var token1DerivedBnbEntryMap = fromPairs((ref1 = data === null || data === void 0 ? void 0 : (ref = data.token1DerivedBnb) === null || ref === void 0 ? void 0 : ref.map(function(entry) {
        return [
            entry.timestamp,
            entry
        ];
    })) !== null && ref1 !== void 0 ? ref1 : []);
    return data === null || data === void 0 ? void 0 : data.token0DerivedBnb.reduce(function(acc, token0DerivedBnbEntry) {
        var token1DerivedBnbEntry = token1DerivedBnbEntryMap[token0DerivedBnbEntry.timestamp];
        if (token1DerivedBnbEntry) {
            acc.push({
                time: parseInt(token0DerivedBnbEntry.timestamp, 10),
                token0Id: token0DerivedBnbEntry.tokenAddress,
                token1Id: token1DerivedBnbEntry.tokenAddress,
                token0DerivedBNB: token0DerivedBnbEntry.derivedBNB,
                token1DerivedBNB: token1DerivedBnbEntry.derivedBNB
            });
        }
        return acc;
    }, []);
};
var normalizers_normalizePairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: fromUnixTime(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.reserve1 / pairPrice.reserve0 : pairPrice.reserve0 / pairPrice.reserve1
        };
    }).reverse();
};
var normalizers_normalizeDerivedPairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: fromUnixTime(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.token0DerivedBNB / pairPrice.token1DerivedBNB : pairPrice.token1DerivedBNB / pairPrice.token0DerivedBNB
        };
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var lodash_get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
;// CONCATENATED MODULE: ./src/state/swap/selectors.ts

var selectors_pairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get(state, [
            "swap",
            "pairDataById",
            pairId,
            timeWindow
        ]);
    };
};
var selectors_derivedPairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get(state, [
            "swap",
            "derivedPairDataById",
            pairId,
            timeWindow
        ]);
    };
};

;// CONCATENATED MODULE: ./src/config/constants/info.ts
var MINIMUM_SEARCH_CHARACTERS = 2;
var WEEKS_IN_YEAR = 52.1429;
var TOTAL_FEE = 0.0025;
var LP_HOLDERS_FEE = 0.0017;
var TREASURY_FEE = 0.000225;
var BUYBACK_FEE = 0.000575;
var PCS_V2_START = 1619136000 // April 23, 2021, 12:00:00 AM
;
var ONE_DAY_UNIX = 86400 // 24h * 60m * 60s
;
var ONE_HOUR_SECONDS = 3600;
var ITEMS_PER_INFO_TABLE_PAGE = 10;
// These tokens are either incorrectly priced or have some other issues that spoil the query data
// None of them present any interest as they have almost 0 daily trade volume
var TOKEN_BLACKLIST = (/* unused pure expression or super */ null && ([
    // These ones are copied from v1 info
    "0x495c7f3a713870f68f8b418b355c085dfdc412c3",
    "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
    "0xe31debd7abff90b06bca21010dd860d8701fd901",
    "0xfc989fbb6b3024de5ca0144dc23c18a063942ac1",
    "0xe40fc6ff5f2895b44268fd2e1a421e07f567e007",
    "0xfd158609228b43aa380140b46fff3cdf9ad315de",
    "0xc00af6212fcf0e6fd3143e692ccd4191dc308bea",
    "0x205969b3ad459f7eba0dee07231a6357183d3fb6",
    "0x0bd67d358636fd7b0597724aa4f20beedbf3073a",
    "0xedf5d2a561e8a3cb5a846fbce24d2ccd88f50075",
    "0x702b0789a3d4dade1688a0c8b7d944e5ba80fc30",
    "0x041929a760d7049edaef0db246fa76ec975e90cc",
    "0xba098df8c6409669f5e6ec971ac02cd5982ac108",
    "0x1bbed115afe9e8d6e9255f18ef10d43ce6608d94",
    "0xe99512305bf42745fae78003428dcaf662afb35d",
    "0xbE609EAcbFca10F6E5504D39E3B113F808389056",
    "0x847daf9dfdc22d5c61c4a857ec8733ef5950e82e",
    "0xdbf8913dfe14536c0dae5dd06805afb2731f7e7b",
    // These ones are newly found
    "0xF1D50dB2C40b63D2c598e2A808d1871a40b1E653",
    "0x4269e4090ff9dfc99d8846eb0d42e67f01c3ac8b", 
]));

// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js + 1 modules
var getUnixTime = __webpack_require__(28401);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfHour/index.js
var startOfHour = __webpack_require__(12383);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js + 5 modules
var sub = __webpack_require__(39370);
;// CONCATENATED MODULE: ./src/state/swap/queries/getDerivedPrices.ts

function getDerivedPrices_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query derivedTokenPriceData {\n        ",
        "\n      }\n    "
    ]);
    getDerivedPrices_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getDerivedPrices = function(tokenAddress, blocks) {
    return blocks.map(function(block) {
        return "\n    t".concat(block.timestamp, ':token(id:"').concat(tokenAddress, '", block: { number: ').concat(block.number, " }) { \n        derivedBNB\n      }\n    ");
    });
};
var getDerivedPricesQueryConstructor = function(subqueries) {
    return (0,graphql_request_dist.gql)(getDerivedPrices_templateObject(), subqueries);
};

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchDerivedPriceData.ts











var getTokenDerivedBnbPrices = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(tokenAddress, blocks) {
        var prices, tokenPrices;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        multiQuery(getDerivedPricesQueryConstructor, getDerivedPrices(tokenAddress, blocks), endpoints/* INFO_CLIENT */.JY, 200)
                    ];
                case 1:
                    prices = _state.sent();
                    if (!prices) {
                        console.error("Price data failed to load");
                        return [
                            2,
                            null
                        ];
                    }
                    tokenPrices = [];
                    // Get Token prices in BNB
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("t")[1];
                        if (timestamp) {
                            var ref;
                            tokenPrices.push({
                                tokenAddress: tokenAddress,
                                timestamp: timestamp,
                                derivedBNB: ((ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref.derivedBNB) ? parseFloat(prices[priceKey].derivedBNB) : 0
                            });
                        }
                    });
                    return [
                        2,
                        orderBy_default()(tokenPrices, function(tokenPrice) {
                            return parseInt(tokenPrice.timestamp, 10);
                        })
                    ];
            }
        });
    });
    return function getTokenDerivedBnbPrices(tokenAddress, blocks) {
        return _ref.apply(this, arguments);
    };
}();
var getInterval = function(timeWindow) {
    switch(timeWindow){
        case types_PairDataTimeWindowEnum.DAY:
            return ONE_HOUR_SECONDS;
        case types_PairDataTimeWindowEnum.WEEK:
            return ONE_HOUR_SECONDS * 4;
        case types_PairDataTimeWindowEnum.MONTH:
            return ONE_DAY_UNIX;
        case types_PairDataTimeWindowEnum.YEAR:
            return ONE_DAY_UNIX * 15;
        default:
            return ONE_HOUR_SECONDS * 4;
    }
};
var getSkipDaysToStart = function(timeWindow) {
    switch(timeWindow){
        case types_PairDataTimeWindowEnum.DAY:
            return 1;
        case types_PairDataTimeWindowEnum.WEEK:
            return 7;
        case types_PairDataTimeWindowEnum.MONTH:
            return 30;
        case types_PairDataTimeWindowEnum.YEAR:
            return 365;
        default:
            return 7;
    }
};
// Fetches derivedBnb values for tokens to calculate derived price
// Used when no direct pool is available
var fetchDerivedPriceData_fetchDerivedPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(token0Address, token1Address, timeWindow) {
        var interval, endTimestamp, startTimestamp, timestamps, time, blocks, ref, token0DerivedBnb, token1DerivedBnb, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    interval = getInterval(timeWindow);
                    endTimestamp = (0,getUnixTime/* default */.Z)(new Date());
                    startTimestamp = (0,getUnixTime/* default */.Z)((0,startOfHour/* default */.Z)((0,sub/* default */.Z)(endTimestamp * 1000, {
                        days: getSkipDaysToStart(timeWindow)
                    })));
                    timestamps = [];
                    time = startTimestamp;
                    while(time <= endTimestamp){
                        timestamps.push(time);
                        time += interval;
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        getBlocksFromTimestamps_getBlocksFromTimestamps(timestamps, "asc", 500)
                    ];
                case 2:
                    blocks = _state.sent();
                    if (!blocks || blocks.length === 0) {
                        console.error("Error fetching blocks for timestamps", timestamps);
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        Promise.all([
                            getTokenDerivedBnbPrices(token0Address, blocks),
                            getTokenDerivedBnbPrices(token1Address, blocks)
                        ])
                    ];
                case 3:
                    ref = src_sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), token0DerivedBnb = ref[0], token1DerivedBnb = ref[1];
                    return [
                        2,
                        {
                            token0DerivedBnb: token0DerivedBnb,
                            token1DerivedBnb: token1DerivedBnb
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetched derived price data for chart", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDerivedPriceData(token0Address, token1Address, timeWindow) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchDerivedPriceData = ((/* unused pure expression or super */ null && (fetchDerivedPriceData_fetchDerivedPriceData)));

;// CONCATENATED MODULE: ./src/views/Info/hooks/useBlocksFromTimestamps.ts




/**
 * for a given array of timestamps, returns block entities
 * @param timestamps
 * @param sortDirection
 * @param skipCount
 */ var useBlocksFromTimestamps_useBlocksFromTimestamps = function(timestamps) {
    var sortDirection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "desc", skipCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    var ref = useState(), blocks = ref[0], setBlocks = ref[1];
    var ref1 = useState(false), error = ref1[0], setError = ref1[1];
    var timestampsString = JSON.stringify(timestamps);
    var blocksString = blocks ? JSON.stringify(blocks) : undefined;
    useEffect(function() {
        var fetchData = function() {
            var _ref = _async_to_generator(function() {
                var timestampsArray, result;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            timestampsArray = JSON.parse(timestampsString);
                            return [
                                4,
                                getBlocksFromTimestamps(timestampsArray, sortDirection, skipCount)
                            ];
                        case 1:
                            result = _state.sent();
                            if (result.length === 0) {
                                setError(true);
                            } else {
                                setBlocks(result);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        var blocksArray = blocksString ? JSON.parse(blocksString) : undefined;
        if (!blocksArray && !error) {
            fetchData();
        }
    }, [
        blocksString,
        error,
        skipCount,
        sortDirection,
        timestampsString
    ]);
    return {
        blocks: blocks,
        error: error
    };
};

;// CONCATENATED MODULE: ./src/state/info/queries/pools/poolData.ts
/* eslint-disable no-param-reassign */ 





function poolData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query pools {\n        now: ",
        "\n        oneDayAgo: ",
        "\n        twoDaysAgo: ",
        "\n        oneWeekAgo: ",
        "\n        twoWeeksAgo: ",
        "\n      }\n    "
    ]);
    poolData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 * Data for displaying pool tables (on multiple pages, used throughout the site)
 * Note: Don't try to refactor it to use variables, server throws error if blocks passed as undefined variable
 * only works if its hard-coded into query string
 */ var POOL_AT_BLOCK = function(block, pools) {
    var blockString = block ? "block: {number: ".concat(block, "}") : "";
    var addressesString = '["'.concat(pools.join('","'), '"]');
    return "pairs(\n    where: { id_in: ".concat(addressesString, " }\n    ").concat(blockString, "\n    orderBy: trackedReserveBNB\n    orderDirection: desc\n  ) {\n    id\n    reserve0\n    reserve1\n    reserveUSD\n    volumeUSD\n    token0Price\n    token1Price\n    token0 {\n      id\n      symbol\n      name\n    }\n    token1 {\n      id\n      symbol\n      name\n    }\n  }");
};
var poolData_fetchPoolData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(block24h, block48h, block7d, block14d, poolAddresses) {
        var query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = (0,graphql_request_dist.gql)(poolData_templateObject(), POOL_AT_BLOCK(null, poolAddresses), POOL_AT_BLOCK(block24h, poolAddresses), POOL_AT_BLOCK(block48h, poolAddresses), POOL_AT_BLOCK(block7d, poolAddresses), POOL_AT_BLOCK(block14d, poolAddresses));
                    return [
                        4,
                        infoClient.request(query)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch pool data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPoolData(block24h, block48h, block7d, block14d, poolAddresses) {
        return _ref.apply(this, arguments);
    };
}();
// Transforms pools into "0xADDRESS: { ...PoolFields }" format and cast strings to numbers
var poolData_parsePoolData = function(pairs) {
    if (!pairs) {
        return {};
    }
    return pairs.reduce(function(accum, poolData) {
        var volumeUSD = poolData.volumeUSD, reserveUSD = poolData.reserveUSD, reserve0 = poolData.reserve0, reserve1 = poolData.reserve1, token0Price = poolData.token0Price, token1Price = poolData.token1Price;
        accum[poolData.id] = _object_spread_props(_object_spread({}, poolData), {
            volumeUSD: parseFloat(volumeUSD),
            reserveUSD: parseFloat(reserveUSD),
            reserve0: parseFloat(reserve0),
            reserve1: parseFloat(reserve1),
            token0Price: parseFloat(token0Price),
            token1Price: parseFloat(token1Price)
        });
        return accum;
    }, {});
};
/**
 * Fetch top pools by liquidity
 */ var usePoolDatas = function(poolAddresses) {
    var ref = useState({
        error: false
    }), fetchState = ref[0], setFetchState = ref[1];
    var ref1 = _sliced_to_array(getDeltaTimestamps(), 4), t24h = ref1[0], t48h = ref1[1], t7d = ref1[2], t14d = ref1[3];
    var ref2 = useBlocksFromTimestamps([
        t24h,
        t48h,
        t7d,
        t14d
    ]), blocks = ref2.blocks, blockError = ref2.error;
    var ref3 = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref3[0], block48h = ref3[1], block7d = ref3[2], block14d = ref3[3];
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var ref, error, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, formatted;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                poolData_fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, poolAddresses)
                            ];
                        case 1:
                            ref = _state.sent(), error = ref.error, data = ref.data;
                            if (error) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                formattedPoolData = poolData_parsePoolData(data === null || data === void 0 ? void 0 : data.now);
                                formattedPoolData24h = poolData_parsePoolData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                                formattedPoolData48h = poolData_parsePoolData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                                formattedPoolData7d = poolData_parsePoolData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                                formattedPoolData14d = poolData_parsePoolData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                                formatted = poolAddresses.reduce(function(accum, address) {
                                    // Undefined data is possible if pool is brand new and didn't exist one day ago or week ago.
                                    var current = formattedPoolData[address];
                                    var oneDay = formattedPoolData24h[address];
                                    var twoDays = formattedPoolData48h[address];
                                    var week = formattedPoolData7d[address];
                                    var twoWeeks = formattedPoolData14d[address];
                                    var ref = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 2), volumeUSD = ref[0], volumeUSDChange = ref[1];
                                    var ref1 = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 2), volumeUSDWeek = ref1[0], volumeUSDChangeWeek = ref1[1];
                                    var liquidityUSD = current ? current.reserveUSD : 0;
                                    var liquidityUSDChange = getPercentChange(current === null || current === void 0 ? void 0 : current.reserveUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.reserveUSD);
                                    var liquidityToken0 = current ? current.reserve0 : 0;
                                    var liquidityToken1 = current ? current.reserve1 : 0;
                                    var ref2 = getLpFeesAndApr(volumeUSD, volumeUSDWeek, liquidityUSD), totalFees24h = ref2.totalFees24h, totalFees7d = ref2.totalFees7d, lpFees24h = ref2.lpFees24h, lpFees7d = ref2.lpFees7d, lpApr7d = ref2.lpApr7d;
                                    if (current) {
                                        accum[address] = {
                                            address: address,
                                            token0: {
                                                address: current.token0.id,
                                                name: current.token0.name,
                                                symbol: current.token0.symbol
                                            },
                                            token1: {
                                                address: current.token1.id,
                                                name: current.token1.name,
                                                symbol: current.token1.symbol
                                            },
                                            token0Price: current.token0Price,
                                            token1Price: current.token1Price,
                                            volumeUSD: volumeUSD,
                                            volumeUSDChange: volumeUSDChange,
                                            volumeUSDWeek: volumeUSDWeek,
                                            volumeUSDChangeWeek: volumeUSDChangeWeek,
                                            totalFees24h: totalFees24h,
                                            totalFees7d: totalFees7d,
                                            lpFees24h: lpFees24h,
                                            lpFees7d: lpFees7d,
                                            lpApr7d: lpApr7d,
                                            liquidityUSD: liquidityUSD,
                                            liquidityUSDChange: liquidityUSDChange,
                                            liquidityToken0: liquidityToken0,
                                            liquidityToken1: liquidityToken1
                                        };
                                    }
                                    return accum;
                                }, {});
                                setFetchState({
                                    data: formatted,
                                    error: false
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24h === null || block24h === void 0 ? void 0 : block24h.number) && (block48h === null || block48h === void 0 ? void 0 : block48h.number) && (block7d === null || block7d === void 0 ? void 0 : block7d.number) && (block14d === null || block14d === void 0 ? void 0 : block14d.number);
        if (poolAddresses.length > 0 && allBlocksAvailable && !blockError) {
            fetch();
        }
    }, [
        poolAddresses,
        block24h,
        block48h,
        block7d,
        block14d,
        blockError
    ]);
    return fetchState;
};
/* harmony default export */ var poolData = ((/* unused pure expression or super */ null && (usePoolDatas)));

;// CONCATENATED MODULE: ./src/state/swap/hooks.ts





































function useSwapState() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.swap;
    });
}
// TODO: update
var BAD_RECIPIENT_ADDRESSES = [
    "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
    "0xf164fC0Ec4E93095b804a4795bBe1e041497b92a",
    "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D"
];
/**
 * Returns true if any of the pairs or tokens in a trade have the given checksummed address
 * @param trade to check for the given address
 * @param checksummedAddress address to check in the pairs and tokens
 */ function involvesAddress(trade, checksummedAddress) {
    return trade.route.path.some(function(token) {
        return token.address === checksummedAddress;
    }) || trade.route.pairs.some(function(pair) {
        return pair.liquidityToken.address === checksummedAddress;
    });
}
// Get swap price for single token disregarding slippage and price impact
function useSingleTokenSwapInfo(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency) {
    var ref;
    var token0Address = getTokenAddress(inputCurrencyId);
    var token1Address = getTokenAddress(outputCurrencyId);
    var parsedAmount = utils_tryParseAmount("1", inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
    var bestTradeExactIn = Trades_useTradeExactIn(parsedAmount, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    if (!inputCurrency || !outputCurrency || !bestTradeExactIn) {
        return null;
    }
    var inputTokenPrice = parseFloat(bestTradeExactIn === null || bestTradeExactIn === void 0 ? void 0 : (ref = bestTradeExactIn.executionPrice) === null || ref === void 0 ? void 0 : ref.toSignificant(6));
    var outputTokenPrice = 1 / inputTokenPrice;
    var _obj;
    return _obj = {}, (0,src_define_property/* default */.Z)(_obj, token0Address, inputTokenPrice), (0,src_define_property/* default */.Z)(_obj, token1Address, outputTokenPrice), _obj;
}
// from the current swap inputs, compute the best trade and return it.
function useDerivedSwapInfo(independentField, typedValue, inputCurrency, outputCurrency, recipient) {
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref;
    var to = (ref = recipient === null ? account : (0,utils/* isAddress */.UJ)(recipient) || null) !== null && ref !== void 0 ? ref : null;
    var relevantTokenBalances = hooks_useCurrencyBalances(account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, 
    ]);
    var isExactIn = independentField === swap_actions/* Field.INPUT */.gN.INPUT;
    var ref1;
    var parsedAmount = utils_tryParseAmount(typedValue, (ref1 = isExactIn ? inputCurrency : outputCurrency) !== null && ref1 !== void 0 ? ref1 : undefined);
    var bestTradeExactIn = Trades_useTradeExactIn(isExactIn ? parsedAmount : undefined, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    var bestTradeExactOut = Trades_useTradeExactOut(inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined, !isExactIn ? parsedAmount : undefined);
    var v2Trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    var _obj;
    var currencyBalances = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, relevantTokenBalances[0]), (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, relevantTokenBalances[1]), _obj);
    var _obj1;
    var currencies = (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, swap_actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,src_define_property/* default */.Z)(_obj1, swap_actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj1);
    var inputError;
    if (!account) {
        inputError = t("Connect Wallet");
    }
    if (!parsedAmount) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter an amount");
    }
    if (!currencies[swap_actions/* Field.INPUT */.gN.INPUT] || !currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Select a token");
    }
    var formattedTo = (0,utils/* isAddress */.UJ)(to);
    if (!to || !formattedTo) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter a recipient");
    } else if (BAD_RECIPIENT_ADDRESSES.indexOf(formattedTo) !== -1 || bestTradeExactIn && involvesAddress(bestTradeExactIn, formattedTo) || bestTradeExactOut && involvesAddress(bestTradeExactOut, formattedTo)) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Invalid recipient");
    }
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref2[0];
    var slippageAdjustedAmounts = v2Trade && allowedSlippage && computeSlippageAdjustedAmounts(v2Trade, allowedSlippage);
    // compare input balance to max input based on version
    var ref3 = [
        currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT],
        slippageAdjustedAmounts ? slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT] : null, 
    ], balanceIn = ref3[0], amountIn = ref3[1];
    if (balanceIn && amountIn && balanceIn.lessThan(amountIn)) {
        inputError = t("Insufficient %symbol% balance", {
            symbol: amountIn.currency.symbol
        });
    }
    return {
        currencies: currencies,
        currencyBalances: currencyBalances,
        parsedAmount: parsedAmount,
        v2Trade: v2Trade !== null && v2Trade !== void 0 ? v2Trade : undefined,
        inputError: inputError
    };
}
function hooks_parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === "string") {
        var valid = (0,utils/* isAddress */.UJ)(urlParam);
        if (valid) return valid;
        if (urlParam.toUpperCase() === "BNB") return "BNB";
        if (valid === false) return "BNB";
    }
    return "";
}
function hooks_parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function hooks_parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? swap_actions/* Field.OUTPUT */.gN.OUTPUT : swap_actions/* Field.INPUT */.gN.INPUT;
}
var ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
function validatedRecipient(recipient) {
    if (typeof recipient !== "string") return null;
    var address = (0,utils/* isAddress */.UJ)(recipient);
    if (address) return address;
    if (ADDRESS_REGEX.test(recipient)) return recipient;
    return null;
}
function hooks_queryParametersToSwapState(parsedQs, nativeSymbol, defaultOutputCurrency) {
    var inputCurrency = hooks_parseCurrencyFromURLParameter(parsedQs.inputCurrency) || (nativeSymbol !== null && nativeSymbol !== void 0 ? nativeSymbol : exchange/* DEFAULT_INPUT_CURRENCY */.VN);
    var outputCurrency = hooks_parseCurrencyFromURLParameter(parsedQs.outputCurrency) || (defaultOutputCurrency !== null && defaultOutputCurrency !== void 0 ? defaultOutputCurrency : exchange/* DEFAULT_OUTPUT_CURRENCY */.g$);
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var recipient = validatedRecipient(parsedQs.recipient);
    var _obj;
    return _obj = {}, (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, {
        currencyId: inputCurrency
    }), (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, {
        currencyId: outputCurrency
    }), (0,src_define_property/* default */.Z)(_obj, "typedValue", hooks_parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,src_define_property/* default */.Z)(_obj, "independentField", hooks_parseIndependentFieldURLParameter(parsedQs.exactField)), (0,src_define_property/* default */.Z)(_obj, "recipient", recipient), (0,src_define_property/* default */.Z)(_obj, "pairDataById", {}), (0,src_define_property/* default */.Z)(_obj, "derivedPairDataById", {}), _obj;
}
// updates the swap state to use the defaults for a given network
function hooks_useDefaultsFromURLSearch() {
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var native = (0,useNativeCurrency/* default */.Z)();
    var query = (0,next_router.useRouter)().query;
    var ref = (0,react.useState)(), result = ref[0], setResult = ref[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!chainId || !native) return;
        var ref2;
        var parsed = hooks_queryParametersToSwapState(query, native.symbol, (ref2 = (ref = tokens_src/* CAKE */.cr[chainId]) === null || ref === void 0 ? void 0 : ref.address) !== null && ref2 !== void 0 ? ref2 : (ref1 = tokens_src/* USDC */.gn[chainId]) === null || ref1 === void 0 ? void 0 : ref1.address);
        dispatch((0,swap_actions/* replaceSwapState */.mV)({
            typedValue: parsed.typedValue,
            field: parsed.independentField,
            inputCurrencyId: parsed[swap_actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[swap_actions/* Field.OUTPUT */.gN.OUTPUT].currencyId,
            recipient: null
        }));
        setResult({
            inputCurrencyId: parsed[swap_actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[swap_actions/* Field.OUTPUT */.gN.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query,
        native
    ]);
    return result;
}
var useFetchPairPrices = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, timeWindow = param.timeWindow, currentSwapPrice = param.currentSwapPrice;
    var ref = useState(null), pairId = ref[0], setPairId = ref[1];
    var ref1 = useState(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var pairData = useSelector(pairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var derivedPairData = useSelector(derivedPairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var dispatch = useDispatch();
    useEffect(function() {
        var fetchDerivedData = function() {
            var _ref = _async_to_generator(function() {
                var derivedData, normalizedDerivedData, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.info("[Price Chart]: Not possible to retrieve price data from single pool, trying to fetch derived prices");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                fetchDerivedPriceData(token0Address, token1Address, timeWindow)
                            ];
                        case 2:
                            derivedData = _state.sent();
                            if (derivedData) {
                                normalizedDerivedData = normalizeDerivedChartData(derivedData);
                                dispatch(updateDerivedPairData({
                                    pairData: normalizedDerivedData,
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            } else {
                                dispatch(updateDerivedPairData({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            }
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Failed to fetch derived prices for chart", error);
                            dispatch(updateDerivedPairData({
                                pairData: [],
                                pairId: pairId,
                                timeWindow: timeWindow
                            }));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchDerivedData() {
                return _ref.apply(this, arguments);
            };
        }();
        var fetchAndUpdatePairPrice = function() {
            var _ref = _async_to_generator(function() {
                var data, hasEnoughLiquidity, newPairData;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            return [
                                4,
                                fetchPairPriceData({
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) {
                                hasEnoughLiquidity = pairHasEnoughLiquidity(data, timeWindow);
                                newPairData = normalizeChartData(data, timeWindow) || [];
                                if (newPairData.length > 0 && hasEnoughLiquidity) {
                                    dispatch(updatePairData({
                                        pairData: newPairData,
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    setIsLoading(false);
                                } else {
                                    console.info("[Price Chart]: Liquidity too low for ".concat(pairId));
                                    dispatch(updatePairData({
                                        pairData: [],
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    fetchDerivedData();
                                }
                            } else {
                                dispatch(updatePairData({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                                fetchDerivedData();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAndUpdatePairPrice() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!pairData && !derivedPairData && pairId && !isLoading) {
            fetchAndUpdatePairPrice();
        }
    }, [
        pairId,
        timeWindow,
        pairData,
        currentSwapPrice,
        token0Address,
        token1Address,
        derivedPairData,
        dispatch,
        isLoading, 
    ]);
    useEffect(function() {
        var updatePairId = function() {
            try {
                var ref;
                var pairAddress = (ref = getLpAddress(token0Address, token1Address)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                if (pairAddress !== pairId) {
                    setPairId(pairAddress);
                }
            } catch (error) {
                setPairId(null);
            }
        };
        updatePairId();
    }, [
        token0Address,
        token1Address,
        pairId
    ]);
    var normalizedPairData = useMemo(function() {
        return normalizePairDataByActiveToken({
            activeToken: token0Address,
            pairData: pairData
        });
    }, [
        token0Address,
        pairData
    ]);
    var normalizedDerivedPairData = useMemo(function() {
        return normalizeDerivedPairDataByActiveToken({
            activeToken: token0Address,
            pairData: derivedPairData
        });
    }, [
        token0Address,
        derivedPairData
    ]);
    var hasSwapPrice = currentSwapPrice && currentSwapPrice[token0Address] > 0;
    var normalizedPairDataWithCurrentSwapPrice = (normalizedPairData === null || normalizedPairData === void 0 ? void 0 : normalizedPairData.length) > 0 && hasSwapPrice ? _to_consumable_array(normalizedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedPairData;
    var normalizedDerivedPairDataWithCurrentSwapPrice = (normalizedDerivedPairData === null || normalizedDerivedPairData === void 0 ? void 0 : normalizedDerivedPairData.length) > 0 && hasSwapPrice ? _to_consumable_array(normalizedDerivedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedDerivedPairData;
    var hasNoDirectData = normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) === 0;
    var hasNoDerivedData = normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) === 0;
    // undefined is used for loading
    var pairPrices = hasNoDirectData && hasNoDerivedData ? [] : undefined;
    if (normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedPairDataWithCurrentSwapPrice;
    } else if (normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedDerivedPairDataWithCurrentSwapPrice;
    }
    return {
        pairPrices: pairPrices,
        pairId: pairId
    };
};
var useLPApr = function(pair) {
    var ref = useSWRImmutable(pair && pair.chainId === ChainId.BSC ? [
        "LP7dApr",
        pair.liquidityToken.address
    ] : null, /*#__PURE__*/ _async_to_generator(function() {
        var timestampsArray, blocks, ref, block24h, block48h, block7d, block14d, ref1, error, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, current, oneDay, twoDays, week, twoWeeks, ref2, volumeUSD, ref3, volumeUSDWeek, liquidityUSD, lpApr7d;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    timestampsArray = getDeltaTimestamps();
                    return [
                        4,
                        getBlocksFromTimestamps(timestampsArray, "desc", 1000)
                    ];
                case 1:
                    blocks = _state.sent();
                    ref = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref[0], block48h = ref[1], block7d = ref[2], block14d = ref[3];
                    return [
                        4,
                        fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, [
                            pair.liquidityToken.address.toLowerCase()
                        ])
                    ];
                case 2:
                    ref1 = _state.sent(), error = ref1.error, data = ref1.data;
                    if (error) return [
                        2,
                        null
                    ];
                    formattedPoolData = parsePoolData(data === null || data === void 0 ? void 0 : data.now);
                    formattedPoolData24h = parsePoolData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                    formattedPoolData48h = parsePoolData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                    formattedPoolData7d = parsePoolData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                    formattedPoolData14d = parsePoolData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                    current = formattedPoolData[pair.liquidityToken.address.toLowerCase()];
                    oneDay = formattedPoolData24h[pair.liquidityToken.address.toLowerCase()];
                    twoDays = formattedPoolData48h[pair.liquidityToken.address.toLowerCase()];
                    week = formattedPoolData7d[pair.liquidityToken.address.toLowerCase()];
                    twoWeeks = formattedPoolData14d[pair.liquidityToken.address.toLowerCase()];
                    ref2 = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 1), volumeUSD = ref2[0];
                    ref3 = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 1), volumeUSDWeek = ref3[0];
                    liquidityUSD = current ? current.reserveUSD : 0;
                    lpApr7d = getLpFeesAndApr(volumeUSD, volumeUSDWeek, liquidityUSD).lpApr7d;
                    return [
                        2,
                        lpApr7d ? {
                            lpApr7d: lpApr7d
                        } : null
                    ];
            }
        });
    }), {
        refreshInterval: SLOW_INTERVAL
    }), poolData = ref.data;
    return poolData;
};

;// CONCATENATED MODULE: ./src/components/Menu/Footer.tsx

function Footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: center;\n  padding-top: 16px;\n  padding-right: ",
        ";\n  ",
        " {\n    justify-content: space-between;\n    flex-direction: ",
        ";\n  }\n"
    ]);
    Footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    fill: ",
        ";\n    transition: background-color 0.2s, opacity 0.2s;\n  }\n  &:hover {\n    svg {\n      opacity: 0.65;\n    }\n  }\n  &:active {\n    svg {\n      opacity: 0.85;\n    }\n  }\n"
    ]);
    Footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Wrapper = /*#__PURE__*/ (0,react.memo)(styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1cb54fd-0"
})(Footer_templateObject(), function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "100%" : "auto";
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "32px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "column" : "row";
}));
var BubbleWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-d1cb54fd-1"
})(Footer_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var Footer = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _helpUrl = param.helpUrl, helpUrl = _helpUrl === void 0 ? constants/* EXCHANGE_DOCS_URLS */.SO : _helpUrl;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isSide = variant === "side";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        $isSide: isSide
    });
};
/* harmony default export */ var Menu_Footer = (/*#__PURE__*/(0,react.memo)(Footer));

// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 2 modules
var Page = __webpack_require__(88452);
;// CONCATENATED MODULE: ./src/views/Page.tsx




function Page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  width: 100%;\n  padding: ",
        ";\n  padding-bottom: 0;\n  min-height: ",
        ";\n  background: ",
        ";\n\n  ",
        " {\n    background-size: auto;\n  }\n\n  ",
        " {\n    padding: ",
        ";\n    padding-bottom: 0;\n  }\n\n  ",
        " {\n    padding: ",
        ";\n    padding-bottom: 0;\n    min-height: ",
        ";\n  }\n"
    ]);
    Page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f6c1a67f-0"
})(Page_templateObject(), function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "16px";
}, function(param) {
    var $noMinHeight = param.$noMinHeight;
    return $noMinHeight ? "initial" : "calc(100vh - 64px)";
}, function(param) {
    var theme = param.theme;
    return theme.colors.gradientBubblegum;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "24px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var $removePadding = param.$removePadding;
    return $removePadding ? "0" : "52px";
}, function(param) {
    var $noMinHeight = param.$noMinHeight;
    return $noMinHeight ? "initial" : "calc(100vh - 132px)";
});
var Page_Page = function(_param) {
    var children = _param.children, _removePadding = _param.removePadding, removePadding = _removePadding === void 0 ? false : _removePadding, _hideFooterOnDesktop = _param.hideFooterOnDesktop, hideFooterOnDesktop = _hideFooterOnDesktop === void 0 ? false : _hideFooterOnDesktop, _noMinHeight = _param.noMinHeight, noMinHeight = _noMinHeight === void 0 ? false : _noMinHeight, _helpUrl = _param.helpUrl, helpUrl = _helpUrl === void 0 ? constants/* EXCHANGE_DOCS_URLS */.SO : _helpUrl, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "removePadding",
        "hideFooterOnDesktop",
        "noMinHeight",
        "helpUrl"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                $removePadding: removePadding,
                $noMinHeight: noMinHeight
            }, props), {
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        flexGrow: 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: [
                            "block",
                            null,
                            null,
                            hideFooterOnDesktop ? "none" : "block"
                        ],
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Footer, {
                            helpUrl: helpUrl
                        })
                    })
                ]
            }))
        ]
    });
};
/* harmony default export */ var views_Page = (Page_Page);

// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var Button_IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(45203);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUpDown.tsx
var ArrowUpDown = __webpack_require__(40589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link_Link = __webpack_require__(98768);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var Modal_useModal = __webpack_require__(21812);
;// CONCATENATED MODULE: ./src/components/Layout/Column.tsx

function Column_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"
    ]);
    Column_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Column_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  align-items: center;\n"
    ]);
    Column_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Column_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-auto-rows: auto;\n  grid-row-gap: ",
        ";\n  justify-items: ",
        ";\n"
    ]);
    Column_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Column = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91e5cc43-0"
})(Column_templateObject());
var ColumnCenter = (0,styled_components_browser_esm/* default */.ZP)(Column).withConfig({
    componentId: "sc-91e5cc43-1"
})(Column_templateObject1());
var Column_AutoColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91e5cc43-2"
})(Column_templateObject2(), function(param) {
    var gap = param.gap;
    return gap === "sm" && "8px" || gap === "md" && "12px" || gap === "lg" && "24px" || gap;
}, function(param) {
    var justify = param.justify;
    return justify;
});
/* harmony default export */ var Layout_Column = (Column);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./packages/utils/uriToHttp.ts
var uriToHttp = __webpack_require__(4278);
;// CONCATENATED MODULE: ./src/hooks/useHttpLocations.ts


function useHttpLocations(uri) {
    return (0,react.useMemo)(function() {
        return uri ? (0,uriToHttp/* default */.Z)(uri) : [];
    }, [
        uri
    ]);
}

;// CONCATENATED MODULE: ./src/utils/getTokenLogoURL.ts


var getTokenLogoURL_obj;
var mapping = (getTokenLogoURL_obj = {}, (0,src_define_property/* default */.Z)(getTokenLogoURL_obj, src/* ChainId.BSC */.a_.BSC, "smartchain"), (0,src_define_property/* default */.Z)(getTokenLogoURL_obj, src/* ChainId.ETHEREUM */.a_.ETHEREUM, "ethereum"), (0,src_define_property/* default */.Z)(getTokenLogoURL_obj, src/* ChainId.CRONOS */.a_.CRONOS, "cronos"), getTokenLogoURL_obj);
var getTokenLogoURL = function(token) {
    if (token && mapping[token.chainId]) {
        return "/images/tokens/".concat(token.address, ".png");
    }
    return null;
};
/* harmony default export */ var utils_getTokenLogoURL = (getTokenLogoURL);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Help.tsx
var Help = __webpack_require__(95160);
;// CONCATENATED MODULE: ./src/components/Logo/Logo.tsx






var BAD_SRCS = {};
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback triangle alert
 */ var Logo = function(_param) {
    var srcs = _param.srcs, alt = _param.alt, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "srcs",
        "alt"
    ]);
    var ref = (0,react.useState)(0), refresh = ref[1];
    var src = srcs.find(function(s) {
        return !BAD_SRCS[s];
    });
    if (src) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS[src] = true;
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, (0,src_object_spread/* default */.Z)({}, rest));
};
/* harmony default export */ var Logo_Logo = (Logo);

;// CONCATENATED MODULE: ./src/components/Logo/CurrencyLogo.tsx



function CurrencyLogo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n"
    ]);
    CurrencyLogo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo_Logo).withConfig({
    componentId: "sc-f2797636-0"
})(CurrencyLogo_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function CurrencyLogo(param) {
    var currency = param.currency, _size = param.size, size = _size === void 0 ? "24px" : _size, style = param.style;
    var uriLocations = useHttpLocations((0,_instanceof/* default */.Z)(currency, tokens_src/* WrappedTokenInfo */.DT) ? currency.logoURI : undefined);
    var srcs = (0,react.useMemo)(function() {
        if (currency === null || currency === void 0 ? void 0 : currency.isNative) return [];
        if (currency === null || currency === void 0 ? void 0 : currency.isToken) {
            var tokenLogoURL = utils_getTokenLogoURL(currency);
            if ((0,_instanceof/* default */.Z)(currency, tokens_src/* WrappedTokenInfo */.DT)) {
                if (!tokenLogoURL) return (0,src_to_consumable_array/* default */.Z)(uriLocations);
                return (0,src_to_consumable_array/* default */.Z)(uriLocations).concat([
                    tokenLogoURL
                ]);
            }
            if (!tokenLogoURL) return [];
            return [
                tokenLogoURL
            ];
        }
        return [];
    }, [
        currency,
        uriLocations
    ]);
    if (currency === null || currency === void 0 ? void 0 : currency.isNative) {
        if (currency.chainId === src/* ChainId.CRONOS */.a_.CRONOS) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
                size: size,
                srcs: [
                    "/images/tokens/0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23.png"
                ],
                width: size,
                style: style
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
            size: size,
            srcs: [
                "/images/chains/".concat(currency.chainId, ".png")
            ],
            width: size,
            style: style
        });
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
        size: size,
        srcs: srcs,
        alt: "".concat((ref = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref !== void 0 ? ref : "token", " logo"),
        style: style
    });
}

;// CONCATENATED MODULE: ./src/components/Logo/DoubleLogo.tsx

function DoubleLogo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-right: ",
        ";\n"
    ]);
    DoubleLogo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var DoubleLogo_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b339c6de-0"
})(DoubleLogo_templateObject(), function(param) {
    var margin = param.margin;
    return margin && "4px";
});
function DoubleCurrencyLogo(param) {
    var currency0 = param.currency0, currency1 = param.currency1, _size = param.size, size = _size === void 0 ? 20 : _size, _margin = param.margin, margin = _margin === void 0 ? false : _margin;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoubleLogo_Wrapper, {
        margin: margin,
        children: [
            currency0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                currency: currency0,
                size: "".concat(size.toString(), "px"),
                style: {
                    marginRight: "4px"
                }
            }),
            currency1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                currency: currency1,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Logo/ListLogo.tsx

function ListLogo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    ListLogo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledListLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo_Logo).withConfig({
    componentId: "sc-60793395-0"
})(ListLogo_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function ListLogo(param) {
    var logoURI = param.logoURI, style = param.style, _size = param.size, size = _size === void 0 ? "24px" : _size, alt = param.alt;
    var srcs = useHttpLocations(logoURI);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListLogo, {
        alt: alt,
        size: size,
        srcs: srcs,
        style: style
    });
}

;// CONCATENATED MODULE: ./src/components/Logo/index.ts




;// CONCATENATED MODULE: ./src/components/UnsupportedCurrencyFooter.tsx


function UnsupportedCurrencyFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 0;\n  width: 100%;\n  max-width: 400px;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  color: ",
        ";\n  background-color: ",
        ";\n  text-align: center;\n"
    ]);
    UnsupportedCurrencyFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var DetailsFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-14e16177-0"
})(UnsupportedCurrencyFooter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
});
var UnsupportedModal = function(param) {
    var currencies = param.currencies, onDismiss = param.onDismiss;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var tokens = chainId && currencies ? currencies.map(function(currency) {
        return (0,utils_wrappedCurrency/* wrappedCurrency */.pu)(currency, chainId);
    }) : [];
    var unsupportedTokens = (0,Tokens/* useUnsupportedTokens */.l6)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        title: t("Unsupported Assets"),
        maxWidth: "420px",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
            gap: "lg",
            children: [
                tokens.map(function(token) {
                    var ref;
                    return token && unsupportedTokens && Object.keys(unsupportedTokens).includes(token.address) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                                gap: "5px",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                        currency: token,
                                        size: "24px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        children: token.symbol
                                    })
                                ]
                            }),
                            chainId && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                                external: true,
                                small: true,
                                color: "primaryDark",
                                href: (0,utils/* getBlockExploreLink */.C)(token.address, "address", chainId),
                                children: token.address
                            })
                        ]
                    }, (ref = token.address) === null || ref === void 0 ? void 0 : ref.concat("not-supported"));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
                    gap: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        children: t("Some assets are not available through this interface because they may not work well with our smart contract or we are unable to allow trading for legal reasons.")
                    })
                })
            ]
        })
    });
};
function UnsupportedCurrencyFooter(param) {
    var currencies = param.currencies;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(UnsupportedModal, {
        currencies: currencies
    })), 1), onPresentModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsFooter, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "text",
            onClick: onPresentModal,
            children: t("Read more about unsupported assets")
        })
    });
}

;// CONCATENATED MODULE: ./src/utils/maxAmountSpend.ts


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    var ref;
    if (!currencyAmount) return undefined;
    if ((ref = currencyAmount.currency) === null || ref === void 0 ? void 0 : ref.isNative) {
        if (src/* JSBI.greaterThan */.QA.greaterThan(currencyAmount.quotient, exchange/* MIN_BNB */.Uz)) {
            return src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(currencyAmount.currency, src/* JSBI.subtract */.QA.subtract(currencyAmount.quotient, exchange/* MIN_BNB */.Uz));
        }
        return src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(currencyAmount.currency, exchange/* BIG_INT_ZERO */.iV);
    }
    return currencyAmount;
}

// EXTERNAL MODULE: ./src/state/swap/useSwapActionHandlers.ts
var useSwapActionHandlers = __webpack_require__(1999);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(88896);
;// CONCATENATED MODULE: ./src/views/Swap/hooks/fetchTokenRisk.ts




var TOKEN_RISK;
(function(TOKEN_RISK) {
    TOKEN_RISK["Low"] = "Low";
    TOKEN_RISK["Medium"] = "Medium";
    TOKEN_RISK["High"] = "High";
})(TOKEN_RISK || (TOKEN_RISK = {}));
var TokenRiskPhases = {
    0: TOKEN_RISK.Low,
    1: TOKEN_RISK.Medium,
    2: TOKEN_RISK.Medium,
    3: TOKEN_RISK.Medium,
    4: TOKEN_RISK.High,
    5: TOKEN_RISK.High
};
var fetchRiskApi = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(address, chainId) {
        var response, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(endpoints/* ACCESS_RISK_API */.iR, {
                            method: "post",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                address: address,
                                chain_id: chainId
                            })
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function fetchRiskApi(address, chainId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchRiskToken = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(address, chainId) {
        var riskApi, _data, risk_result, scanned_ts, risk_level, risk_level_description, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchRiskApi(address, chainId)
                    ];
                case 1:
                    riskApi = _state.sent();
                    _data = riskApi.data, risk_result = _data.risk_result, scanned_ts = _data.scanned_ts, risk_level = _data.risk_level, risk_level_description = _data.risk_level_description;
                    return [
                        2,
                        {
                            isSuccess: true,
                            address: address,
                            chainId: chainId,
                            riskLevel: TokenRiskPhases[risk_level],
                            riskResult: risk_result,
                            scannedTs: scanned_ts,
                            riskLevelDescription: risk_level_description
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Fetch Risk Token error: ", error);
                    return [
                        2,
                        {
                            isSuccess: false,
                            address: "",
                            chainId: src/* ChainId.CRONOS */.a_.CRONOS,
                            riskLevel: TokenRiskPhases[0],
                            riskResult: "",
                            scannedTs: 0,
                            riskLevelDescription: ""
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchRiskToken(address, chainId) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(27208);
;// CONCATENATED MODULE: ./src/views/Swap/components/AccessRisk/RiskMessage.tsx






var RiskMessage = function(param) {
    var currency = param.currency, riskTokenInfo = param.riskTokenInfo;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var riskLevel = riskTokenInfo.riskLevel, riskLevelDescription = riskTokenInfo.riskLevelDescription;
    var messageVariant = (0,react.useMemo)(function() {
        switch(riskLevel){
            case TOKEN_RISK.High:
                return "danger";
            case TOKEN_RISK.Medium:
                return "warning";
            default:
                return "success";
        }
    }, [
        riskLevel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
        variant: messageVariant,
        icon: "",
        mt: "10px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message/* MessageText */.Y, {
            bold: true,
            ml: "-12px",
            children: [
                t("%riskLevel% Risk", {
                    riskLevel: riskLevel
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    mt: "4px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                            currency: currency,
                            size: "24px",
                            style: {
                                marginRight: "8px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    fontSize: "14px",
                                    lineHeight: "120%",
                                    children: riskLevelDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                                    fontSize: "14px",
                                    mt: "8px",
                                    ml: "auto",
                                    external: true,
                                    href: "https://hashdit.github.io/hashdit/docs/risk-level-description/",
                                    children: t("Learn More")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var AccessRisk_RiskMessage = (RiskMessage);

;// CONCATENATED MODULE: ./src/views/Swap/components/AccessRisk/index.tsx












var AccessRisk = function(param) {
    var currency = param.currency;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var toastInfo = (0,useToast/* useToast */.p)().toastInfo;
    var ref = (0,react.useState)(false), isScanning = ref[0], setIsScanning = ref[1];
    var ref1 = (0,react.useState)(false), isFetchStatusSuccess = ref1[0], setIsFetchStatusSuccess = ref1[1];
    var ref2 = (0,react.useState)({}), allTokenInfo = ref2[0], setAllTokenInfo = ref2[1];
    var ref3 = (0,react.useState)({
        isSuccess: false,
        address: "",
        chainId: src/* ChainId.CRONOS */.a_.CRONOS,
        riskLevel: TokenRiskPhases[0],
        riskResult: "",
        scannedTs: 0,
        riskLevelDescription: ""
    }), riskTokenInfo = ref3[0], setRiskTokenInfo = ref3[1];
    (0,react.useEffect)(function() {
        if (currency) {
            setIsScanning(false);
            setIsFetchStatusSuccess(false);
            var address = currency.address, chainId = currency.chainId;
            if (allTokenInfo) {
                var list = allTokenInfo[chainId];
                if (list === null || list === void 0 ? void 0 : list[address]) {
                    setRiskTokenInfo(list[address]);
                    setIsFetchStatusSuccess(list[address].isSuccess);
                }
            }
        }
    }, [
        currency,
        allTokenInfo
    ]);
    var disabledButton = (0,react.useMemo)(function() {
        if (currency) {
            var address = currency.address;
            return isScanning || address === riskTokenInfo.address && riskTokenInfo.isSuccess;
        }
        return false;
    }, [
        currency,
        riskTokenInfo,
        isScanning
    ]);
    var handleScan = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            var address, chainId, symbol, tokenRiskResult;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsScanning(true);
                        address = currency.address, chainId = currency.chainId, symbol = currency.symbol;
                        toastInfo(t("Scanning Risk"), t("Please wait until we scan the risk for %symbol% token", {
                            symbol: symbol
                        }));
                        return [
                            4,
                            fetchRiskToken(address, chainId)
                        ];
                    case 1:
                        tokenRiskResult = _state.sent();
                        // To avoid response too slow, and user already change to new currency.
                        if (tokenRiskResult.isSuccess && tokenRiskResult.address === address) {
                            setIsScanning(false);
                            saveRiskTokenInfo(tokenRiskResult);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleScan() {
            return _ref.apply(this, arguments);
        };
    }();
    var saveRiskTokenInfo = function(data) {
        var address = data.address, chainId = data.chainId;
        var getRiskTokenList = allTokenInfo;
        var newData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getRiskTokenList), (0,src_define_property/* default */.Z)({}, chainId, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getRiskTokenList[chainId]), (0,src_define_property/* default */.Z)({}, address, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
            createDate: new Date().getTime()
        })))));
        setRiskTokenInfo(data);
        setIsFetchStatusSuccess(data.isSuccess);
        setAllTokenInfo(newData);
    };
    // Tooltips
    var ref4 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                children: t("The scan result is provided by 3rd parties and may not cover every token. Therefore the result is for reference only, do NOT take it as investment or financial advice. Always DYOR!")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                mt: "4px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        children: t("Powered by")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                        ml: "4px",
                        external: true,
                        href: "https://www.hashdit.io/en",
                        children: t("Hashdit.")
                    })
                ]
            })
        ]
    }), {
        placement: "bottom"
    }), targetRef = ref4.targetRef, tooltip = ref4.tooltip, tooltipVisible = ref4.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                justifyContent: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        scale: "xs",
                        style: {
                            textTransform: "uppercase"
                        },
                        disabled: disabledButton,
                        onClick: handleScan,
                        children: isScanning ? t("scanning...") : t("scan risk")
                    }),
                    tooltipVisible && tooltip,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        ref: targetRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {
                            ml: "4px",
                            width: "20px",
                            height: "20px",
                            color: "textSubtle"
                        })
                    })
                ]
            }),
            !isScanning && isFetchStatusSuccess && /*#__PURE__*/ (0,jsx_runtime.jsx)(AccessRisk_RiskMessage, {
                currency: currency,
                riskTokenInfo: riskTokenInfo
            })
        ]
    });
};
/* harmony default export */ var components_AccessRisk = (AccessRisk);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(57049);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts + 1 modules
var useBUSDPrice = __webpack_require__(78469);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading_Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/hooks/src/index.ts + 4 modules
var hooks_src = __webpack_require__(74903);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(32762);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(52687);
// EXTERNAL MODULE: ./src/state/lists/hooks.ts + 3 modules
var lists_hooks = __webpack_require__(8074);
;// CONCATENATED MODULE: ./src/components/SearchModal/types.ts
var CurrencyModalView;
(function(CurrencyModalView) {
    CurrencyModalView[CurrencyModalView["search"] = 0] = "search";
    CurrencyModalView[CurrencyModalView["manage"] = 1] = "manage";
    CurrencyModalView[CurrencyModalView["importToken"] = 2] = "importToken";
    CurrencyModalView[CurrencyModalView["importList"] = 3] = "importList";
})(CurrencyModalView || (CurrencyModalView = {}));
var CommonBasesType;
(function(CommonBasesType) {
    CommonBasesType["LIQUIDITY"] = "LIQUIDITY";
    CommonBasesType["SWAP_LIMITORDER"] = "SWAP_LIMITORDER";
})(CommonBasesType || (CommonBasesType = {}));
/* harmony default export */ var SearchModal_types = ((/* unused pure expression or super */ null && (CurrencyModalView)));

;// CONCATENATED MODULE: ./src/components/SearchModal/CommonBases.tsx

function CommonBases_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 10px;\n"
    ]);
    CommonBases_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CommonBases_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  display: flex;\n  padding: 6px;\n  align-items: center;\n  :hover {\n    cursor: ",
        ";\n    background-color: ",
        ";\n  }\n  background-color: ",
        ";\n  opacity: ",
        ";\n"
    ]);
    CommonBases_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CommonBases_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  &::-webkit-scrollbar {\n    display: none;\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n"
    ]);
    CommonBases_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e064d5f4-0"
})(CommonBases_templateObject());
var BaseWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e064d5f4-1"
})(CommonBases_templateObject1(), function(param) {
    var theme = param.theme, disable = param.disable;
    return disable ? "transparent" : theme.colors.dropdown;
}, function(param) {
    var disable = param.disable;
    return !disable && "pointer";
}, function(param) {
    var theme = param.theme, disable = param.disable;
    return !disable && theme.colors.background;
}, function(param) {
    var theme = param.theme, disable = param.disable;
    return disable && theme.colors.dropdown;
}, function(param) {
    var disable = param.disable;
    return disable && "0.4";
});
var RowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e064d5f4-2"
})(CommonBases_templateObject2());
function CommonBases(param) {
    var chainId = param.chainId, onSelect = param.onSelect, selectedCurrency = param.selectedCurrency, commonBasesType = param.commonBasesType;
    var native = (0,useNativeCurrency/* default */.Z)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var pinTokenDescText = commonBasesType === CommonBasesType.SWAP_LIMITORDER ? t("Common tokens") : t("Common bases");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
        gap: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        fontSize: "14px",
                        children: pinTokenDescText
                    }),
                    commonBasesType === CommonBasesType.LIQUIDITY && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHelper/* default */.Z, {
                        text: t("These tokens are commonly paired with other tokens."),
                        ml: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseWrapper, {
                            onClick: function() {
                                if (!selectedCurrency || !selectedCurrency.isNative) {
                                    onSelect(native);
                                }
                            },
                            disable: selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.isNative,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                    currency: native,
                                    style: {
                                        marginRight: 8
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    children: native === null || native === void 0 ? void 0 : native.symbol
                                })
                            ]
                        })
                    }),
                    (chainId ? exchange/* SUGGESTED_BASES */.kx[chainId] || [] : []).map(function(token, i) {
                        var selected = selectedCurrency === null || selectedCurrency === void 0 ? void 0 : selectedCurrency.equals(token);
                        return(// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseWrapper, {
                                onClick: function() {
                                    return !selected && onSelect(token);
                                },
                                disable: selected,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                        currency: token,
                                        style: {
                                            marginRight: 8,
                                            borderRadius: "50%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        children: token.symbol
                                    })
                                ]
                            }, token.address)
                        }, i));
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-window/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(1314);
;// CONCATENATED MODULE: ./src/components/Card/index.tsx

function Card_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    Card_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Card_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    Card_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Card_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    Card_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Card_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Card_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Card_Card = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-21be8dee-0"
})(Card_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "1.25rem";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius !== null && borderRadius !== void 0 ? borderRadius : "16px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
/* harmony default export */ var components_Card = (Card_Card);
var LightCard = (0,styled_components_browser_esm/* default */.ZP)(Card_Card).withConfig({
    componentId: "sc-21be8dee-1"
})(Card_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var LightGreyCard = (0,styled_components_browser_esm/* default */.ZP)(Card_Card).withConfig({
    componentId: "sc-21be8dee-2"
})(Card_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var GreyCard = (0,styled_components_browser_esm/* default */.ZP)(Card_Card).withConfig({
    componentId: "sc-21be8dee-3"
})(Card_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CheckmarkCircle.tsx
var CheckmarkCircle = __webpack_require__(39398);
;// CONCATENATED MODULE: ./src/components/SearchModal/ImportRow.tsx

function ImportRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 20px;\n  height: 56px;\n  display: grid;\n  grid-template-columns: auto minmax(auto, 1fr) auto;\n  grid-gap: 10px;\n  align-items: center;\n\n  opacity: ",
        ";\n\n  ",
        " {\n    grid-gap: 16px;\n  }\n"
    ]);
    ImportRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImportRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 16px;\n  width: 16px;\n  margin-right: 6px;\n  stroke: ",
        ";\n"
    ]);
    ImportRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ImportRow_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 140px;\n  font-size: 12px;\n"
    ]);
    ImportRow_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var TokenSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46a7a6c2-0"
})(ImportRow_templateObject(), function(param) {
    var dim = param.dim;
    return dim ? "0.4" : "1";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var CheckIcon = (0,styled_components_browser_esm/* default */.ZP)(CheckmarkCircle/* default */.Z).withConfig({
    componentId: "sc-46a7a6c2-1"
})(ImportRow_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.success;
});
var NameOverflow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46a7a6c2-2"
})(ImportRow_templateObject2());
function ImportRow(param) {
    var token = param.token, style = param.style, dim = param.dim, showImportView = param.showImportView, setImportToken = param.setImportToken;
    var ref, ref1;
    // globals
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // check if token comes from list
    var inactiveTokenList = (0,lists_hooks/* useCombinedInactiveList */.qB)();
    var list = chainId && (inactiveTokenList === null || inactiveTokenList === void 0 ? void 0 : (ref = inactiveTokenList[chainId]) === null || ref === void 0 ? void 0 : (ref1 = ref[token.address]) === null || ref1 === void 0 ? void 0 : ref1.list);
    // check if already active on list or local storage tokens
    var isAdded = (0,Tokens/* useIsUserAddedToken */.EH)(token);
    var isActive = (0,Tokens/* useIsTokenActive */.ZN)(token);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TokenSection, {
        style: style,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                currency: token,
                size: isMobile ? "20px" : "24px",
                style: {
                    opacity: dim ? "0.6" : "1"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                gap: "4px",
                style: {
                    opacity: dim ? "0.6" : "1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                mr: "8px",
                                children: token.symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                color: "textDisabled",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NameOverflow, {
                                    title: token.name,
                                    children: token.name
                                })
                            })
                        ]
                    }),
                    list && list.logoURI && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                fontSize: isMobile ? "10px" : "14px",
                                mr: "4px",
                                color: "textSubtle",
                                children: [
                                    t("via"),
                                    " ",
                                    list.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLogo, {
                                logoURI: list.logoURI,
                                size: "12px"
                            })
                        ]
                    })
                ]
            }),
            !isActive && !isAdded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                scale: isMobile ? "sm" : "md",
                width: "fit-content",
                onClick: function() {
                    if (setImportToken) {
                        setImportToken(token);
                    }
                    showImportView();
                },
                children: t("Import")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                style: {
                    minWidth: "fit-content"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        color: "success",
                        children: "Active"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/SearchModal/CurrencyList.tsx


function CurrencyList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: 5rem;\n  text-overflow: ellipsis;\n"
    ]);
    CurrencyList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencyList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 20px;\n  height: 56px;\n  display: grid;\n  grid-gap: 16px;\n  align-items: center;\n"
    ]);
    CurrencyList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CurrencyList_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4px 20px;\n  height: 56px;\n  display: grid;\n  grid-template-columns: auto minmax(auto, 1fr) minmax(0, 72px);\n  grid-gap: 8px;\n  cursor: ",
        ";\n  pointer-events: ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n  opacity: ",
        ";\n"
    ]);
    CurrencyList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





















function currencyKey(currency) {
    return (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency.address : (currency === null || currency === void 0 ? void 0 : currency.isNative) ? currency.symbol : "";
}
var StyledBalanceText = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).withConfig({
    componentId: "sc-e1f91500-0"
})(CurrencyList_templateObject());
var FixedContentRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e1f91500-1"
})(CurrencyList_templateObject1());
function Balance(param) {
    var balance = param.balance;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceText, {
        title: balance.toExact(),
        children: balance.toSignificant(4)
    });
}
var MenuItem = (0,styled_components_browser_esm/* default */.ZP)(RowBetween).withConfig({
    componentId: "sc-e1f91500-2"
})(CurrencyList_templateObject2(), function(param) {
    var disabled = param.disabled;
    return !disabled && "pointer";
}, function(param) {
    var disabled = param.disabled;
    return disabled && "none";
}, function(param) {
    var theme = param.theme, disabled = param.disabled;
    return !disabled && theme.colors.background;
}, function(param) {
    var disabled = param.disabled, selected = param.selected;
    return disabled || selected ? 0.5 : 1;
});
function CurrencyRow(param) {
    var currency = param.currency, onSelect = param.onSelect, isSelected = param.isSelected, otherSelected = param.otherSelected, style = param.style;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var key = currencyKey(currency);
    var selectedTokenList = (0,lists_hooks/* useCombinedActiveList */.z0)();
    var isOnSelectedList = (0,utils/* isTokenOnList */.wK)(selectedTokenList, currency);
    var customAdded = (0,Tokens/* useIsUserAddedToken */.EH)(currency);
    var balance = useCurrencyBalance(account !== null && account !== void 0 ? account : undefined, currency);
    // only show add or remove buttons if not on selected list
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
        style: style,
        className: "token-item-".concat(key),
        onClick: function() {
            return isSelected ? null : onSelect();
        },
        disabled: isSelected,
        selected: otherSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                currency: currency,
                size: "24px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Column, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        bold: true,
                        children: currency.symbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        color: "textSubtle",
                        small: true,
                        ellipsis: true,
                        maxWidth: "200px",
                        children: [
                            !isOnSelectedList && customAdded && "".concat(t("Added by user"), " •"),
                            " ",
                            currency.name
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                style: {
                    justifySelf: "flex-end"
                },
                children: balance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance, {
                    balance: balance
                }) : account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleLoader, {}) : null
            })
        ]
    });
}
function CurrencyList(param) {
    var height = param.height, currencies = param.currencies, inactiveCurrencies = param.inactiveCurrencies, selectedCurrency = param.selectedCurrency, onCurrencySelect = param.onCurrencySelect, otherCurrency = param.otherCurrency, fixedListRef = param.fixedListRef, showBNB = param.showBNB, showImportView = param.showImportView, setImportToken = param.setImportToken, breakIndex = param.breakIndex;
    var native = (0,useNativeCurrency/* default */.Z)();
    var itemData = (0,react.useMemo)(function() {
        var formatted = showBNB ? [
            native
        ].concat((0,src_to_consumable_array/* default */.Z)(currencies), (0,src_to_consumable_array/* default */.Z)(inactiveCurrencies)) : (0,src_to_consumable_array/* default */.Z)(currencies).concat((0,src_to_consumable_array/* default */.Z)(inactiveCurrencies));
        if (breakIndex !== undefined) {
            formatted = (0,src_to_consumable_array/* default */.Z)(formatted.slice(0, breakIndex)).concat([
                undefined
            ], (0,src_to_consumable_array/* default */.Z)(formatted.slice(breakIndex, formatted.length)));
        }
        return formatted;
    }, [
        breakIndex,
        currencies,
        inactiveCurrencies,
        showBNB,
        native
    ]);
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var Row = (0,react.useCallback)(function(param) {
        var data = param.data, index = param.index, style = param.style;
        var currency = data[index];
        var isSelected = Boolean(selectedCurrency && currency && selectedCurrency.equals(currency));
        var otherSelected = Boolean(otherCurrency && currency && otherCurrency.equals(currency));
        var handleSelect = function() {
            return onCurrencySelect(currency);
        };
        var token = (0,utils_wrappedCurrency/* wrappedCurrency */.pu)(currency, chainId);
        var showImport = index > currencies.length;
        if (index === breakIndex || !data) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedContentRow, {
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LightGreyCard, {
                    padding: "8px 12px",
                    borderRadius: "8px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                small: true,
                                children: t("Expanded results from inactive Token Lists")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHelper/* default */.Z, {
                                text: t("Tokens from inactive lists. Import specific tokens below or click 'Manage' to activate more lists."),
                                ml: "4px"
                            })
                        ]
                    })
                })
            });
        }
        if (showImport && token) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportRow, {
                style: style,
                token: token,
                showImportView: showImportView,
                setImportToken: setImportToken,
                dim: true
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyRow, {
            style: style,
            currency: currency,
            isSelected: isSelected,
            onSelect: handleSelect,
            otherSelected: otherSelected
        });
    }, [
        selectedCurrency,
        otherCurrency,
        chainId,
        currencies.length,
        breakIndex,
        onCurrencySelect,
        t,
        showImportView,
        setImportToken, 
    ]);
    var itemKey = (0,react.useCallback)(function(index, data) {
        return currencyKey(data[index]);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FixedSizeList */.t7, {
        height: height,
        ref: fixedListRef,
        width: "100%",
        itemData: itemData,
        itemCount: itemData.length,
        itemSize: 56,
        itemKey: itemKey,
        children: Row
    });
}

;// CONCATENATED MODULE: ./src/components/SearchModal/filtering.ts



function filterTokens(tokens, search) {
    if (search.length === 0) return tokens;
    var searchingAddress = isAddress(search);
    if (searchingAddress) {
        return tokens.filter(function(token) {
            return token.address === searchingAddress;
        });
    }
    var lowerSearchParts = search.toLowerCase().split(/\s+/).filter(function(s) {
        return s.length > 0;
    });
    if (lowerSearchParts.length === 0) {
        return tokens;
    }
    var matchesSearch = function(s) {
        var sParts = s.toLowerCase().split(/\s+/).filter(function(s_) {
            return s_.length > 0;
        });
        return lowerSearchParts.every(function(p) {
            return p.length === 0 || sParts.some(function(sp) {
                return sp.startsWith(p) || sp.endsWith(p);
            });
        });
    };
    return tokens.filter(function(token) {
        var symbol = token.symbol, name = token.name;
        return symbol && matchesSearch(symbol) || name && matchesSearch(name);
    });
}
function createFilterToken(search) {
    var searchingAddress = (0,utils/* isAddress */.UJ)(search);
    if (searchingAddress) {
        var address = searchingAddress.toLowerCase();
        return function(t) {
            return "address" in t && address === t.address.toLowerCase();
        };
    }
    var lowerSearchParts = search.toLowerCase().split(/\s+/).filter(function(s) {
        return s.length > 0;
    });
    if (lowerSearchParts.length === 0) {
        return function() {
            return true;
        };
    }
    var matchesSearch = function(s) {
        var sParts = s.toLowerCase().split(/\s+/).filter(function(s_) {
            return s_.length > 0;
        });
        return lowerSearchParts.every(function(p) {
            return p.length === 0 || sParts.some(function(sp) {
                return sp.startsWith(p) || sp.endsWith(p);
            });
        });
    };
    return function(token) {
        var symbol = token.symbol, name = token.name;
        return symbol && matchesSearch(symbol) || name && matchesSearch(name);
    };
}
function useSortedTokensByQuery(tokens, searchQuery) {
    return (0,react.useMemo)(function() {
        if (!tokens) {
            return [];
        }
        var trimmedSearchQuery = searchQuery.toLowerCase().trim();
        var symbolMatch = trimmedSearchQuery.split(/\s+/).filter(function(s) {
            return s.length > 0;
        });
        if (symbolMatch.length > 1) {
            return tokens;
        }
        var exactMatches = [];
        var symbolSubstrings = [];
        var rest = [];
        // sort tokens by exact match -> substring on symbol match -> rest
        tokens.forEach(function(token) {
            var ref, ref1;
            var tokenSymbol = (ref = token.symbol) === null || ref === void 0 ? void 0 : ref.toLowerCase();
            if (tokenSymbol === symbolMatch[0] || ((ref1 = token.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === trimmedSearchQuery) {
                return exactMatches.push(token);
            }
            if (tokenSymbol.startsWith(trimmedSearchQuery)) {
                return symbolSubstrings.push(token);
            }
            return rest.push(token);
        });
        return (0,src_to_consumable_array/* default */.Z)(exactMatches).concat((0,src_to_consumable_array/* default */.Z)(symbolSubstrings), (0,src_to_consumable_array/* default */.Z)(rest));
    }, [
        tokens,
        searchQuery
    ]);
}

;// CONCATENATED MODULE: ./src/components/SearchModal/sorting.ts


// compare two token amounts with highest one coming first
function balanceComparator(balanceA, balanceB) {
    if (balanceA && balanceB) {
        return balanceA.greaterThan(balanceB) ? -1 : balanceA.equalTo(balanceB) ? 0 : 1;
    }
    if (balanceA && balanceA.greaterThan("0")) {
        return -1;
    }
    if (balanceB && balanceB.greaterThan("0")) {
        return 1;
    }
    return 0;
}
function getTokenComparator(balances) {
    return function sortTokens(tokenA, tokenB) {
        // -1 = a is first
        // 1 = b is first
        // sort by balances
        var balanceA = balances[tokenA.address];
        var balanceB = balances[tokenB.address];
        var balanceComp = balanceComparator(balanceA, balanceB);
        if (balanceComp !== 0) return balanceComp;
        if (tokenA.symbol && tokenB.symbol) {
            // sort by symbol
            return tokenA.symbol.toLowerCase() < tokenB.symbol.toLowerCase() ? -1 : 1;
        }
        return tokenA.symbol ? -1 : tokenB.symbol ? -1 : 0;
    };
}
function useTokenComparator(inverted) {
    var balances = useAllTokenBalances();
    var comparator = (0,react.useMemo)(function() {
        return getTokenComparator(balances !== null && balances !== void 0 ? balances : {});
    }, [
        balances
    ]);
    return (0,react.useMemo)(function() {
        if (inverted) {
            return function(tokenA, tokenB) {
                return comparator(tokenA, tokenB) * -1;
            };
        }
        return comparator;
    }, [
        inverted,
        comparator
    ]);
}
/* harmony default export */ var sorting = (useTokenComparator);

;// CONCATENATED MODULE: ./src/components/SearchModal/swapSound.ts
var swapSound;
var swapSoundURL = "https://cdn.pancakeswap.com/swap.mp3";
var getSwapSound = function() {
    if (!swapSound) {
        swapSound = new Audio(swapSoundURL);
    }
    return swapSound;
};

;// CONCATENATED MODULE: ./src/components/SearchModal/CurrencySearch.tsx
/* eslint-disable no-restricted-syntax */ 























function useSearchInactiveTokenLists(search) {
    var minResults = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var lists = (0,lists_hooks/* useAllLists */.R0)();
    var inactiveUrls = (0,lists_hooks/* useInactiveListUrls */.eu)();
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var activeTokens = (0,Tokens/* useAllTokens */.e_)();
    return (0,react.useMemo)(function() {
        if (!search || search.trim().length === 0) return [];
        var filterToken = createFilterToken(search);
        var exactMatches = [];
        var rest = [];
        var addressSet = {};
        var trimmedSearchQuery = search.toLowerCase().trim();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = inactiveUrls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var url = _step.value;
                var list = lists[url].current;
                // eslint-disable-next-line no-continue
                if (!list) continue;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = list.tokens[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var tokenInfo = _step1.value;
                        if (tokenInfo.chainId === chainId && !(tokenInfo.address in activeTokens) && !addressSet[tokenInfo.address] && filterToken(tokenInfo)) {
                            var ref, ref1, ref2, ref3;
                            var ref4;
                            var tags = (ref4 = (ref1 = (ref = tokenInfo.tags) === null || ref === void 0 ? void 0 : ref.map(function(tagId) {
                                var ref;
                                if (!((ref = list.tags) === null || ref === void 0 ? void 0 : ref[tagId])) return undefined;
                                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, list.tags[tagId]), {
                                    id: tagId
                                });
                            })) === null || ref1 === void 0 ? void 0 : ref1.filter(function(x) {
                                return Boolean(x);
                            })) !== null && ref4 !== void 0 ? ref4 : [];
                            var wrapped = new tokens_src/* WrappedTokenInfo */.DT(tokenInfo, tags);
                            addressSet[wrapped.address] = true;
                            if (((ref2 = tokenInfo.name) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === trimmedSearchQuery || ((ref3 = tokenInfo.symbol) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === trimmedSearchQuery) {
                                exactMatches.push(wrapped);
                            } else {
                                rest.push(wrapped);
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0,src_to_consumable_array/* default */.Z)(exactMatches).concat((0,src_to_consumable_array/* default */.Z)(rest)).slice(0, minResults);
    }, [
        activeTokens,
        chainId,
        inactiveUrls,
        lists,
        minResults,
        search
    ]);
}
function CurrencySearch(param) {
    var selectedCurrency = param.selectedCurrency, onCurrencySelect = param.onCurrencySelect, otherSelectedCurrency = param.otherSelectedCurrency, showCommonBases = param.showCommonBases, commonBasesType = param.commonBasesType, showImportView = param.showImportView, setImportToken = param.setImportToken, height = param.height;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    // refs for fixed size lists
    var fixedList = (0,react.useRef)();
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    var debouncedQuery = (0,useDebounce/* default */.Z)(searchQuery, 200);
    var ref1 = (0,react.useState)(false), invertSearchOrder = ref1[0];
    var allTokens = (0,Tokens/* useAllTokens */.e_)();
    // if they input an address, use it
    var searchToken = (0,Tokens/* useToken */.dQ)(debouncedQuery);
    var searchTokenIsAdded = (0,Tokens/* useIsUserAddedToken */.EH)(searchToken);
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useAudioModeManager */.TO)(), 1), audioPlay = ref2[0];
    var native = (0,useNativeCurrency/* default */.Z)();
    var showBNB = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var s = debouncedQuery.toLowerCase().trim();
        return native && ((ref = native.symbol) === null || ref === void 0 ? void 0 : (ref1 = ref.toLowerCase) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.call(ref)) === null || ref2 === void 0 ? void 0 : ref2.indexOf(s)) !== -1;
    }, [
        debouncedQuery,
        native
    ]);
    var filteredTokens = (0,react.useMemo)(function() {
        var filterToken = createFilterToken(debouncedQuery);
        return Object.values(allTokens).filter(filterToken);
    }, [
        allTokens,
        debouncedQuery
    ]);
    var filteredQueryTokens = useSortedTokensByQuery(filteredTokens, debouncedQuery);
    var tokenComparator = sorting(invertSearchOrder);
    var filteredSortedTokens = (0,react.useMemo)(function() {
        return (0,src_to_consumable_array/* default */.Z)(filteredQueryTokens).sort(tokenComparator);
    }, [
        filteredQueryTokens,
        tokenComparator
    ]);
    var handleCurrencySelect = (0,react.useCallback)(function(currency) {
        onCurrencySelect(currency);
        if (audioPlay) {
            getSwapSound().play();
        }
    }, [
        audioPlay,
        onCurrencySelect
    ]);
    // manage focus on modal show
    var inputRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        if (!isMobile) inputRef.current.focus();
    }, [
        isMobile
    ]);
    var handleInput = (0,react.useCallback)(function(event) {
        var ref;
        var input = event.target.value;
        var checksummedInput = (0,utils/* isAddress */.UJ)(input);
        setSearchQuery(checksummedInput || input);
        (ref = fixedList.current) === null || ref === void 0 ? void 0 : ref.scrollTo(0);
    }, []);
    var handleEnter = (0,react.useCallback)(function(e) {
        if (e.key === "Enter") {
            var s = debouncedQuery.toLowerCase().trim();
            if (s === native.symbol.toLowerCase().trim()) {
                handleCurrencySelect(native);
            } else if (filteredSortedTokens.length > 0) {
                var ref;
                if (((ref = filteredSortedTokens[0].symbol) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === debouncedQuery.trim().toLowerCase() || filteredSortedTokens.length === 1) {
                    handleCurrencySelect(filteredSortedTokens[0]);
                }
            }
        }
    }, [
        debouncedQuery,
        filteredSortedTokens,
        handleCurrencySelect,
        native
    ]);
    // if no results on main list, show option to expand into inactive
    var filteredInactiveTokens = useSearchInactiveTokenLists(debouncedQuery);
    var hasFilteredInactiveTokens = Boolean(filteredInactiveTokens === null || filteredInactiveTokens === void 0 ? void 0 : filteredInactiveTokens.length);
    var getCurrencyListRows = (0,react.useCallback)(function() {
        if (searchToken && !searchTokenIsAdded && !hasFilteredInactiveTokens) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Column, {
                style: {
                    padding: "20px 0",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportRow, {
                    token: searchToken,
                    showImportView: showImportView,
                    setImportToken: setImportToken
                })
            });
        }
        return Boolean(filteredSortedTokens === null || filteredSortedTokens === void 0 ? void 0 : filteredSortedTokens.length) || hasFilteredInactiveTokens ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            margin: "24px -24px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyList, {
                height: isMobile ? showCommonBases ? height || 250 : height ? height + 80 : 350 : 390,
                showBNB: showBNB,
                currencies: filteredSortedTokens,
                inactiveCurrencies: filteredInactiveTokens,
                breakIndex: Boolean(filteredInactiveTokens === null || filteredInactiveTokens === void 0 ? void 0 : filteredInactiveTokens.length) && filteredSortedTokens ? filteredSortedTokens.length : undefined,
                onCurrencySelect: handleCurrencySelect,
                otherCurrency: otherSelectedCurrency,
                selectedCurrency: selectedCurrency,
                fixedListRef: fixedList,
                showImportView: showImportView,
                setImportToken: setImportToken
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Column, {
            style: {
                padding: "20px",
                height: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                color: "textSubtle",
                textAlign: "center",
                mb: "20px",
                children: t("No results found.")
            })
        });
    }, [
        filteredInactiveTokens,
        filteredSortedTokens,
        handleCurrencySelect,
        hasFilteredInactiveTokens,
        otherSelectedCurrency,
        searchToken,
        searchTokenIsAdded,
        selectedCurrency,
        setImportToken,
        showBNB,
        showImportView,
        t,
        showCommonBases,
        isMobile,
        height, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                gap: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "token-search-input",
                            placeholder: t("Search name or paste address"),
                            scale: "lg",
                            autoComplete: "off",
                            value: searchQuery,
                            ref: inputRef,
                            onChange: handleInput,
                            onKeyDown: handleEnter
                        })
                    }),
                    showCommonBases && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonBases, {
                        chainId: chainId,
                        onSelect: handleCurrencySelect,
                        selectedCurrency: selectedCurrency,
                        commonBasesType: commonBasesType
                    })
                ]
            }),
            getCurrencyListRows()
        ]
    });
}
/* harmony default export */ var SearchModal_CurrencySearch = (CurrencySearch);

// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Grid.tsx
var Grid = __webpack_require__(66260);
// EXTERNAL MODULE: ./packages/uikit/src/components/Tag/Tag.tsx + 3 modules
var Tag = __webpack_require__(22769);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Error.tsx
var Icons_Error = __webpack_require__(5389);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx + 1 modules
var Checkbox = __webpack_require__(92052);
// EXTERNAL MODULE: ./packages/utils/truncateHash.ts
var truncateHash = __webpack_require__(15260);
;// CONCATENATED MODULE: ./src/components/SearchModal/ImportToken.tsx











function ImportToken(param) {
    var tokens = param.tokens, handleCurrencySelect = param.handleCurrencySelect;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), confirmed = ref[0], setConfirmed = ref[1];
    var addToken = (0,hooks/* useAddUserToken */._E)();
    // use for showing import source on inactive tokens
    var inactiveTokenList = (0,lists_hooks/* useCombinedInactiveList */.qB)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
        gap: "lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                    children: [
                        t("Anyone can create a CRC20 token on Cronos with any name, including creating fake versions of existing tokens and tokens that claim to represent projects that do not have a token."),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        t("If you purchase an arbitrary token, you may be unable to sell it back.")
                    ]
                })
            }),
            tokens.map(function(token) {
                var ref, ref1;
                var list = chainId && (inactiveTokenList === null || inactiveTokenList === void 0 ? void 0 : (ref = inactiveTokenList[chainId]) === null || ref === void 0 ? void 0 : (ref1 = ref[token.address]) === null || ref1 === void 0 ? void 0 : ref1.list);
                var address = token.address ? "".concat((0,truncateHash/* default */.Z)(token.address)) : null;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    gridTemplateRows: "1fr 1fr 1fr",
                    gridGap: "4px",
                    children: [
                        list !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tag/* default */.Z, {
                            variant: "success",
                            outline: true,
                            scale: "sm",
                            startIcon: list.logoURI && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLogo, {
                                logoURI: list.logoURI,
                                size: "12px"
                            }),
                            children: [
                                t("via"),
                                " ",
                                list.name
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                            variant: "failure",
                            outline: true,
                            scale: "sm",
                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                                color: "failure"
                            }),
                            children: t("Unknown Source")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    mr: "8px",
                                    children: token.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                    children: [
                                        "(",
                                        token.symbol,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        chainId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            justifyContent: "space-between",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    mr: "4px",
                                    children: address
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link_Link/* default */.Z, {
                                    href: (0,utils/* getBlockExploreLink */.C)(token.address, "address", chainId),
                                    external: true,
                                    children: [
                                        "(",
                                        t("View on %site%", {
                                            site: (0,utils/* getBlockExploreName */.X0)(chainId)
                                        }),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }, token.address);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        alignItems: "center",
                        onClick: function() {
                            return setConfirmed(!confirmed);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                scale: "sm",
                                name: "confirmed",
                                type: "checkbox",
                                checked: confirmed,
                                onChange: function() {
                                    return setConfirmed(!confirmed);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                ml: "8px",
                                style: {
                                    userSelect: "none"
                                },
                                children: t("I understand")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "danger",
                        disabled: !confirmed,
                        onClick: function() {
                            tokens.forEach(function(token) {
                                return addToken(token);
                            });
                            if (handleCurrencySelect) {
                                handleCurrencySelect(tokens[0]);
                            }
                        },
                        className: ".token-dismiss-button",
                        children: t("Import")
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var SearchModal_ImportToken = (ImportToken);

// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(12587);
// EXTERNAL MODULE: ./packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(51983);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Cog.tsx
var Cog = __webpack_require__(79605);
// EXTERNAL MODULE: ./packages/uikit/src/components/Toggle/Toggle.tsx + 2 modules
var Toggle = __webpack_require__(40628);
// EXTERNAL MODULE: ./src/config/constants/lists.ts
var constants_lists = __webpack_require__(77310);
// EXTERNAL MODULE: ./node_modules/jotai/esm/index.js
var esm = __webpack_require__(91131);
// EXTERNAL MODULE: ./src/state/lists/lists.ts
var lists_lists = __webpack_require__(92088);
// EXTERNAL MODULE: ./packages/token-lists/src/index.ts + 3 modules
var token_lists_src = __webpack_require__(52226);
// EXTERNAL MODULE: ./packages/token-lists/src/actions.ts
var src_actions = __webpack_require__(5898);
;// CONCATENATED MODULE: ./src/components/SearchModal/ManageLists.tsx




function ManageLists_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    ManageLists_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ManageLists_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px;\n  border-color: ",
        ";\n  transition: 200ms;\n  align-items: center;\n  padding: 1rem;\n  border-radius: 20px;\n  opacity: ",
        ";\n"
    ]);
    ManageLists_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ManageLists_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem 0;\n  height: 100%;\n  overflow: auto;\n"
    ]);
    ManageLists_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















function listVersionLabel(version) {
    return "v".concat(version.major, ".").concat(version.minor, ".").concat(version.patch);
}
var ManageLists_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Layout_Column).withConfig({
    componentId: "sc-4009d26d-0"
})(ManageLists_templateObject());
var ManageLists_RowWrapper = (0,styled_components_browser_esm/* default */.ZP)(Layout_Row).withConfig({
    componentId: "sc-4009d26d-1"
})(ManageLists_templateObject1(), function(param) {
    var active = param.active, theme = param.theme;
    return active ? "".concat(theme.colors.success19) : "transparent";
}, function(param) {
    var active = param.active, theme = param.theme;
    return active ? theme.colors.success : theme.colors.tertiary;
}, function(param) {
    var hasActiveTokens = param.hasActiveTokens;
    return hasActiveTokens ? 1 : 0.4;
});
function listUrlRowHTMLId(listUrl) {
    return "list-row-".concat(listUrl.replace(/\./g, "-"));
}
var ListRow = /*#__PURE__*/ (0,react.memo)(function ListRow(param) {
    var listUrl = param.listUrl;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isActive = (0,lists_hooks/* useIsListActive */.EF)(listUrl);
    var listsByUrl = (0,esm/* useAtomValue */.Dv)(lists_hooks/* selectorByUrlsAtom */.Ti);
    var ref = (0,src_sliced_to_array/* default */.Z)((0,lists_lists/* useListState */.n)(), 2), dispatch = ref[1];
    var _listUrl = listsByUrl[listUrl], list = _listUrl.current, pending = _listUrl.pendingUpdate;
    var activeTokensOnThisChain = (0,react.useMemo)(function() {
        if (!list || !chainId) {
            return 0;
        }
        return list.tokens.reduce(function(acc, cur) {
            return cur.chainId === chainId ? acc + 1 : acc;
        }, 0);
    }, [
        chainId,
        list
    ]);
    var handleAcceptListUpdate = (0,react.useCallback)(function() {
        if (!pending) return;
        dispatch((0,src_actions/* acceptListUpdate */.xJ)(listUrl));
    }, [
        dispatch,
        listUrl,
        pending
    ]);
    var handleRemoveList = (0,react.useCallback)(function() {
        // eslint-disable-next-line no-alert
        if (window.confirm("Please confirm you would like to remove this list")) {
            dispatch((0,src_actions/* removeList */.J_)(listUrl));
        }
    }, [
        dispatch,
        listUrl
    ]);
    var handleEnableList = (0,react.useCallback)(function() {
        dispatch((0,src_actions/* enableList */.ic)(listUrl));
    }, [
        dispatch,
        listUrl
    ]);
    var handleDisableList = (0,react.useCallback)(function() {
        dispatch((0,src_actions/* disableList */.K$)(listUrl));
    }, [
        dispatch,
        listUrl
    ]);
    var ref1 = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                children: list && listVersionLabel(list.version)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                external: true,
                href: "https://tokenlists.org/token-list?url=".concat(listUrl),
                children: t("See")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "danger",
                scale: "xs",
                onClick: handleRemoveList,
                disabled: Object.keys(listsByUrl).length === 1,
                children: t("Remove")
            }),
            pending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                onClick: handleAcceptListUpdate,
                style: {
                    fontSize: "12px"
                },
                children: t("Update list")
            })
        ]
    }), {
        placement: "right-end",
        trigger: "click"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    if (!list) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ManageLists_RowWrapper, {
        active: isActive,
        hasActiveTokens: activeTokensOnThisChain > 0,
        id: listUrlRowHTMLId(listUrl),
        children: [
            tooltipVisible && tooltip,
            list.logoURI ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLogo, {
                size: "40px",
                style: {
                    marginRight: "1rem"
                },
                logoURI: list.logoURI,
                alt: "".concat(list.name, " list logo")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: "24px",
                    height: "24px",
                    marginRight: "1rem"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Column, {
                style: {
                    flex: "1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            bold: true,
                            children: list.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        mt: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                fontSize: "12px",
                                mr: "6px",
                                textTransform: "lowercase",
                                children: [
                                    list.tokens.length,
                                    " ",
                                    t("Tokens")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                ref: targetRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cog/* default */.Z, {
                                    color: "text",
                                    width: "12px"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle/* default */.Z, {
                checked: isActive,
                onChange: function() {
                    if (isActive) {
                        handleDisableList();
                    } else {
                        handleEnableList();
                    }
                }
            })
        ]
    }, listUrl);
});
var ListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4009d26d-2"
})(ManageLists_templateObject2());
function ManageLists(param) {
    var setModalView = param.setModalView, setImportList = param.setImportList, setListUrl = param.setListUrl;
    var ref = (0,react.useState)(""), listUrlInput = ref[0], setListUrlInput = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var lists = (0,lists_hooks/* useAllLists */.R0)();
    // sort by active but only if not visible
    var activeListUrls = (0,lists_hooks/* useActiveListUrls */.v0)();
    var ref1 = (0,react.useState)(), activeCopy = ref1[0], setActiveCopy = ref1[1];
    (0,react.useEffect)(function() {
        if (!activeCopy && activeListUrls) {
            setActiveCopy(activeListUrls);
        }
    }, [
        activeCopy,
        activeListUrls
    ]);
    var handleInput = (0,react.useCallback)(function(e) {
        setListUrlInput(e.target.value);
    }, []);
    var fetchList = (0,token_lists_src/* useFetchListCallback */.jn)(lists_lists/* listsAtom */.l);
    var validUrl = (0,react.useMemo)(function() {
        return (0,uriToHttp/* default */.Z)(listUrlInput).length > 0;
    }, [
        listUrlInput
    ]);
    var sortedLists = (0,react.useMemo)(function() {
        var listUrls = Object.keys(lists);
        return listUrls.filter(function(listUrl) {
            // only show loaded lists, hide unsupported lists
            return Boolean(lists[listUrl].current) && !constants_lists/* UNSUPPORTED_LIST_URLS.includes */.US.includes(listUrl);
        }).sort(function(u1, u2) {
            var _u1 = lists[u1], l1 = _u1.current;
            var _u2 = lists[u2], l2 = _u2.current;
            // first filter on active lists
            if ((activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u1)) && !(activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u2))) {
                return -1;
            }
            if (!(activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u1)) && (activeCopy === null || activeCopy === void 0 ? void 0 : activeCopy.includes(u2))) {
                return 1;
            }
            if (l1 && l2) {
                // Always make PancakeSwap list in top.
                var keyword = "pancakeswap";
                if (l1.name.toLowerCase().includes(keyword) || l2.name.toLowerCase().includes(keyword)) {
                    return -1;
                }
                return l1.name.toLowerCase() < l2.name.toLowerCase() ? -1 : l1.name.toLowerCase() === l2.name.toLowerCase() ? 0 : 1;
            }
            if (l1) return -1;
            if (l2) return 1;
            return 0;
        });
    }, [
        lists,
        activeCopy
    ]);
    // temporary fetched list for import flow
    var ref2 = (0,react.useState)(), tempList = ref2[0], setTempList = ref2[1];
    var ref3 = (0,react.useState)(), addError = ref3[0], setAddError = ref3[1];
    (0,react.useEffect)(function() {
        function fetchTempList() {
            return _fetchTempList.apply(this, arguments);
        }
        function _fetchTempList() {
            _fetchTempList = (0,src_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    fetchList(listUrlInput, false).then(function(list) {
                        return setTempList(list);
                    }).catch(function() {
                        return setAddError("Error importing list");
                    });
                    return [
                        2
                    ];
                });
            });
            return _fetchTempList.apply(this, arguments);
        }
        // if valid url, fetch details for card
        if (validUrl) {
            fetchTempList();
        } else {
            setTempList(undefined);
            if (listUrlInput !== "") {
                setAddError("Enter valid list location");
            }
        }
        // reset error
        if (listUrlInput === "") {
            setAddError(undefined);
        }
    }, [
        fetchList,
        listUrlInput,
        validUrl
    ]);
    // check if list is already imported
    var isImported = Object.keys(lists).includes(listUrlInput);
    // set list values and have parent modal switch to import list view
    var handleImport = (0,react.useCallback)(function() {
        if (!tempList) return;
        setImportList(tempList);
        setModalView(CurrencyModalView.importList);
        setListUrl(listUrlInput);
    }, [
        listUrlInput,
        setImportList,
        setListUrl,
        setModalView,
        tempList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ManageLists_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                gap: "14px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "list-add-input",
                            scale: "lg",
                            placeholder: t("https:// or ipfs://"),
                            value: listUrlInput,
                            onChange: handleInput
                        })
                    }),
                    addError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        color: "failure",
                        style: {
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        },
                        children: addError
                    }) : null
                ]
            }),
            tempList && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
                style: {
                    paddingTop: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Card, {
                    padding: "12px 20px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                children: [
                                    tempList.logoURI && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLogo, {
                                        logoURI: tempList.logoURI,
                                        size: "40px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                                        gap: "4px",
                                        style: {
                                            marginLeft: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                bold: true,
                                                children: tempList.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                                color: "textSubtle",
                                                small: true,
                                                textTransform: "lowercase",
                                                children: [
                                                    tempList.tokens.length,
                                                    " ",
                                                    t("Tokens")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isImported ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkmark/* default */.Z, {
                                        width: "16px",
                                        mr: "10px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        children: t("Loaded")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                width: "fit-content",
                                onClick: handleImport,
                                children: t("Import")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
                    gap: "md",
                    children: sortedLists.map(function(listUrl) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListRow, {
                            listUrl: listUrl
                        }, listUrl);
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var SearchModal_ManageLists = (ManageLists);

// EXTERNAL MODULE: ./src/state/user/hooks/useUserAddedTokens.ts
var useUserAddedTokens = __webpack_require__(69482);
;// CONCATENATED MODULE: ./src/components/SearchModal/ManageTokens.tsx

function ManageTokens_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: calc(100% - 60px);\n  position: relative;\n  padding-bottom: 60px;\n"
    ]);
    ManageTokens_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ManageTokens_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    ManageTokens_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var ManageTokens_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3eca3fc-0"
})(ManageTokens_templateObject());
var ManageTokens_Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3eca3fc-1"
})(ManageTokens_templateObject1());
function ManageTokens(param) {
    var setModalView = param.setModalView, setImportToken = param.setImportToken;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(""), searchQuery = ref[0], setSearchQuery = ref[1];
    // manage focus on modal show
    var inputRef = (0,react.useRef)();
    var handleInput = (0,react.useCallback)(function(event) {
        var input = event.target.value;
        var checksummedInput = (0,utils/* isAddress */.UJ)(input);
        setSearchQuery(checksummedInput || input);
    }, []);
    // if they input an address, use it
    var searchToken = (0,Tokens/* useToken */.dQ)(searchQuery);
    // all tokens for local list
    var userAddedTokens = (0,useUserAddedTokens/* default */.Z)();
    var removeToken = (0,hooks/* useRemoveUserAddedToken */.QG)();
    var handleRemoveAll = (0,react.useCallback)(function() {
        if (chainId && userAddedTokens) {
            userAddedTokens.forEach(function(token) {
                return removeToken(chainId, token.address);
            });
        }
    }, [
        removeToken,
        userAddedTokens,
        chainId
    ]);
    var tokenList = (0,react.useMemo)(function() {
        return chainId && userAddedTokens.map(function(token) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                currency: token,
                                size: "20px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                                external: true,
                                href: (0,utils/* getBlockExploreLink */.C)(token.address, "address", chainId),
                                color: "textSubtle",
                                ml: "10px",
                                children: token.symbol
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_IconButton/* default */.Z, {
                                variant: "text",
                                onClick: function() {
                                    return removeToken(chainId, token.address);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                                href: (0,utils/* getBlockExploreLink */.C)(token.address, "address", chainId)
                            })
                        ]
                    })
                ]
            }, token.address);
        });
    }, [
        userAddedTokens,
        chainId,
        removeToken
    ]);
    var isAddressValid = searchQuery === "" || (0,utils/* isAddress */.UJ)(searchQuery);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageTokens_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Column, {
            style: {
                width: "100%",
                flex: "1 1"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                    gap: "14px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Row, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                id: "token-search-input",
                                scale: "lg",
                                placeholder: "0x0000",
                                value: searchQuery,
                                autoComplete: "off",
                                ref: inputRef,
                                onChange: handleInput,
                                isWarning: !isAddressValid
                            })
                        }),
                        !isAddressValid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            color: "failure",
                            children: t("Enter valid token address")
                        }),
                        searchToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportRow, {
                            token: searchToken,
                            showImportView: function() {
                                return setModalView(CurrencyModalView.importToken);
                            },
                            setImportToken: setImportToken,
                            style: {
                                height: "fit-content"
                            }
                        })
                    ]
                }),
                tokenList,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ManageTokens_Footer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                            bold: true,
                            color: "textSubtle",
                            children: [
                                userAddedTokens === null || userAddedTokens === void 0 ? void 0 : userAddedTokens.length,
                                " ",
                                userAddedTokens.length === 1 ? t("Custom Token") : t("Custom Tokens")
                            ]
                        }),
                        userAddedTokens.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "tertiary",
                            onClick: handleRemoveAll,
                            children: t("Clear all")
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/SearchModal/Manage.tsx

function Manage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    Manage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledButtonMenu = (0,styled_components_browser_esm/* default */.ZP)(ButtonMenu/* default */.Z).withConfig({
    componentId: "sc-e2a99e21-0"
})(Manage_templateObject());
function Manage(param) {
    var setModalView = param.setModalView, setImportList = param.setImportList, setImportToken = param.setImportToken, setListUrl = param.setListUrl;
    var ref = (0,react.useState)(true), showLists = ref[0], setShowLists = ref[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButtonMenu, {
                activeIndex: showLists ? 0 : 1,
                onItemClick: function() {
                    return setShowLists(function(prev) {
                        return !prev;
                    });
                },
                scale: "sm",
                variant: "subtle",
                mb: "32px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                        width: "50%",
                        children: t("Lists")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                        width: "50%",
                        children: t("Tokens")
                    })
                ]
            }),
            showLists ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal_ManageLists, {
                setModalView: setModalView,
                setImportList: setImportList,
                setListUrl: setListUrl
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageTokens, {
                setModalView: setModalView,
                setImportToken: setImportToken
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
;// CONCATENATED MODULE: ./src/components/SearchModal/ImportList.tsx


function ImportList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    ImportList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ImportList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 3px;\n  width: 3px;\n  background-color: ",
        ";\n  border-radius: 50%;\n"
    ]);
    ImportList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var ImportList_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-73e63f60-0"
})(ImportList_templateObject());
var TextDot = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-73e63f60-1"
})(ImportList_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
function ImportList(param) {
    var listURL = param.listURL, list = param.list, onImport = param.onImport;
    var ref;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,lists_lists/* useListState */.n)(), 2), dispatch = ref1[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // user must accept
    var ref2 = (0,react.useState)(false), confirmed = ref2[0], setConfirmed = ref2[1];
    var lists = (0,lists_hooks/* useAllLists */.R0)();
    var fetchList = (0,token_lists_src/* useFetchListCallback */.jn)(lists_lists/* listsAtom */.l);
    // monitor is list is loading
    var adding = Boolean((ref = lists[listURL]) === null || ref === void 0 ? void 0 : ref.loadingRequestId);
    var ref3 = (0,react.useState)(null), addError = ref3[0], setAddError = ref3[1];
    var handleAddList = (0,react.useCallback)(function() {
        if (adding) return;
        setAddError(null);
        fetchList(listURL).then(function() {
            dispatch((0,token_lists_src/* enableList */.ic)(listURL));
            onImport();
        }).catch(function(error) {
            setAddError(error.message);
            dispatch((0,token_lists_src/* removeList */.J_)(listURL));
        });
    }, [
        adding,
        dispatch,
        fetchList,
        listURL,
        onImport
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportList_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
            gap: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                gap: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Card, {
                        padding: "12px 20px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RowBetween, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                children: [
                                    list.logoURI && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLogo, {
                                        logoURI: list.logoURI,
                                        size: "40px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                                        gap: "sm",
                                        style: {
                                            marginLeft: "20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                                        bold: true,
                                                        mr: "6px",
                                                        children: list.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextDot, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                                        small: true,
                                                        color: "textSubtle",
                                                        ml: "6px",
                                                        children: [
                                                            list.tokens.length,
                                                            " tokens"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                                                small: true,
                                                external: true,
                                                ellipsis: true,
                                                maxWidth: "90%",
                                                href: "https://tokenlists.org/token-list?url=".concat(listURL),
                                                children: listURL
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        variant: "danger",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    fontSize: "20px",
                                    textAlign: "center",
                                    color: theme.colors.failure,
                                    mb: "16px",
                                    children: t("Import at your own risk")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    color: theme.colors.failure,
                                    mb: "8px",
                                    children: t("By adding this list you are implicitly trusting that the data is correct. Anyone can create a list, including creating fake versions of existing lists and lists that claim to represent projects that do not have one.")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    bold: true,
                                    color: theme.colors.failure,
                                    mb: "16px",
                                    children: t("If you purchase a token from this list, you may not be able to sell it back.")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            name: "confirmed",
                                            type: "checkbox",
                                            checked: confirmed,
                                            onChange: function() {
                                                return setConfirmed(!confirmed);
                                            },
                                            scale: "sm"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                            ml: "10px",
                                            style: {
                                                userSelect: "none"
                                            },
                                            children: t("I understand")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        disabled: !confirmed,
                        onClick: handleAddList,
                        children: t("Import")
                    }),
                    addError ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        color: "failure",
                        style: {
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        },
                        children: addError
                    }) : null
                ]
            })
        })
    });
}
/* harmony default export */ var SearchModal_ImportList = (ImportList);

;// CONCATENATED MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx


function CurrencySearchModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  text-align: center;\n"
    ]);
    CurrencySearchModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencySearchModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-width: 320px;\n  max-width: 420px !important;\n  min-height: calc(var(--vh, 1vh) * 90);\n  ",
        " {\n    min-height: auto;\n  }\n"
    ]);
    CurrencySearchModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CurrencySearchModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  overflow-y: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    CurrencySearchModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var CurrencySearchModal_Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a06b5c7d-0"
})(CurrencySearchModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var StyledModalContainer = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-a06b5c7d-1"
})(CurrencySearchModal_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalBody */.fe).withConfig({
    componentId: "sc-a06b5c7d-2"
})(CurrencySearchModal_templateObject2());
function CurrencySearchModal(param) {
    var _onDismiss = param.onDismiss, onDismiss = _onDismiss === void 0 ? function() {
        return null;
    } : _onDismiss, onCurrencySelect = param.onCurrencySelect, selectedCurrency = param.selectedCurrency, otherSelectedCurrency = param.otherSelectedCurrency, _showCommonBases = param.showCommonBases, showCommonBases = _showCommonBases === void 0 ? true : _showCommonBases, commonBasesType = param.commonBasesType;
    var ref = (0,react.useState)(CurrencyModalView.search), modalView = ref[0], setModalView = ref[1];
    var handleCurrencySelect = (0,react.useCallback)(function(currency) {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        onCurrencySelect(currency);
    }, [
        onDismiss,
        onCurrencySelect
    ]);
    // for token import view
    var prevView = (0,hooks_src/* usePreviousValue */.zP)(modalView);
    // used for import token flow
    var ref1 = (0,react.useState)(), importToken = ref1[0], setImportToken = ref1[1];
    // used for import list
    var ref2 = (0,react.useState)(), importList = ref2[0], setImportList = ref2[1];
    var ref3 = (0,react.useState)(), listURL = ref3[0], setListUrl = ref3[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var _obj;
    var config = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, CurrencyModalView.search, {
        title: t("Select a Token"),
        onBack: undefined
    }), (0,src_define_property/* default */.Z)(_obj, CurrencyModalView.manage, {
        title: t("Manage"),
        onBack: function() {
            return setModalView(CurrencyModalView.search);
        }
    }), (0,src_define_property/* default */.Z)(_obj, CurrencyModalView.importToken, {
        title: t("Import Tokens"),
        onBack: function() {
            return setModalView(prevView && prevView !== CurrencyModalView.importToken ? prevView : CurrencyModalView.search);
        }
    }), (0,src_define_property/* default */.Z)(_obj, CurrencyModalView.importList, {
        title: t("Import List"),
        onBack: function() {
            return setModalView(CurrencyModalView.search);
        }
    }), _obj);
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var wrapperRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(undefined), height = ref4[0], setHeight = ref4[1];
    (0,react.useEffect)(function() {
        if (!wrapperRef.current) return;
        setHeight(wrapperRef.current.offsetHeight - 330);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalContainer, {
        drag: isMobile ? "y" : false,
        dragConstraints: {
            top: 0,
            bottom: 600
        },
        dragElastic: {
            top: 0
        },
        dragSnapToOrigin: true,
        onDragStart: function() {
            if (wrapperRef.current) wrapperRef.current.style.animation = "none";
        },
        // @ts-ignore
        onDragEnd: function(e, info) {
            if (info.velocity.y > Modal_Modal/* MODAL_SWIPE_TO_CLOSE_VELOCITY */.d && onDismiss) onDismiss();
        },
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalHeader */.xB, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalTitle */.r6, {
                        children: [
                            config[modalView].onBack && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBackButton */.vy, {
                                onBack: config[modalView].onBack
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading/* default */.Z, {
                                children: config[modalView].title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalCloseButton */.ol, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalBody, {
                children: modalView === CurrencyModalView.search ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal_CurrencySearch, {
                    onCurrencySelect: handleCurrencySelect,
                    selectedCurrency: selectedCurrency,
                    otherSelectedCurrency: otherSelectedCurrency,
                    showCommonBases: showCommonBases,
                    commonBasesType: commonBasesType,
                    showImportView: function() {
                        return setModalView(CurrencyModalView.importToken);
                    },
                    setImportToken: setImportToken,
                    height: height
                }) : modalView === CurrencyModalView.importToken && importToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal_ImportToken, {
                    tokens: [
                        importToken
                    ],
                    handleCurrencySelect: handleCurrencySelect
                }) : modalView === CurrencyModalView.importList && importList && listURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal_ImportList, {
                    list: importList,
                    listURL: listURL,
                    onImport: function() {
                        return setModalView(CurrencyModalView.manage);
                    }
                }) : modalView === CurrencyModalView.manage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Manage, {
                    setModalView: setModalView,
                    setImportToken: setImportToken,
                    setImportList: setImportList,
                    setListUrl: setListUrl
                }) : ""
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/NumericalInput.tsx




function NumericalInput_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: 16px;\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    NumericalInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-8de12016-0"
})(NumericalInput_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.text;
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "right";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var NumericalInput_Input = /*#__PURE__*/ (0,react.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        },
        // universal input options
        inputMode: "decimal",
        title: t("Token Amount"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    }));
});
/* harmony default export */ var NumericalInput = ((/* unused pure expression or super */ null && (NumericalInput_Input)));

// EXTERNAL MODULE: ./src/components/CopyButton/index.tsx
var CopyButton = __webpack_require__(17235);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/BinanceChain.tsx
var BinanceChain = __webpack_require__(67290);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CoinbaseWallet.tsx
var CoinbaseWallet = __webpack_require__(5203);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Opera.tsx
var Opera = __webpack_require__(58600);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TokenPocket.tsx
var TokenPocket = __webpack_require__(2529);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TrustWallet.tsx
var TrustWallet = __webpack_require__(62149);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Metamask.tsx
var Metamask = __webpack_require__(75545);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/wagmi.esm.js + 30 modules
var wagmi_esm = __webpack_require__(5286);
;// CONCATENATED MODULE: ./src/utils/wallet.ts
// Set of helper functions to facilitate wallet setup



/**
 * Prompt the user to add a custom token to metamask
 * @param tokenAddress
 * @param tokenSymbol
 * @param tokenDecimals
 * @returns {boolean} true if the token has been added, false otherwise
 */ var registerToken = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(tokenAddress, tokenSymbol, tokenDecimals, tokenLogo) {
        var image, tokenAdded;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    image = tokenLogo ? BAD_SRCS[tokenLogo] ? undefined : tokenLogo : undefined;
                    return [
                        4,
                        window.ethereum.request({
                            method: "wallet_watchAsset",
                            params: {
                                type: "ERC20",
                                options: {
                                    address: tokenAddress,
                                    symbol: tokenSymbol,
                                    decimals: tokenDecimals,
                                    image: image
                                }
                            }
                        })
                    ];
                case 1:
                    tokenAdded = _state.sent();
                    return [
                        2,
                        tokenAdded
                    ];
            }
        });
    });
    return function registerToken(tokenAddress, tokenSymbol, tokenDecimals, tokenLogo) {
        return _ref.apply(this, arguments);
    };
}();
var canRegisterToken = function() {
    var ref, ref1, ref2, ref3, ref4;
    return  true && // @ts-ignore
    !(window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isSafePal) && ((window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isMetaMask) || (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isTrust) || (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isCoinbaseWallet) || (window === null || window === void 0 ? void 0 : (ref4 = window.ethereum) === null || ref4 === void 0 ? void 0 : ref4.isTokenPocket));
};

;// CONCATENATED MODULE: ./src/components/AddToWallet/AddToWalletButton.tsx









var AddToWalletTextOptions;
(function(AddToWalletTextOptions) {
    AddToWalletTextOptions[AddToWalletTextOptions["NO_TEXT"] = 0] = "NO_TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT"] = 1] = "TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT_WITH_ASSET"] = 2] = "TEXT_WITH_ASSET";
})(AddToWalletTextOptions || (AddToWalletTextOptions = {}));
var Icons = {
    // TODO: Brave
    Binance: BinanceChain/* default */.Z,
    "Coinbase Wallet": CoinbaseWallet/* default */.Z,
    Opera: Opera/* default */.Z,
    TokenPocket: TokenPocket/* default */.Z,
    "Trust Wallet": TrustWallet/* default */.Z,
    MetaMask: Metamask/* default */.Z
};
var getWalletText = function(textOptions, tokenSymbol, t) {
    return textOptions !== AddToWalletTextOptions.NO_TEXT && (textOptions === AddToWalletTextOptions.TEXT ? t("Add to Wallet") : t("Add %asset% to Wallet", {
        asset: tokenSymbol
    }));
};
var getWalletIcon = function(marginTextBetweenLogo, name) {
    var ref, ref1, ref2, ref3;
    var iconProps = (0,src_object_spread/* default */.Z)({
        width: "16px"
    }, marginTextBetweenLogo && {
        ml: marginTextBetweenLogo
    });
    if (name && Icons[name]) {
        var Icon = Icons[name];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, (0,src_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isTrust) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustWallet/* default */.Z, (0,src_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isCoinbaseWallet) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinbaseWallet/* default */.Z, (0,src_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isTokenPocket) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPocket/* default */.Z, (0,src_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isMetaMask) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, (0,src_object_spread/* default */.Z)({}, iconProps));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, (0,src_object_spread/* default */.Z)({}, iconProps));
};
var AddToWalletButton = function(_param) {
    var tokenAddress = _param.tokenAddress, tokenSymbol = _param.tokenSymbol, tokenDecimals = _param.tokenDecimals, tokenLogo = _param.tokenLogo, _textOptions = _param.textOptions, textOptions = _textOptions === void 0 ? AddToWalletTextOptions.NO_TEXT : _textOptions, _marginTextBetweenLogo = _param.marginTextBetweenLogo, marginTextBetweenLogo = _marginTextBetweenLogo === void 0 ? "0px" : _marginTextBetweenLogo, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "tokenAddress",
        "tokenSymbol",
        "tokenDecimals",
        "tokenLogo",
        "textOptions",
        "marginTextBetweenLogo"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,wagmi_esm/* useAccount */.mA)(), connector = ref.connector, isConnected = ref.isConnected;
    var isCanRegisterToken = canRegisterToken();
    if (connector && connector.name === "Binance") return null;
    if (!(connector && connector.watchAsset && isConnected)) return null;
    if (!isCanRegisterToken) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        onClick: function() {
            var ref;
            var image = tokenLogo ? BAD_SRCS[tokenLogo] ? undefined : tokenLogo : undefined;
            (ref = connector.watchAsset) === null || ref === void 0 ? void 0 : ref.call(connector, {
                address: tokenAddress,
                symbol: tokenSymbol,
                image: image,
                // @ts-ignore
                decimals: tokenDecimals
            });
        },
        children: [
            getWalletText(textOptions, tokenSymbol, t),
            getWalletIcon(marginTextBetweenLogo, connector === null || connector === void 0 ? void 0 : connector.name)
        ]
    }));
};
/* harmony default export */ var AddToWallet_AddToWalletButton = (AddToWalletButton);

;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/index.tsx



function CurrencyInputPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: ",
        ";\n"
    ]);
    CurrencyInputPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencyInputPanel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 8px;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      border-radius: ",
        " 8px 0px 0px;\n      height: auto;\n    "
    ]);
    CurrencyInputPanel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CurrencyInputPanel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0.5rem;\n\n  ",
        ";\n"
    ]);
    CurrencyInputPanel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CurrencyInputPanel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.75rem 1rem 0 1rem;\n"
    ]);
    CurrencyInputPanel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CurrencyInputPanel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    CurrencyInputPanel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-radius: 0px 16px 16px 16px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 16px;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  opacity: 0.6;\n  background-color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}















var InputRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-298c7fb9-0"
})(CurrencyInputPanel_templateObject(), function(param) {
    var selected = param.selected;
    return selected ? "0.75rem 0.5rem 0.75rem 1rem" : "0.75rem 0.75rem 0.75rem 1rem";
});
var CurrencySelectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "text",
    scale: "sm"
}).withConfig({
    componentId: "sc-298c7fb9-1"
})(CurrencyInputPanel_templateObject2(), function(param) {
    var zapStyle = param.zapStyle, theme = param.theme;
    return zapStyle && (0,styled_components_browser_esm/* css */.iv)(CurrencyInputPanel_templateObject1(), theme.colors.background, theme.colors.cardBorder, zapStyle === "zap" ? "0px" : "8px");
});
var LabelRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-298c7fb9-2"
})(CurrencyInputPanel_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var InputPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-298c7fb9-3"
})(CurrencyInputPanel_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-298c7fb9-4"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme, error = param.error;
    return theme.shadows[error ? "warning" : "inset"];
}, function(param) {
    var zapStyle = param.zapStyle;
    return !!zapStyle && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-298c7fb9-5"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onInputBlur = param.onInputBlur, onMax = param.onMax, showMaxButton = param.showMaxButton, label = param.label, onCurrencySelect = param.onCurrencySelect, currency = param.currency, _disableCurrencySelect = param.disableCurrencySelect, disableCurrencySelect = _disableCurrencySelect === void 0 ? false : _disableCurrencySelect, _hideBalance = param.hideBalance, hideBalance = _hideBalance === void 0 ? false : _hideBalance, zapStyle = param.zapStyle, beforeButton = param.beforeButton, _pair = param.pair, pair = _pair === void 0 ? null : _pair, otherCurrency = param.otherCurrency, id = param.id, showCommonBases = param.showCommonBases, commonBasesType = param.commonBasesType, disabled = param.disabled, error = param.error, showBUSD = param.showBUSD;
    var account = (0,hooks_useActiveWeb3React/* default */.Z)().account;
    var selectedCurrencyBalance = useCurrencyBalance(account !== null && account !== void 0 ? account : undefined, currency !== null && currency !== void 0 ? currency : undefined);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var token = pair ? pair.liquidityToken : (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency : null;
    var tokenAddress = token ? (0,utils/* isAddress */.UJ)(token.address) : null;
    var amountInDollar = (0,useBUSDPrice/* useBUSDCurrencyAmount */.vB)(showBUSD ? currency : undefined, Number.isFinite(+value) ? +value : undefined);
    var ref = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: currency,
        otherSelectedCurrency: otherCurrency,
        showCommonBases: showCommonBases,
        commonBasesType: commonBasesType
    })), 1), onPresentCurrencyModal = ref[0];
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        children: [
                            beforeButton,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelectButton, {
                                zapStyle: zapStyle,
                                className: "open-currency-select-button",
                                selected: !!currency,
                                onClick: function() {
                                    if (!disableCurrencySelect) {
                                        onPresentCurrencyModal();
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        pair ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DoubleCurrencyLogo, {
                                            currency0: pair.token0,
                                            currency1: pair.token1,
                                            size: 16,
                                            margin: true
                                        }) : currency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                            currency: currency,
                                            size: "24px",
                                            style: {
                                                marginRight: "8px"
                                            }
                                        }) : null,
                                        pair ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                            id: "pair",
                                            bold: true,
                                            children: [
                                                pair === null || pair === void 0 ? void 0 : pair.token0.symbol,
                                                ":",
                                                pair === null || pair === void 0 ? void 0 : pair.token1.symbol
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                            id: "pair",
                                            bold: true,
                                            children: (currency && currency.symbol && currency.symbol.length > 20 ? "".concat(currency.symbol.slice(0, 4), "...").concat(currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)) : currency === null || currency === void 0 ? void 0 : currency.symbol) || t("Select a currency")
                                        }),
                                        !disableCurrencySelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
                                    ]
                                })
                            }),
                            token && tokenAddress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                                style: {
                                    gap: "4px"
                                },
                                ml: "4px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                        width: "16px",
                                        buttonColor: "textSubtle",
                                        text: tokenAddress,
                                        tooltipMessage: t("Token address copied"),
                                        tooltipTop: -20,
                                        tooltipRight: 40,
                                        tooltipFontSize: 12
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWallet_AddToWalletButton, {
                                        variant: "text",
                                        p: "0",
                                        height: "auto",
                                        width: "fit-content",
                                        tokenAddress: tokenAddress,
                                        tokenSymbol: token.symbol,
                                        tokenDecimals: token.decimals,
                                        tokenLogo: (0,_instanceof/* default */.Z)(token, tokens_src/* WrappedTokenInfo */.DT) ? token.logoURI : undefined
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        onClick: !disabled && onMax,
                        color: "textSubtle",
                        fontSize: "14px",
                        style: {
                            display: "inline",
                            cursor: "pointer"
                        },
                        children: !hideBalance && !!currency ? t("Balance: %balance%", {
                            balance: (ref1 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref1 !== void 0 ? ref1 : t("Loading")
                        }) : " -"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputPanel, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                        as: "label",
                        zapStyle: zapStyle,
                        error: error,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericalInput_Input, {
                                    error: error,
                                    disabled: disabled,
                                    className: "token-amount-input",
                                    value: value,
                                    onBlur: onInputBlur,
                                    onUserInput: function(val) {
                                        onUserInput(val);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                selected: disableCurrencySelect,
                                children: [
                                    !!currency && showBUSD && Number.isFinite(amountInDollar) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        mr: "12px",
                                        children: [
                                            "~",
                                            (0,formatBalance/* formatNumber */.uf)(amountInDollar),
                                            " USD"
                                        ]
                                    }),
                                    account && currency && !disabled && showMaxButton && label !== "To" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: onMax,
                                        scale: "xs",
                                        variant: "secondary",
                                        style: {
                                            textTransform: "uppercase"
                                        },
                                        children: t("Max")
                                    })
                                ]
                            })
                        ]
                    }),
                    disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {})
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
;// CONCATENATED MODULE: ./src/utils/sentry.ts


var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var isUserRejected = function(err) {
    // provider user rejected error code
    return typeof err === "object" && "code" in err && err.code === 4001;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_instanceof/* default */.Z)(error, Error)) {
            (0,esm_exports/* captureException */.Tb)(error);
        } else {
            (0,esm_exports/* captureException */.Tb)(assignError(error), error);
        }
    }
    console.error(error);
};

// EXTERNAL MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/dist/index.js
var limit_orders_lib_dist = __webpack_require__(55855);
// EXTERNAL MODULE: ./src/hooks/useProviderOrSigner.ts
var hooks_useProviderOrSigner = __webpack_require__(99648);
;// CONCATENATED MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersLib.ts






var useGelatoLimitOrdersLib_useGelatoLimitOrdersLib = function() {
    var chainId = useActiveWeb3React().chainId;
    var providerOrSigner = useProviderOrSigner();
    return useMemo(function() {
        if (!chainId || !providerOrSigner) {
            console.error("Could not instantiate GelatoLimitOrders: missing chainId or library");
            return undefined;
        }
        if (chainId !== ChainId.BSC) return undefined;
        try {
            return new GelatoLimitOrders(chainId, providerOrSigner, GELATO_HANDLER, false);
        } catch (error) {
            console.error("Could not instantiate GelatoLimitOrders: ".concat(error.message));
            return undefined;
        }
    }, [
        chainId,
        providerOrSigner
    ]);
};
/* harmony default export */ var limitOrders_useGelatoLimitOrdersLib = ((/* unused pure expression or super */ null && (useGelatoLimitOrdersLib_useGelatoLimitOrdersLib)));

;// CONCATENATED MODULE: ./src/hooks/useCallWithGasPrice.ts









function useCallWithGasPrice() {
    var gasPrice = (0,hooks/* useGasPrice */.Fh)();
    /**
   * Perform a contract call with a gas price returned from useGasPrice
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callWithGasPrice = (0,react.useCallback)(function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, hasManualGasPriceOverride, tx, ref;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,esm_exports/* addBreadcrumb */.n_)({
                            type: "Transaction",
                            message: "Call with gas price: ".concat(gasPrice),
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = get_default()(contract, methodName);
                        hasManualGasPriceOverride = overrides === null || overrides === void 0 ? void 0 : overrides.gasPrice;
                        return [
                            4,
                            contractMethod.apply(void 0, (0,src_to_consumable_array/* default */.Z)(methodArgs).concat([
                                hasManualGasPriceOverride ? (0,src_object_spread/* default */.Z)({}, overrides) : (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, overrides), {
                                    gasPrice: gasPrice
                                })
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,esm_exports/* addBreadcrumb */.n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        gasPrice
    ]);
    return {
        callWithGasPrice: callWithGasPrice
    };
}

;// CONCATENATED MODULE: ./src/hooks/useTokenAllowance.ts




function useTokenAllowance(token, owner, spender) {
    var contract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address, false);
    var inputs = (0,react.useMemo)(function() {
        return [
            owner,
            spender
        ];
    }, [
        owner,
        spender
    ]);
    var allowance = (0,multicall_hooks/* useSingleCallResult */.Wk)(contract, "allowance", inputs).result;
    return (0,react.useMemo)(function() {
        return token && allowance ? src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(token, allowance.toString()) : undefined;
    }, [
        token,
        allowance
    ]);
}
/* harmony default export */ var hooks_useTokenAllowance = (useTokenAllowance);

;// CONCATENATED MODULE: ./src/hooks/useApproveCallback.ts

















var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(amountToApprove, spender) {
    var ref;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var callWithGasPrice = useCallWithGasPrice().callWithGasPrice;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var toastError = (0,useToast/* useToast */.p)().toastError;
    var token = (amountToApprove === null || amountToApprove === void 0 ? void 0 : (ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isToken) ? amountToApprove.currency : undefined;
    var currentAllowance = hooks_useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
    var pendingApproval = (0,transactions_hooks/* useHasPendingApproval */.wB)(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        var ref;
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if ((ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isNative) return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        pendingApproval,
        spender
    ]);
    var tokenContract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var approve = (0,react.useCallback)(/*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var useExact, estimatedGas;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (approvalState !== ApprovalState.NOT_APPROVED) {
                        toastError(t("Error"), t("Approve was called unnecessarily"));
                        console.error("approve was called unnecessarily");
                        return [
                            2
                        ];
                    }
                    if (!token) {
                        toastError(t("Error"), t("No token"));
                        console.error("no token");
                        return [
                            2
                        ];
                    }
                    if (!tokenContract) {
                        toastError(t("Error"), t("Cannot find contract of the token %tokenAddress%", {
                            tokenAddress: token === null || token === void 0 ? void 0 : token.address
                        }));
                        console.error("tokenContract is null");
                        return [
                            2
                        ];
                    }
                    if (!amountToApprove) {
                        toastError(t("Error"), t("Missing amount to approve"));
                        console.error("missing amount to approve");
                        return [
                            2
                        ];
                    }
                    if (!spender) {
                        toastError(t("Error"), t("No spender"));
                        console.error("no spender");
                        return [
                            2
                        ];
                    }
                    useExact = false;
                    return [
                        4,
                        tokenContract.estimateGas.approve(spender, bignumbers/* MaxUint256 */.Bz).catch(function() {
                            // general fallback for tokens who restrict approval amounts
                            useExact = true;
                            return tokenContract.estimateGas.approve(spender, amountToApprove.quotient.toString());
                        })
                    ];
                case 1:
                    estimatedGas = _state.sent();
                    // eslint-disable-next-line consistent-return
                    return [
                        2,
                        callWithGasPrice(tokenContract, "approve", [
                            spender,
                            useExact ? amountToApprove.quotient.toString() : bignumbers/* MaxUint256 */.Bz
                        ], {
                            gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGas)
                        }).then(function(response) {
                            addTransaction(response, {
                                summary: "Approve ".concat(amountToApprove.currency.symbol),
                                translatableSummary: {
                                    text: "Approve %symbol%",
                                    data: {
                                        symbol: amountToApprove.currency.symbol
                                    }
                                },
                                approval: {
                                    tokenAddress: token.address,
                                    spender: spender
                                },
                                type: "approve"
                            });
                        }).catch(function(error) {
                            logError(error);
                            console.error("Failed to approve token", error);
                            if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                                toastError(t("Error"), error.message);
                            }
                            throw error;
                        })
                    ];
            }
        });
    }), [
        approvalState,
        token,
        tokenContract,
        amountToApprove,
        spender,
        addTransaction,
        callWithGasPrice,
        t,
        toastError
    ]);
    return [
        approvalState,
        approve
    ];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, chainId = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? computeSlippageAdjustedAmounts(trade, allowedSlippage)[swap_actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    return useApproveCallback(amountToApprove, exchange/* ROUTER_ADDRESS */.bR[chainId]);
}
// Wraps useApproveCallback in the context of a Gelato Limit Orders
function useApproveCallbackFromInputCurrencyAmount(currencyAmountIn) {
    var gelatoLibrary = useGelatoLimitOrdersLib();
    var _address;
    return useApproveCallback(currencyAmountIn, (_address = gelatoLibrary === null || gelatoLibrary === void 0 ? void 0 : gelatoLibrary.erc20OrderRouter.address) !== null && _address !== void 0 ? _address : undefined);
}

;// CONCATENATED MODULE: ./src/hooks/useWrapCallback.ts











var WrapType;
(function(WrapType) {
    WrapType[WrapType["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
    WrapType[WrapType["WRAP"] = 1] = "WRAP";
    WrapType[WrapType["UNWRAP"] = 2] = "UNWRAP";
})(WrapType || (WrapType = {}));
var NOT_APPLICABLE = {
    wrapType: WrapType.NOT_APPLICABLE
};
/**
 * Given the selected input and output currency, return a wrap callback
 * @param inputCurrency the selected input currency
 * @param outputCurrency the selected output currency
 * @param typedValue the user input value
 */ function useWrapCallback(inputCurrency, outputCurrency, typedValue) {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    var callWithGasPrice = useCallWithGasPrice().callWithGasPrice;
    var wbnbContract = (0,useContract/* useWNativeContract */.vR)();
    var balance = useCurrencyBalance(account !== null && account !== void 0 ? account : undefined, inputCurrency);
    // we can always parse the amount typed as the input currency, since wrapping is 1:1
    var inputAmount = (0,react.useMemo)(function() {
        return utils_tryParseAmount(typedValue, inputCurrency);
    }, [
        inputCurrency,
        typedValue
    ]);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    return (0,react.useMemo)(function() {
        var ref, ref1;
        if (!wbnbContract || !chainId || !inputCurrency || !outputCurrency) return NOT_APPLICABLE;
        var sufficientBalance = inputAmount && balance && !balance.lessThan(inputAmount);
        if ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.isNative) && ((ref = src/* WNATIVE */.FX[chainId]) === null || ref === void 0 ? void 0 : ref.equals(outputCurrency))) {
            return {
                wrapType: WrapType.WRAP,
                execute: sufficientBalance && inputAmount ? /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    var txReceipt, amount, native, wrap, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callWithGasPrice(wbnbContract, "deposit", undefined, {
                                        value: "0x".concat(inputAmount.quotient.toString(16))
                                    })
                                ];
                            case 1:
                                txReceipt = _state.sent();
                                amount = inputAmount.toSignificant(6);
                                native = inputCurrency.symbol;
                                wrap = src/* WNATIVE */.FX[chainId].symbol;
                                addTransaction(txReceipt, {
                                    summary: "Wrap ".concat(amount, " ").concat(native, " to ").concat(wrap),
                                    translatableSummary: {
                                        text: "Wrap %amount% %native% to %wrap%",
                                        data: {
                                            amount: amount,
                                            native: native,
                                            wrap: wrap
                                        }
                                    },
                                    type: "wrap"
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Could not deposit", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }) : undefined,
                inputError: sufficientBalance ? undefined : t("Insufficient %symbol% balance", {
                    symbol: inputCurrency.symbol
                })
            };
        }
        if (((ref1 = src/* WNATIVE */.FX[chainId]) === null || ref1 === void 0 ? void 0 : ref1.equals(inputCurrency)) && (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.isNative)) {
            return {
                wrapType: WrapType.UNWRAP,
                execute: sufficientBalance && inputAmount ? /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                    var txReceipt, amount, wrap, native, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callWithGasPrice(wbnbContract, "withdraw", [
                                        "0x".concat(inputAmount.quotient.toString(16))
                                    ])
                                ];
                            case 1:
                                txReceipt = _state.sent();
                                amount = inputAmount.toSignificant(6);
                                wrap = src/* WNATIVE */.FX[chainId].symbol;
                                native = outputCurrency.symbol;
                                addTransaction(txReceipt, {
                                    summary: "Unwrap ".concat(amount, " ").concat(wrap, " to ").concat(native),
                                    translatableSummary: {
                                        text: "Unwrap %amount% %wrap% to %native%",
                                        data: {
                                            amount: amount,
                                            wrap: wrap,
                                            native: native
                                        }
                                    }
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Could not withdraw", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }) : undefined,
                inputError: sufficientBalance ? undefined : t("Insufficient %symbol% balance", {
                    symbol: inputCurrency.symbol
                })
            };
        }
        return NOT_APPLICABLE;
    }, [
        wbnbContract,
        chainId,
        inputCurrency,
        outputCurrency,
        t,
        inputAmount,
        balance,
        addTransaction,
        callWithGasPrice
    ]);
}

// EXTERNAL MODULE: ./packages/utils/replaceBrowserHistory.ts
var replaceBrowserHistory = __webpack_require__(36399);
;// CONCATENATED MODULE: ./src/utils/currencyId.ts
function currencyId(currency) {
    var ref;
    if (currency === null || currency === void 0 ? void 0 : currency.isNative) return (ref = currency.symbol) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    if (currency === null || currency === void 0 ? void 0 : currency.isToken) return currency.address;
    throw new Error("invalid currency");
}
/* harmony default export */ var utils_currencyId = ((/* unused pure expression or super */ null && (currencyId)));

// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot_NotificationDot = __webpack_require__(85765);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./src/components/Svg/RefreshIcon.tsx





// NOTE: Temporary save icon here. Will move to uikit when the feature is done
var DisabledIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        id: "arrow_loading",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "none",
                fill: "#D7CAEC",
                d: "M16.2751 7.78995C13.932 5.44681 10.133 5.44681 7.78986 7.78995C7.02853 8.55128 6.51457 9.4663 6.24798 10.4351C6.24473 10.4499 6.24114 10.4646 6.23719 10.4793C6.17635 10.7064 6.12938 10.9339 6.09577 11.161C5.83159 12.9457 6.39255 14.7026 7.52624 15.9944C7.61054 16.0901 7.69842 16.1838 7.78986 16.2752C8.08307 16.5685 8.39909 16.825 8.7322 17.0448C9.25533 17.3892 9.84172 17.6568 10.4798 17.8278C10.7386 17.8971 10.9979 17.9484 11.2565 17.9825C12.9537 18.2061 14.6187 17.6866 15.8747 16.6415C16.0123 16.5265 16.1459 16.4044 16.2751 16.2752C16.2848 16.2655 16.2947 16.2561 16.3047 16.2469C17.0123 15.531 17.5491 14.627 17.8283 13.5851C17.9712 13.0517 18.5196 12.7351 19.053 12.878C19.5865 13.021 19.9031 13.5693 19.7602 14.1028C19.3141 15.7676 18.3745 17.1684 17.1409 18.1899C16.1883 18.9822 15.0949 19.5189 13.9515 19.8002C11.8607 20.3147 9.6028 19.9749 7.7328 18.7809C7.06855 18.3579 6.47841 17.8432 5.97519 17.2589C5.12341 16.2738 4.55173 15.1302 4.26015 13.9324C4.01698 12.9416 3.96104 11.8931 4.12168 10.8379C4.36697 9.20484 5.1183 7.63309 6.37564 6.37574C9.49984 3.25154 14.5652 3.25154 17.6894 6.37574L18.2332 6.91959L18.2337 5.49951C18.2338 5.05769 18.5921 4.69964 19.034 4.69979C19.4758 4.69995 19.8338 5.05825 19.8337 5.50007L19.8325 9.03277L19.8322 9.8325L19.0325 9.83249L18.9401 9.83249C18.8146 9.85665 18.6854 9.85665 18.5599 9.83248L15.5005 9.83245C15.0587 9.83245 14.7005 9.47427 14.7005 9.03244C14.7005 8.59062 15.0587 8.23245 15.5005 8.23245L16.7176 8.23246L16.2751 7.78995Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "arrow",
                        stroke: "none",
                        fill: "none",
                        d: "M16.2751 7.78995C13.932 5.44681 10.133 5.44681 7.78986 7.78995C7.02853 8.55128 6.51457 9.4663 6.24798 10.4351C6.24473 10.4499 6.24114 10.4646 6.23719 10.4793C6.17635 10.7064 6.12938 10.9339 6.09577 11.161C5.83159 12.9457 6.39255 14.7026 7.52624 15.9944C7.61054 16.0901 7.69842 16.1838 7.78986 16.2752C8.08307 16.5685 8.39909 16.825 8.7322 17.0448C9.25533 17.3892 9.84172 17.6568 10.4798 17.8278C10.7386 17.8971 10.9979 17.9484 11.2565 17.9825C12.9537 18.2061 14.6187 17.6866 15.8747 16.6415C16.0123 16.5265 16.1459 16.4044 16.2751 16.2752C16.2848 16.2655 16.2947 16.2561 16.3047 16.2469C17.0123 15.531 17.5491 14.627 17.8283 13.5851C17.9712 13.0517 18.5196 12.7351 19.053 12.878C19.5865 13.021 19.9031 13.5693 19.7602 14.1028C19.3141 15.7676 18.3745 17.1684 17.1409 18.1899C16.1883 18.9822 15.0949 19.5189 13.9515 19.8002C11.8607 20.3147 9.6028 19.9749 7.7328 18.7809C7.06855 18.3579 6.47841 17.8432 5.97519 17.2589C5.12341 16.2738 4.55173 15.1302 4.26015 13.9324C4.01698 12.9416 3.96104 11.8931 4.12168 10.8379C4.36697 9.20484 5.1183 7.63309 6.37564 6.37574C9.49984 3.25154 14.5652 3.25154 17.6894 6.37574L18.2332 6.91959L18.2337 5.49951C18.2338 5.05769 18.5921 4.69964 19.034 4.69979C19.4758 4.69995 19.8338 5.05825 19.8337 5.50007L19.8325 9.03277L19.8322 9.8325L19.0325 9.83249L18.9401 9.83249C18.8146 9.85665 18.6854 9.85665 18.5599 9.83248L15.5005 9.83245C15.0587 9.83245 14.7005 9.47427 14.7005 9.03244C14.7005 8.59062 15.0587 8.23245 15.5005 8.23245L16.7176 8.23246L16.2751 7.78995Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "arrow-clip",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#arrow"
                        })
                    })
                ]
            })
        ]
    }));
};
var Icon = function(_param) {
    var disabled = _param.disabled, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "disabled"
    ]);
    return disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisabledIcon, (0,src_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        id: "arrow_loading",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "none",
                fill: "#7A6EAA",
                d: "M16.2751 7.78995C13.932 5.44681 10.133 5.44681 7.78986 7.78995C7.02853 8.55128 6.51457 9.4663 6.24798 10.4351C6.24473 10.4499 6.24114 10.4646 6.23719 10.4793C6.17635 10.7064 6.12938 10.9339 6.09577 11.161C5.83159 12.9457 6.39255 14.7026 7.52624 15.9944C7.61054 16.0901 7.69842 16.1838 7.78986 16.2752C8.08307 16.5685 8.39909 16.825 8.7322 17.0448C9.25533 17.3892 9.84172 17.6568 10.4798 17.8278C10.7386 17.8971 10.9979 17.9484 11.2565 17.9825C12.9537 18.2061 14.6187 17.6866 15.8747 16.6415C16.0123 16.5265 16.1459 16.4044 16.2751 16.2752C16.2848 16.2655 16.2947 16.2561 16.3047 16.2469C17.0123 15.531 17.5491 14.627 17.8283 13.5851C17.9712 13.0517 18.5196 12.7351 19.053 12.878C19.5865 13.021 19.9031 13.5693 19.7602 14.1028C19.3141 15.7676 18.3745 17.1684 17.1409 18.1899C16.1883 18.9822 15.0949 19.5189 13.9515 19.8002C11.8607 20.3147 9.6028 19.9749 7.7328 18.7809C7.06855 18.3579 6.47841 17.8432 5.97519 17.2589C5.12341 16.2738 4.55173 15.1302 4.26015 13.9324C4.01698 12.9416 3.96104 11.8931 4.12168 10.8379C4.36697 9.20484 5.1183 7.63309 6.37564 6.37574C9.49984 3.25154 14.5652 3.25154 17.6894 6.37574L18.2332 6.91959L18.2337 5.49951C18.2338 5.05769 18.5921 4.69964 19.034 4.69979C19.4758 4.69995 19.8338 5.05825 19.8337 5.50007L19.8325 9.03277L19.8322 9.8325L19.0325 9.83249L18.9401 9.83249C18.8146 9.85665 18.6854 9.85665 18.5599 9.83248L15.5005 9.83245C15.0587 9.83245 14.7005 9.47427 14.7005 9.03244C14.7005 8.59062 15.0587 8.23245 15.5005 8.23245L16.7176 8.23246L16.2751 7.78995Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "arrow",
                        stroke: "none",
                        fill: "none",
                        d: "M16.2751 7.78995C13.932 5.44681 10.133 5.44681 7.78986 7.78995C7.02853 8.55128 6.51457 9.4663 6.24798 10.4351C6.24473 10.4499 6.24114 10.4646 6.23719 10.4793C6.17635 10.7064 6.12938 10.9339 6.09577 11.161C5.83159 12.9457 6.39255 14.7026 7.52624 15.9944C7.61054 16.0901 7.69842 16.1838 7.78986 16.2752C8.08307 16.5685 8.39909 16.825 8.7322 17.0448C9.25533 17.3892 9.84172 17.6568 10.4798 17.8278C10.7386 17.8971 10.9979 17.9484 11.2565 17.9825C12.9537 18.2061 14.6187 17.6866 15.8747 16.6415C16.0123 16.5265 16.1459 16.4044 16.2751 16.2752C16.2848 16.2655 16.2947 16.2561 16.3047 16.2469C17.0123 15.531 17.5491 14.627 17.8283 13.5851C17.9712 13.0517 18.5196 12.7351 19.053 12.878C19.5865 13.021 19.9031 13.5693 19.7602 14.1028C19.3141 15.7676 18.3745 17.1684 17.1409 18.1899C16.1883 18.9822 15.0949 19.5189 13.9515 19.8002C11.8607 20.3147 9.6028 19.9749 7.7328 18.7809C7.06855 18.3579 6.47841 17.8432 5.97519 17.2589C5.12341 16.2738 4.55173 15.1302 4.26015 13.9324C4.01698 12.9416 3.96104 11.8931 4.12168 10.8379C4.36697 9.20484 5.1183 7.63309 6.37564 6.37574C9.49984 3.25154 14.5652 3.25154 17.6894 6.37574L18.2332 6.91959L18.2337 5.49951C18.2338 5.05769 18.5921 4.69964 19.034 4.69979C19.4758 4.69995 19.8338 5.05825 19.8337 5.50007L19.8325 9.03277L19.8322 9.8325L19.0325 9.83249L18.9401 9.83249C18.8146 9.85665 18.6854 9.85665 18.5599 9.83248L15.5005 9.83245C15.0587 9.83245 14.7005 9.47427 14.7005 9.03244C14.7005 8.59062 15.0587 8.23245 15.5005 8.23245L16.7176 8.23246L16.2751 7.78995Z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "arrow-clip",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            xlinkHref: "#arrow"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#arrow-clip)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "5",
                    transform: "rotate(365,12,12)",
                    fill: "none",
                    stroke: "#D7CAEC",
                    strokeWidth: "16",
                    strokeDasharray: "30",
                    strokeDashoffset: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "stroke-dashoffset",
                        values: "0;-30",
                        begin: "arrow_loading.click; 0.7s",
                        repeatCount: "indefinite",
                        dur: "6.3s"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                xlinkHref: "#arrow"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_0",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "0 0 0",
                to: "-10 0 0",
                dur: "0.07s",
                begin: "arrow_loading.click;",
                repeatCount: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_1",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "-45 0 0",
                to: "390 0 0",
                dur: "0.6s",
                begin: "transform_0.end",
                repeatCount: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                id: "transform_2",
                attributeName: "transform",
                attributeType: "XML",
                type: "rotate",
                from: "390 0 0",
                to: "360 0 0",
                dur: "0.15s",
                begin: "transform_1.end",
                repeatCount: "1"
            })
        ]
    }));
};
/* harmony default export */ var RefreshIcon = (Icon);

;// CONCATENATED MODULE: ./src/views/Swap/components/CurrencyInputHeader.tsx


function CurrencyInputHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  width: 100%;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    CurrencyInputHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CurrencyInputHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    CurrencyInputHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var CurrencyInputContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-f6dc2d70-0"
})(CurrencyInputHeader_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var ColoredIconButton = (0,styled_components_browser_esm/* default */.ZP)(Button_IconButton/* default */.Z).withConfig({
    componentId: "sc-f6dc2d70-1"
})(CurrencyInputHeader_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var CurrencyInputHeader = function(param) {
    var title = param.title, subtitle = param.subtitle, setIsChartDisplayed = param.setIsChartDisplayed, isChartDisplayed = param.isChartDisplayed, hasAmount = param.hasAmount, onRefreshPrice = param.onRefreshPrice;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 1), expertMode = ref[0];
    var toggleChartDisplayed = function() {
        setIsChartDisplayed(function(currentIsChartDisplayed) {
            return !currentIsChartDisplayed;
        });
    };
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Transactions_TransactionsModal, {})), 1), onPresentTransactionsModal = ref1[0];
    var handleOnClick = (0,react.useCallback)(function() {
        return onRefreshPrice === null || onRefreshPrice === void 0 ? void 0 : onRefreshPrice();
    }, [
        onRefreshPrice
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CurrencyInputContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        flexDirection: "column",
                        alignItems: "flex-end",
                        width: "100%",
                        mr: 18,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading/* default */.Z, {
                            as: "h2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot_NotificationDot/* default */.Z, {
                                show: expertMode,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_GlobalSettings/* default */.Z, {
                                    color: "textSubtle",
                                    mr: "0",
                                    mode: GlobalSettings_types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_IconButton/* default */.Z, {
                                variant: "text",
                                scale: "sm",
                                onClick: handleOnClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIcon, {
                                    disabled: !hasAmount,
                                    color: "textSubtle",
                                    width: "27px"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                alignItems: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                    color: "textSubtle",
                    fontSize: "14px",
                    children: subtitle
                })
            })
        ]
    });
};
/* harmony default export */ var components_CurrencyInputHeader = (CurrencyInputHeader);

// EXTERNAL MODULE: ./src/hooks/useSwitchNetworkLoading.ts
var useSwitchNetworkLoading = __webpack_require__(95579);
// EXTERNAL MODULE: ./src/components/NetworkModal/index.ts + 5 modules
var NetworkModal = __webpack_require__(92963);
// EXTERNAL MODULE: ./src/components/Trans.tsx
var Trans = __webpack_require__(4369);
;// CONCATENATED MODULE: ./src/components/CommitButton.tsx










var wrongNetworkProps = {
    variant: "danger",
    disabled: false,
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
        children: "Wrong Network"
    })
};
var CommitButton = function(props) {
    var isWrongNetwork = (0,useActiveChainId/* useActiveChainId */.gi)().isWrongNetwork;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,useSwitchNetworkLoading/* useSwitchNetworkLoading */.c)(), 1), switchNetworkLoading = ref[0];
    var setHideWrongNetwork = (0,esm/* useSetAtom */.b9)(NetworkModal/* hideWrongNetworkModalAtom */.v);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        onClick: function(e) {
            if (isWrongNetwork) {
                setHideWrongNetwork(false);
            } else {
                var ref;
                (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
            }
        }
    }), switchNetworkLoading && {
        disabled: true
    }, isWrongNetwork && wrongNetworkProps));
};

// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/SettingsModal.tsx + 3 modules
var SettingsModal = __webpack_require__(61967);
;// CONCATENATED MODULE: ./packages/utils/isZero.ts
/**
 * Returns true if the string value is zero in hex
 * @param hexNumberString
 */ function isZero(hexNumberString) {
    return /^0x0*$/.test(hexNumberString);
}

;// CONCATENATED MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
/**
 * This is hacking out the revert reason from the ethers provider thrown error however it can.
 * This object seems to be undocumented by ethers.
 * @param error an error from the ethers provider
 * @param t Translation function
 */ function transactionErrorToUserReadableMessage(error, t) {
    var reason;
    while(error){
        var ref, ref1;
        var _reason, ref2, ref3;
        reason = (ref3 = (ref2 = (_reason = error.reason) !== null && _reason !== void 0 ? _reason : (ref = error.data) === null || ref === void 0 ? void 0 : ref.message) !== null && ref2 !== void 0 ? ref2 : error.message) !== null && ref3 !== void 0 ? ref3 : reason;
        var _error;
        // eslint-disable-next-line no-param-reassign
        error = (_error = error.error) !== null && _error !== void 0 ? _error : (ref1 = error.data) === null || ref1 === void 0 ? void 0 : ref1.originalError;
    }
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("execution reverted: ")) === 0) reason = reason.substring("execution reverted: ".length);
    switch(reason){
        case "PancakeRouter: EXPIRED":
            return t("The transaction could not be sent because the deadline has passed. Please check that your transaction deadline is not too low.");
        case "PancakeRouter: INSUFFICIENT_OUTPUT_AMOUNT":
        case "PancakeRouter: EXCESSIVE_INPUT_AMOUNT":
        case "PancakeRouter: INSUFFICIENT_A_AMOUNT":
        case "PancakeRouter: INSUFFICIENT_B_AMOUNT":
            return t("This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.");
        case "TransferHelper: TRANSFER_FROM_FAILED":
            return t("The input token cannot be transferred. There may be an issue with the input token.");
        case "Pancake: TRANSFER_FAILED":
            return t("The output token cannot be transferred. There may be an issue with the output token.");
        default:
            if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("undefined is not an object")) !== -1) {
                console.error(error, reason);
                return t("An error occurred when trying to execute this operation. You may need to increase your slippage tolerance. If that does not work, there may be an incompatibility with the token you are trading.");
            }
            return t("Unknown error%reason%. Try increasing your slippage tolerance.", {
                reason: reason ? ': "'.concat(reason, '"') : ""
            });
    }
}

;// CONCATENATED MODULE: ./src/hooks/useSwapCallback.ts
















var SwapCallbackState;
(function(SwapCallbackState) {
    SwapCallbackState[SwapCallbackState["INVALID"] = 0] = "INVALID";
    SwapCallbackState[SwapCallbackState["LOADING"] = 1] = "LOADING";
    SwapCallbackState[SwapCallbackState["VALID"] = 2] = "VALID";
})(SwapCallbackState || (SwapCallbackState = {}));
// returns a function that will execute a swap, if the parameters are all valid
// and the user has approved the slippage adjusted input amount for the trade
function useSwapCallback(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* INITIAL_ALLOWED_SLIPPAGE */.gv, recipientAddress = arguments.length > 2 ? arguments[2] : void 0, swapCalls = arguments.length > 3 ? arguments[3] : void 0;
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var gasPrice = (0,hooks/* useGasPrice */.Fh)();
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var recipient = recipientAddress === null ? account : recipientAddress;
    return (0,react.useMemo)(function() {
        if (!trade || !account || !chainId) {
            return {
                state: SwapCallbackState.INVALID,
                callback: null,
                error: "Missing dependencies"
            };
        }
        if (!recipient) {
            if (recipientAddress !== null) {
                return {
                    state: SwapCallbackState.INVALID,
                    callback: null,
                    error: "Invalid recipient"
                };
            }
            return {
                state: SwapCallbackState.LOADING,
                callback: null,
                error: null
            };
        }
        return {
            state: SwapCallbackState.VALID,
            callback: function() {
                var _onSwap = (0,src_async_to_generator/* default */.Z)(function() {
                    var _contract, estimatedCalls, successfulEstimation, errorCalls, _call, contract, _parameters, methodName, args, value, gasEstimate;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(swapCalls.map(function(call) {
                                        var _estimateGas;
                                        var _parameters = call.parameters, methodName = _parameters.methodName, args = _parameters.args, value = _parameters.value, contract = call.contract;
                                        var options = !value || isZero(value) ? {} : {
                                            value: value
                                        };
                                        return (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,src_to_consumable_array/* default */.Z)(args).concat([
                                            options
                                        ])).then(function(gasEstimate) {
                                            return {
                                                call: call,
                                                gasEstimate: gasEstimate
                                            };
                                        }).catch(function(gasError) {
                                            var _callStatic;
                                            console.error("Gas estimate failed, trying eth_call to extract error", call);
                                            return (_callStatic = contract.callStatic)[methodName].apply(_callStatic, (0,src_to_consumable_array/* default */.Z)(args).concat([
                                                options
                                            ])).then(function(result) {
                                                console.error("Unexpected successful call after failed estimate gas", call, gasError, result);
                                                return {
                                                    call: call,
                                                    error: t("Unexpected issue with estimating the gas. Please try again.")
                                                };
                                            }).catch(function(callError) {
                                                console.error("Call threw error", call, callError);
                                                return {
                                                    call: call,
                                                    error: transactionErrorToUserReadableMessage(callError, t)
                                                };
                                            });
                                        });
                                    }))
                                ];
                            case 1:
                                estimatedCalls = _state.sent();
                                successfulEstimation = estimatedCalls.find(function(el, ix, list) {
                                    return "gasEstimate" in el && (ix === list.length - 1 || "gasEstimate" in list[ix + 1]);
                                });
                                if (!successfulEstimation) {
                                    errorCalls = estimatedCalls.filter(function(call) {
                                        return "error" in call;
                                    });
                                    if (errorCalls.length > 0) throw new Error(errorCalls[errorCalls.length - 1].error);
                                    throw new Error(t("Unexpected error. Could not estimate gas for the swap."));
                                }
                                _call = successfulEstimation.call, contract = _call.contract, _parameters = _call.parameters, methodName = _parameters.methodName, args = _parameters.args, value = _parameters.value, gasEstimate = successfulEstimation.gasEstimate;
                                return [
                                    2,
                                    (_contract = contract)[methodName].apply(_contract, (0,src_to_consumable_array/* default */.Z)(args).concat([
                                        (0,src_object_spread/* default */.Z)({
                                            gasLimit: (0,utils/* calculateGasMargin */.yC)(gasEstimate),
                                            gasPrice: gasPrice
                                        }, value && !isZero(value) ? {
                                            value: value,
                                            from: account
                                        } : {
                                            from: account
                                        })
                                    ])).then(function(response) {
                                        var inputSymbol = trade.inputAmount.currency.symbol;
                                        var outputSymbol = trade.outputAmount.currency.symbol;
                                        var pct = basisPointsToPercent(allowedSlippage);
                                        var inputAmount = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.inputAmount.toSignificant(3) : trade.maximumAmountIn(pct).toSignificant(3);
                                        var outputAmount = trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? trade.outputAmount.toSignificant(3) : trade.minimumAmountOut(pct).toSignificant(3);
                                        var base = "Swap ".concat(trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? "max." : "", " ").concat(inputAmount, " ").concat(inputSymbol, " for ").concat(trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? "min." : "", " ").concat(outputAmount, " ").concat(outputSymbol);
                                        var recipientAddressText = recipientAddress && (0,utils/* isAddress */.UJ)(recipientAddress) ? (0,truncateHash/* default */.Z)(recipientAddress) : recipientAddress;
                                        var withRecipient = recipient === account ? base : "".concat(base, " to ").concat(recipientAddressText);
                                        var translatableWithRecipient = trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? recipient === account ? "Swap max. %inputAmount% %inputSymbol% for %outputAmount% %outputSymbol%" : "Swap max. %inputAmount% %inputSymbol% for %outputAmount% %outputSymbol% to %recipientAddress%" : recipient === account ? "Swap %inputAmount% %inputSymbol% for min. %outputAmount% %outputSymbol%" : "Swap %inputAmount% %inputSymbol% for min. %outputAmount% %outputSymbol% to %recipientAddress%";
                                        addTransaction(response, {
                                            summary: withRecipient,
                                            translatableSummary: {
                                                text: translatableWithRecipient,
                                                data: (0,src_object_spread/* default */.Z)({
                                                    inputAmount: inputAmount,
                                                    inputSymbol: inputSymbol,
                                                    outputAmount: outputAmount,
                                                    outputSymbol: outputSymbol
                                                }, recipient !== account && {
                                                    recipientAddress: recipientAddressText
                                                })
                                            },
                                            type: "swap"
                                        });
                                        return response.hash;
                                    }).catch(function(error) {
                                        // if the user rejected the tx, pass this along
                                        if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                                            throw new Error("Transaction rejected.");
                                        } else {
                                            // otherwise, the error was unexpected and we need to convey that
                                            console.error("Swap failed", error, methodName, args, value);
                                            throw new Error(t("Swap failed: %message%", {
                                                message: transactionErrorToUserReadableMessage(error, t)
                                            }));
                                        }
                                    })
                                ];
                        }
                    });
                });
                function onSwap() {
                    return _onSwap.apply(this, arguments);
                }
                return onSwap;
            }(),
            error: null
        };
    }, [
        trade,
        account,
        chainId,
        recipient,
        recipientAddress,
        swapCalls,
        gasPrice,
        t,
        addTransaction,
        allowedSlippage
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/useCurrentBlockTimestamp.ts


// gets the current timestamp from the blockchain
function useCurrentBlockTimestamp() {
    var ref, ref1;
    var multicall = (0,useContract/* useMulticallContract */.gq)();
    return (ref = (0,multicall_hooks/* useSingleCallResult */.Wk)(multicall, "getCurrentBlockTimestamp")) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
}

;// CONCATENATED MODULE: ./src/hooks/useTransactionDeadline.ts



// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
function useTransactionDeadline() {
    var ttl = (0,es/* useSelector */.v9)(function(state) {
        return state.user.userDeadline;
    });
    var blockTimestamp = useCurrentBlockTimestamp();
    return (0,react.useMemo)(function() {
        if (blockTimestamp && ttl) return blockTimestamp.add(ttl);
        return undefined;
    }, [
        blockTimestamp,
        ttl
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/useSwapCallArguments.ts







/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName
 */ function useSwapCallArguments(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* INITIAL_ALLOWED_SLIPPAGE */.gv, recipientAddress = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var recipient = recipientAddress === null ? account : recipientAddress;
    var deadline = useTransactionDeadline();
    var contract = useRouterContract();
    return (0,react.useMemo)(function() {
        if (!trade || !recipient || !account || !chainId || !deadline) return [];
        if (!contract) {
            return [];
        }
        var swapMethods = [];
        swapMethods.push(src/* Router.swapCallParameters */.F0.swapCallParameters(trade, {
            feeOnTransfer: false,
            allowedSlippage: new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(allowedSlippage), exchange/* BIPS_BASE */.PM),
            recipient: recipient,
            deadline: deadline.toNumber()
        }));
        if (trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT) {
            swapMethods.push(src/* Router.swapCallParameters */.F0.swapCallParameters(trade, {
                feeOnTransfer: true,
                allowedSlippage: new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(allowedSlippage), exchange/* BIPS_BASE */.PM),
                recipient: recipient,
                deadline: deadline.toNumber()
            }));
        }
        return swapMethods.map(function(parameters) {
            return {
                parameters: parameters,
                contract: contract
            };
        });
    }, [
        account,
        allowedSlippage,
        chainId,
        contract,
        deadline,
        recipient,
        trade
    ]);
}

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(40696);
;// CONCATENATED MODULE: ./src/components/TransactionConfirmationModal/index.tsx





function TransactionConfirmationModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    TransactionConfirmationModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TransactionConfirmationModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n"
    ]);
    TransactionConfirmationModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TransactionConfirmationModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0;\n"
    ]);
    TransactionConfirmationModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var TransactionConfirmationModal_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30c0a7b0-0"
})(TransactionConfirmationModal_templateObject());
var Section = (0,styled_components_browser_esm/* default */.ZP)(Column_AutoColumn).withConfig({
    componentId: "sc-30c0a7b0-1"
})(TransactionConfirmationModal_templateObject1());
var ConfirmedIcon = (0,styled_components_browser_esm/* default */.ZP)(ColumnCenter).withConfig({
    componentId: "sc-30c0a7b0-2"
})(TransactionConfirmationModal_templateObject2());
function ConfirmationPendingContent(param) {
    var pendingText = param.pendingText;
    var t = useTranslation().t;
    return /*#__PURE__*/ _jsxs(TransactionConfirmationModal_Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(ConfirmedIcon, {
                children: /*#__PURE__*/ _jsx(Spinner, {})
            }),
            /*#__PURE__*/ _jsxs(AutoColumn, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        fontSize: "20px",
                        children: t("Waiting For Confirmation")
                    }),
                    /*#__PURE__*/ _jsx(AutoColumn, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ _jsx(Text, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
function TransactionSubmittedContent(param) {
    var onDismiss = param.onDismiss, chainId = param.chainId, hash = param.hash, currencyToAdd = param.currencyToAdd;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var token = (0,utils_wrappedCurrency/* wrappedCurrency */.pu)(currencyToAdd, chainId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmedIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                        strokeWidth: 0.5,
                        width: "90px",
                        color: "primary"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                    gap: "12px",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "20px",
                            children: t("Transaction Submitted")
                        }),
                        chainId && hash && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                            external: true,
                            small: true,
                            href: (0,utils/* getBlockExploreLink */.C)(hash, "transaction", chainId),
                            children: t("View on %site%", {
                                site: (0,utils/* getBlockExploreName */.X0)(chainId)
                            })
                        }),
                        currencyToAdd && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWallet_AddToWalletButton, {
                            variant: "tertiary",
                            mt: "12px",
                            width: "fit-content",
                            marginTextBetweenLogo: "6px",
                            textOptions: AddToWalletTextOptions.TEXT_WITH_ASSET,
                            tokenAddress: token.address,
                            tokenSymbol: currencyToAdd.symbol,
                            tokenDecimals: token.decimals,
                            tokenLogo: (0,_instanceof/* default */.Z)(token, tokens_src/* WrappedTokenInfo */.DT) ? token.logoURI : undefined
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: onDismiss,
                            mt: "20px",
                            children: t("Close")
                        })
                    ]
                })
            ]
        })
    });
}
function ConfirmationModalContent(param) {
    var bottomContent = param.bottomContent, topContent = param.topContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionConfirmationModal_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: topContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: bottomContent()
            })
        ]
    });
}
function TransactionErrorContent(param) {
    var message = param.message, onDismiss = param.onDismiss;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionConfirmationModal_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                        color: "failure",
                        width: "64px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        color: "failure",
                        style: {
                            textAlign: "center",
                            width: "85%",
                            wordBreak: "break-word"
                        },
                        children: message
                    })
                ]
            }),
            onDismiss ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                justifyContent: "center",
                pt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: onDismiss,
                    children: t("Dismiss")
                })
            }) : null
        ]
    });
}
var TransactionConfirmationModal = function(_param) {
    var title = _param.title, onDismiss = _param.onDismiss, customOnDismiss = _param.customOnDismiss, attemptingTxn = _param.attemptingTxn, hash = _param.hash, pendingText = _param.pendingText, content = _param.content, currencyToAdd = _param.currencyToAdd, props = _object_without_properties(_param, [
        "title",
        "onDismiss",
        "customOnDismiss",
        "attemptingTxn",
        "hash",
        "pendingText",
        "content",
        "currencyToAdd"
    ]);
    var chainId = useActiveWeb3React().chainId;
    var handleDismiss = useCallback(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    if (!chainId) return null;
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({
        title: title,
        headerBackground: "gradientCardHeader"
    }, props), {
        onDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ _jsx(ConfirmationPendingContent, {
            pendingText: pendingText
        }) : hash ? /*#__PURE__*/ _jsx(TransactionSubmittedContent, {
            chainId: chainId,
            hash: hash,
            onDismiss: handleDismiss,
            currencyToAdd: currencyToAdd
        }) : content()
    }));
};
/* harmony default export */ var components_TransactionConfirmationModal = ((/* unused pure expression or super */ null && (TransactionConfirmationModal)));

// EXTERNAL MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx
var Spinner_Spinner = __webpack_require__(72433);
;// CONCATENATED MODULE: ./src/views/Swap/components/ConfirmationPendingContent.tsx

function ConfirmationPendingContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    ConfirmationPendingContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConfirmationPendingContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0;\n"
    ]);
    ConfirmationPendingContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ConfirmationPendingContent_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fee24e72-0"
})(ConfirmationPendingContent_templateObject());
var ConfirmationPendingContent_ConfirmedIcon = (0,styled_components_browser_esm/* default */.ZP)(ColumnCenter).withConfig({
    componentId: "sc-fee24e72-1"
})(ConfirmationPendingContent_templateObject1());
function ConfirmationPendingContent_ConfirmationPendingContent(param) {
    var trade = param.trade;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref6, ref7, ref8, ref9;
    // text to show while loading
    var pendingText = t("Swapping %amountA% %symbolA% for %amountB% %symbolB%", {
        amountA: (ref6 = trade === null || trade === void 0 ? void 0 : (ref = trade.inputAmount) === null || ref === void 0 ? void 0 : ref.toSignificant(6)) !== null && ref6 !== void 0 ? ref6 : "",
        symbolA: (ref7 = trade === null || trade === void 0 ? void 0 : (ref1 = trade.inputAmount) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.currency) === null || ref2 === void 0 ? void 0 : ref2.symbol) !== null && ref7 !== void 0 ? ref7 : "",
        amountB: (ref8 = trade === null || trade === void 0 ? void 0 : (ref3 = trade.outputAmount) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "",
        symbolB: (ref9 = trade === null || trade === void 0 ? void 0 : (ref4 = trade.outputAmount) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.currency) === null || ref5 === void 0 ? void 0 : ref5.symbol) !== null && ref9 !== void 0 ? ref9 : ""
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmationPendingContent_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationPendingContent_ConfirmedIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner_Spinner/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        fontSize: "20px",
                        children: t("Waiting For Confirmation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_ConfirmationPendingContent = (ConfirmationPendingContent_ConfirmationPendingContent);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(63771);
;// CONCATENATED MODULE: ./src/views/Swap/components/styleds.tsx

function styleds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 1rem;\n"
    ]);
    styleds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styleds_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          :hover {\n            cursor: pointer;\n            opacity: 0.8;\n          }\n        "
    ]);
    styleds_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styleds_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px;\n\n  ",
        "\n"
    ]);
    styleds_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styleds_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    styleds_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styleds_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 22px;\n  width: 22px;\n  background-color: ",
        ";\n  border: none;\n  border-radius: 50%;\n  padding: 0.2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  margin-left: 0.4rem;\n  cursor: pointer;\n  color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n\n  :hover {\n    background-color: ",
        ";\n  }\n  :focus {\n    background-color: ",
        ";\n    outline: none;\n  }\n"
    ]);
    styleds_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styleds_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 220px;\n"
    ]);
    styleds_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styleds_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  font-size: 0.825rem;\n  width: 100%;\n  padding: 3rem 1.25rem 1rem 1rem;\n  margin-top: -2rem;\n  color: ",
        ";\n  z-index: -1;\n  p {\n    padding: 0;\n    margin: 0;\n    font-weight: 500;\n  }\n"
    ]);
    styleds_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styleds_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  border-radius: 12px;\n  min-width: 48px;\n  height: 48px;\n"
    ]);
    styleds_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0.5rem;\n  border-radius: 12px;\n  margin-top: 8px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var styleds_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-a638242f-0"
})(styleds_templateObject());
var ArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a638242f-1"
})(styleds_templateObject2(), function(param) {
    var clickable = param.clickable;
    return clickable ? (0,styled_components_browser_esm/* css */.iv)(styleds_templateObject1()) : null;
});
var ErrorText = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).withConfig({
    componentId: "sc-a638242f-2"
})(styleds_templateObject3(), function(param) {
    var theme = param.theme, severity = param.severity;
    return severity === 3 || severity === 4 ? theme.colors.failure : severity === 2 ? theme.colors.warning : severity === 1 ? theme.colors.text : theme.colors.success;
});
var StyledBalanceMaxMini = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a638242f-3"
})(styleds_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});
var TruncatedText = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).attrs({
    ellipsis: true
}).withConfig({
    componentId: "sc-a638242f-4"
})(styleds_templateObject5());
var SwapCallbackErrorInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a638242f-5"
})(styleds_templateObject6(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.failure33);
}, function(param) {
    var theme = param.theme;
    return theme.colors.failure;
});
var SwapCallbackErrorInnerAlertTriangle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a638242f-6"
})(styleds_templateObject7(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.failure33);
});
function SwapCallbackError(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwapCallbackErrorInner, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackErrorInnerAlertTriangle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                    width: "24px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: error
            })
        ]
    });
}
var SwapShowAcceptChanges = (0,styled_components_browser_esm/* default */.ZP)(Column_AutoColumn).withConfig({
    componentId: "sc-a638242f-7"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.warning33);
});

;// CONCATENATED MODULE: ./src/views/Swap/components/FormattedPriceImpact.tsx




/**
 * Formatted version of price impact text with warning colors
 */ function FormattedPriceImpact(param) {
    var priceImpact = param.priceImpact;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
        fontSize: "14px",
        severity: warningSeverity(priceImpact),
        children: priceImpact ? priceImpact.lessThan(exchange/* ONE_BIPS */.IS) ? "<0.01%" : "".concat(priceImpact.toFixed(2), "%") : "-"
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapModalFooter.tsx

function SwapModalFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  padding: 16px;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    SwapModalFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var SwapModalFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Column_AutoColumn).withConfig({
    componentId: "sc-9a8ec767-0"
})(SwapModalFooter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.radii.default;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
function SwapModalFooter(param) {
    var trade = param.trade, slippageAdjustedAmounts = param.slippageAdjustedAmounts, isEnoughInputBalance = param.isEnoughInputBalance, onConfirm = param.onConfirm, swapErrorMessage = param.swapErrorMessage, disabledConfirm = param.disabledConfirm;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(false), showInverted = ref2[0], setShowInverted = ref2[1];
    var ref3 = (0,react.useMemo)(function() {
        return computeTradePriceBreakdown(trade);
    }, [
        trade
    ]), priceImpactWithoutFee = ref3.priceImpactWithoutFee, realizedLPFee = ref3.realizedLPFee;
    var severity = warningSeverity(priceImpactWithoutFee);
    var totalFeePercent = "".concat((TOTAL_FEE * 100).toFixed(2), "%");
    var lpHoldersFeePercent = "".concat((LP_HOLDERS_FEE * 100).toFixed(2), "%");
    var treasuryFeePercent = "".concat((TREASURY_FEE * 100).toFixed(4), "%");
    var buyBackFeePercent = "".concat((BUYBACK_FEE * 100).toFixed(4), "%");
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwapModalFooterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                children: t("Price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                style: {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    textAlign: "right",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    formatExecutionPrice(trade, showInverted),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                                        onClick: function() {
                                            return setShowInverted(!showInverted);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                            width: "14px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Minimum received") : t("Maximum sold")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHelper/* default */.Z, {
                                        text: t("Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref4 = (ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(4)) !== null && ref4 !== void 0 ? ref4 : "-" : (ref5 = (ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(4)) !== null && ref5 !== void 0 ? ref5 : "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "14px",
                                        marginLeft: "4px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: t("Price Impact")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHelper/* default */.Z, {
                                        text: t("The difference between the market price and your price due to trade size."),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedPriceImpact, {
                                priceImpact: priceImpactWithoutFee
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    fontSize: "14px",
                                    children: t("Liquidity Provider Fee")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                children: realizedLPFee ? "".concat(realizedLPFee === null || realizedLPFee === void 0 ? void 0 : realizedLPFee.toSignificant(6), " ").concat(trade.inputAmount.currency.symbol) : "-"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: severity > 2 ? "danger" : "primary",
                        onClick: onConfirm,
                        disabled: disabledConfirm,
                        mt: "12px",
                        id: "confirm-swap-or-send",
                        width: "100%",
                        children: severity > 2 || trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance ? t("Swap Anyway") : t("Confirm Swap")
                    }),
                    swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                        error: swapErrorMessage
                    }) : null
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapModalHeader.tsx













function SwapModalHeader(param) {
    var trade = param.trade, slippageAdjustedAmounts = param.slippageAdjustedAmounts, isEnoughInputBalance = param.isEnoughInputBalance, recipient = param.recipient, showAcceptChanges = param.showAcceptChanges, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var priceImpactWithoutFee = (0,react.useMemo)(function() {
        return computeTradePriceBreakdown(trade);
    }, [
        trade
    ]).priceImpactWithoutFee;
    var priceImpactSeverity = warningSeverity(priceImpactWithoutFee);
    var inputTextColor = showAcceptChanges && trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && isEnoughInputBalance ? "primary" : trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance ? "failure" : "text";
    var amount = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(6) : (ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6);
    var symbol = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol;
    var tradeInfoText = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Output is estimated. You will receive at least or the transaction will revert.") : t("Input is estimated. You will sell at most or the transaction will revert.");
    var ref2 = (0,src_sliced_to_array/* default */.Z)(tradeInfoText.split("".concat(amount, " ").concat(symbol)), 2), estimatedText = ref2[0], transactionRevertText = ref2[1];
    var truncatedRecipient = recipient ? (0,truncateHash/* default */.Z)(recipient) : "";
    var recipientInfoText = t("Output will be sent to %recipient%", {
        recipient: truncatedRecipient
    });
    var ref3 = (0,src_sliced_to_array/* default */.Z)(recipientInfoText.split(truncatedRecipient), 2), recipientSentToText = ref3[0], postSentToText = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
        gap: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        gap: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                currency: trade.inputAmount.currency,
                                size: "24px",
                                style: {
                                    marginRight: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: inputTextColor,
                                children: trade.inputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                        gap: "0px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.inputAmount.currency.symbol
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: "16px",
                    ml: "4px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        gap: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                currency: trade.outputAmount.currency,
                                size: "24px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: priceImpactSeverity > 2 ? "failure" : showAcceptChanges && trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? "primary" : "text",
                                children: trade.outputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.outputAmount.currency.symbol
                        })
                    })
                ]
            }),
            showAcceptChanges ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapShowAcceptChanges, {
                justify: "flex-start",
                gap: "0px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                                    mr: "8px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                    bold: true,
                                    children: [
                                        " ",
                                        t("Price Updated")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: onAcceptChanges,
                            children: t("Accept")
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "24px 0 0 0px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        style: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                color: "secondary",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Slippage Tolerance")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                bold: true,
                                color: "primary",
                                ml: "auto",
                                textAlign: "end",
                                children: "".concat(allowedSlippage / 100, "%")
                            })
                        ]
                    }),
                    trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        small: true,
                        color: "failure",
                        textAlign: "left",
                        style: {
                            width: "100%"
                        },
                        children: t("Insufficient input token balance. Your transaction may fail.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "left",
                        style: {
                            width: "100%"
                        },
                        children: [
                            estimatedText,
                            transactionRevertText
                        ]
                    })
                ]
            }),
            recipient !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "12px 0 0 0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                    color: "textSubtle",
                    children: [
                        recipientSentToText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            title: recipient,
                            children: truncatedRecipient
                        }),
                        postSentToText
                    ]
                })
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/StableSwap/components/StableSwapModalHeader.tsx












function StableSwapModalHeader(param) {
    var trade = param.trade, slippageAdjustedAmounts = param.slippageAdjustedAmounts, isEnoughInputBalance = param.isEnoughInputBalance, recipient = param.recipient, showAcceptChanges = param.showAcceptChanges, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var inputTextColor = showAcceptChanges && trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && isEnoughInputBalance ? "primary" : trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance ? "failure" : "text";
    var amount = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(6) : (ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6);
    var symbol = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol;
    var tradeInfoText = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Output is estimated. You will receive at least or the transaction will revert.") : t("Input is estimated. You will sell at most or the transaction will revert.");
    var ref2 = (0,src_sliced_to_array/* default */.Z)(tradeInfoText.split("".concat(amount, " ").concat(symbol)), 2), estimatedText = ref2[0], transactionRevertText = ref2[1];
    var truncatedRecipient = recipient ? (0,truncateHash/* default */.Z)(recipient) : "";
    var recipientInfoText = t("Output will be sent to %recipient%", {
        recipient: truncatedRecipient
    });
    var ref3 = (0,src_sliced_to_array/* default */.Z)(recipientInfoText.split(truncatedRecipient), 2), recipientSentToText = ref3[0], postSentToText = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
        gap: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        gap: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                currency: trade.inputAmount.currency,
                                size: "24px",
                                style: {
                                    marginRight: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: inputTextColor,
                                children: trade.inputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                        gap: "0px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.inputAmount.currency.symbol
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: "16px",
                    ml: "4px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        gap: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                                currency: trade.outputAmount.currency,
                                size: "24px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: showAcceptChanges && trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? "primary" : "text",
                                children: trade.outputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.outputAmount.currency.symbol
                        })
                    })
                ]
            }),
            showAcceptChanges ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapShowAcceptChanges, {
                justify: "flex-start",
                gap: "0px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                                    mr: "8px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                    bold: true,
                                    children: [
                                        " ",
                                        t("Price Updated")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: onAcceptChanges,
                            children: t("Accept")
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "24px 0 0 0px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        style: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                color: "secondary",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Slippage Tolerance")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                bold: true,
                                color: "primary",
                                ml: "auto",
                                textAlign: "end",
                                children: "".concat(basisPointsToPercent(allowedSlippage).toFixed(1), "%")
                            })
                        ]
                    }),
                    trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        small: true,
                        color: "failure",
                        textAlign: "left",
                        style: {
                            width: "100%"
                        },
                        children: t("Insufficient input token balance. Your transaction may fail.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "left",
                        style: {
                            width: "100%"
                        },
                        children: [
                            estimatedText,
                            transactionRevertText
                        ]
                    })
                ]
            }),
            recipient !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "12px 0 0 0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                    color: "textSubtle",
                    children: [
                        recipientSentToText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            title: recipient,
                            children: truncatedRecipient
                        }),
                        postSentToText
                    ]
                })
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/StableSwap/components/StableSwapModalFooter.tsx

function StableSwapModalFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  padding: 16px;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    StableSwapModalFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var StableSwapModalFooter_SwapModalFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Column_AutoColumn).withConfig({
    componentId: "sc-47f93bc2-0"
})(StableSwapModalFooter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.radii.default;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
function StableSwapModalFooter(param) {
    var trade = param.trade, slippageAdjustedAmounts = param.slippageAdjustedAmounts, isEnoughInputBalance = param.isEnoughInputBalance, onConfirm = param.onConfirm, swapErrorMessage = param.swapErrorMessage, disabledConfirm = param.disabledConfirm;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(false), showInverted = ref2[0], setShowInverted = ref2[1];
    var totalFeePercent = "".concat((TOTAL_FEE * 100).toFixed(2), "%");
    var lpHoldersFeePercent = "".concat((LP_HOLDERS_FEE * 100).toFixed(2), "%");
    var treasuryFeePercent = "".concat((TREASURY_FEE * 100).toFixed(4), "%");
    var buyBackFeePercent = "".concat((BUYBACK_FEE * 100).toFixed(4), "%");
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StableSwapModalFooter_SwapModalFooterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                children: t("Price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                style: {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    textAlign: "right",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    formatExecutionPrice(trade, showInverted),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                                        onClick: function() {
                                            return setShowInverted(!showInverted);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                            width: "14px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Minimum received") : t("Maximum sold")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHelper/* default */.Z, {
                                        text: t("Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref3 = (ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(4)) !== null && ref3 !== void 0 ? ref3 : "-" : (ref4 = (ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(4)) !== null && ref4 !== void 0 ? ref4 : "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "14px",
                                        marginLeft: "4px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowBetween, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                children: t("Liquidity Provider Fee")
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        onClick: onConfirm,
                        disabled: disabledConfirm,
                        mt: "12px",
                        id: "confirm-swap-or-send",
                        width: "100%",
                        children: trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance ? t("Swap Anyway") : t("Confirm Swap")
                    }),
                    swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                        error: swapErrorMessage
                    }) : null
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/TransactionConfirmSwapContent.tsx











/**
 * Returns true if the trade requires a confirmation of details before we can submit it
 * @param tradeA trade A
 * @param tradeB trade B
 */ function tradeMeaningfullyDiffers(tradeA, tradeB) {
    return tradeA.tradeType !== tradeB.tradeType || !tradeA.inputAmount.currency.equals(tradeB.inputAmount.currency) || !tradeA.inputAmount.equalTo(tradeB.inputAmount) || !tradeA.outputAmount.currency.equals(tradeB.outputAmount.currency) || !tradeA.outputAmount.equalTo(tradeB.outputAmount);
}
var TransactionConfirmSwapContent = function(param) {
    var trade = param.trade, originalTrade = param.originalTrade, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage, onConfirm = param.onConfirm, recipient = param.recipient, currencyBalances = param.currencyBalances, isStable = param.isStable;
    var showAcceptChanges = (0,react.useMemo)(function() {
        return Boolean(trade && originalTrade && tradeMeaningfullyDiffers(trade, originalTrade));
    }, [
        originalTrade,
        trade
    ]);
    var slippageAdjustedAmounts = (0,react.useMemo)(function() {
        return computeSlippageAdjustedAmounts(trade, allowedSlippage);
    }, [
        trade,
        allowedSlippage
    ]);
    var isEnoughInputBalance = (0,react.useMemo)(function() {
        if ((trade === null || trade === void 0 ? void 0 : trade.tradeType) !== src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT) return null;
        var isInputBalanceExist = !!(currencyBalances && currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT]);
        var isInputBalanceBNB = isInputBalanceExist && currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT].currency.isNative;
        var inputCurrencyAmount = isInputBalanceExist ? isInputBalanceBNB ? maxAmountSpend(currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT]) : currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT] : null;
        return inputCurrencyAmount && slippageAdjustedAmounts && slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT] ? inputCurrencyAmount.greaterThan(slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) || inputCurrencyAmount.equalTo(slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) : false;
    }, [
        currencyBalances,
        trade,
        slippageAdjustedAmounts
    ]);
    var modalHeader = (0,react.useCallback)(function() {
        var SwapModalHead = isStable ? StableSwapModalHeader : SwapModalHeader;
        return trade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapModalHead, {
            trade: trade,
            allowedSlippage: allowedSlippage,
            slippageAdjustedAmounts: slippageAdjustedAmounts,
            isEnoughInputBalance: isEnoughInputBalance,
            recipient: recipient,
            showAcceptChanges: showAcceptChanges,
            onAcceptChanges: onAcceptChanges
        }) : null;
    }, [
        allowedSlippage,
        onAcceptChanges,
        recipient,
        showAcceptChanges,
        trade,
        slippageAdjustedAmounts,
        isEnoughInputBalance,
        isStable, 
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        var SwapModalF = isStable ? StableSwapModalFooter : SwapModalFooter;
        return trade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapModalF, {
            onConfirm: onConfirm,
            trade: trade,
            disabledConfirm: showAcceptChanges,
            slippageAdjustedAmounts: slippageAdjustedAmounts,
            isEnoughInputBalance: isEnoughInputBalance
        }) : null;
    }, [
        onConfirm,
        showAcceptChanges,
        trade,
        isEnoughInputBalance,
        slippageAdjustedAmounts,
        isStable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModalContent, {
        topContent: modalHeader,
        bottomContent: modalBottom
    });
};
/* harmony default export */ var components_TransactionConfirmSwapContent = (/*#__PURE__*/(0,react.memo)(TransactionConfirmSwapContent));

;// CONCATENATED MODULE: ./src/views/Swap/components/ConfirmSwapModalContainer.tsx



var ConfirmSwapModalContainer = function(param) {
    var children = param.children, handleDismiss = param.handleDismiss;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        title: t("Confirm Swap"),
        headerBackground: "gradientCardHeader",
        onDismiss: handleDismiss,
        children: children
    });
};
/* harmony default export */ var components_ConfirmSwapModalContainer = (ConfirmSwapModalContainer);

// EXTERNAL MODULE: ./packages/localization/src/useTranslation.ts
var src_useTranslation = __webpack_require__(71578);
;// CONCATENATED MODULE: ./src/views/Swap/components/ConfirmSwapModal.tsx









var PancakeRouterSlippageErrorMsg = "This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.";
var SwapTransactionErrorContent = function(param) {
    var onDismiss = param.onDismiss, message = param.message, openSettingModal = param.openSettingModal;
    var isSlippagedErrorMsg = message === null || message === void 0 ? void 0 : message.includes(PancakeRouterSlippageErrorMsg);
    var handleErrorDismiss = (0,react.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        if (isSlippagedErrorMsg && openSettingModal) {
            openSettingModal();
        }
    }, [
        isSlippagedErrorMsg,
        onDismiss,
        openSettingModal
    ]);
    var t = (0,src_useTranslation/* default */.Z)().t;
    return isSlippagedErrorMsg ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionErrorContent, {
        message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                    mb: "16px",
                    children: [
                        t("This transaction will not succeed either due to price movement or fee on transfer. Try increasing your"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            bold: true,
                            display: "inline",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: handleErrorDismiss,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                children: t("slippage tolerance.")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "https://docs.pancakeswap.finance/products/pancakeswap-exchange/trade-guide",
                    style: {
                        width: "100%",
                        justifyContent: "center"
                    },
                    children: t("What are the potential issues with the token?")
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionErrorContent, {
        message: message,
        onDismiss: onDismiss
    });
};
var ConfirmSwapModal = function(param) {
    var trade = param.trade, originalTrade = param.originalTrade, currencyBalances = param.currencyBalances, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage, onConfirm = param.onConfirm, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, recipient = param.recipient, swapErrorMessage = param.swapErrorMessage, attemptingTxn = param.attemptingTxn, txHash = param.txHash, openSettingModal = param.openSettingModal, isStable = param.isStable;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var handleDismiss = (0,react.useCallback)(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    var confirmationContent = (0,react.useCallback)(function() {
        return swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapTransactionErrorContent, {
            openSettingModal: openSettingModal,
            onDismiss: onDismiss,
            message: swapErrorMessage
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TransactionConfirmSwapContent, {
            isStable: isStable,
            trade: trade,
            currencyBalances: currencyBalances,
            originalTrade: originalTrade,
            onAcceptChanges: onAcceptChanges,
            allowedSlippage: allowedSlippage,
            onConfirm: onConfirm,
            recipient: recipient
        });
    }, [
        isStable,
        trade,
        originalTrade,
        onAcceptChanges,
        allowedSlippage,
        onConfirm,
        recipient,
        swapErrorMessage,
        onDismiss,
        openSettingModal,
        currencyBalances, 
    ]);
    if (!chainId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmSwapModalContainer, {
        handleDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmationPendingContent, {
            trade: trade
        }) : txHash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionSubmittedContent, {
            chainId: chainId,
            hash: txHash,
            onDismiss: handleDismiss,
            currencyToAdd: trade === null || trade === void 0 ? void 0 : trade.outputAmount.currency
        }) : confirmationContent()
    });
};
/* harmony default export */ var components_ConfirmSwapModal = (/*#__PURE__*/(0,react.memo)(ConfirmSwapModal));

;// CONCATENATED MODULE: ./src/views/Swap/components/ProgressSteps.tsx




function ProgressSteps_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n"
    ]);
    ProgressSteps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProgressSteps_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 20px;\n  min-height: 20px;\n  background-color: ",
        ";\n  border-radius: 50%;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 8px;\n  font-size: 12px;\n"
    ]);
    ProgressSteps_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProgressSteps_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 20px);\n  display: flex;\n  align-items: center;\n"
    ]);
    ProgressSteps_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProgressSteps_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(\n    90deg,\n    ",
        "\n      0%,\n    ",
        "\n      80%\n  );\n  opacity: 0.6;\n"
    ]);
    ProgressSteps_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Grouping = (0,styled_components_browser_esm/* default */.ZP)(RowBetween).withConfig({
    componentId: "sc-b6a41b3e-0"
})(ProgressSteps_templateObject());
var Circle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6a41b3e-1"
})(ProgressSteps_templateObject1(), function(param) {
    var theme = param.theme, confirmed = param.confirmed, disabled = param.disabled;
    return disabled ? theme.colors.backgroundDisabled : confirmed ? theme.colors.success : theme.colors.primary;
});
var CircleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6a41b3e-2"
})(ProgressSteps_templateObject2());
var Connector = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b6a41b3e-3"
})(ProgressSteps_templateObject3(), function(param) {
    var theme = param.theme, prevConfirmed = param.prevConfirmed, disabled = param.disabled;
    return disabled ? theme.colors.backgroundDisabled : prevConfirmed ? theme.colors.success : theme.colors.primary;
}, function(param) {
    var theme = param.theme, prevConfirmed = param.prevConfirmed, disabled = param.disabled;
    return disabled ? theme.colors.backgroundDisabled : prevConfirmed ? theme.colors.primary : theme.colors.backgroundDisabled;
});
/**
 * Based on array of steps, create a step counter of circles.
 * A circle can be enabled, disabled, or confirmed. States are derived
 * from previous step.
 *
 * An extra circle is added to represent the ability to swap, add, or remove.
 * This step will never be marked as complete (because no 'txn done' state in body ui).
 *
 * @param steps  array of booleans where true means step is complete
 */ function ProgressCircles(_param) {
    var steps = _param.steps, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "steps",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        justify: "center"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grouping, {
            children: [
                steps.map(function(step, i) {
                    return(// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CircleRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                                confirmed: step,
                                disabled: disabled || !steps[i - 1] && i !== 0,
                                children: step ? "✓" : i + 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Connector, {
                                prevConfirmed: step,
                                disabled: disabled
                            })
                        ]
                    }, i));
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                    disabled: disabled || !steps[steps.length - 1],
                    children: steps.length + 1
                })
            ]
        })
    }));
}

;// CONCATENATED MODULE: ./src/views/Swap/components/confirmPriceImpactWithoutFee.ts

/**
 * Given the price impact, get user confirmation.
 *
 * @param priceImpactWithoutFee price impact of the trade without the fee.
 * @param t Translation
 */ function confirmPriceImpactWithoutFee(priceImpactWithoutFee, t) {
    if (!priceImpactWithoutFee.lessThan(exchange/* PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN */.EV)) {
        var confirmWord = "confirm";
        return(// eslint-disable-next-line no-alert
        window.prompt(t('This swap has a price impact of at least %amount%%. Please type the word "%word%" to continue with this swap.', {
            amount: exchange/* PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN.toFixed */.EV.toFixed(0),
            word: confirmWord
        })) === confirmWord);
    }
    if (!priceImpactWithoutFee.lessThan(exchange/* ALLOWED_PRICE_IMPACT_HIGH */.Uf)) {
        // eslint-disable-next-line no-alert
        return window.confirm(t("This swap has a price impact of at least %amount%%. Please confirm that you would like to continue with this swap.", {
            amount: exchange/* ALLOWED_PRICE_IMPACT_HIGH.toFixed */.Uf.toFixed(0)
        }));
    }
    return true;
}

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapCommitButton.tsx



























var SettingsModalWithCustomDismiss = (0,SettingsModal/* withCustomOnDismiss */.h)(SettingsModal/* default */.Z);
function SwapCommitButton(param) {
    var swapIsUnsupported = param.swapIsUnsupported, account = param.account, showWrap = param.showWrap, wrapInputError = param.wrapInputError, onWrap = param.onWrap, wrapType = param.wrapType, approval = param.approval, approveCallback = param.approveCallback, approvalSubmitted = param.approvalSubmitted, currencies = param.currencies, isExpertMode = param.isExpertMode, trade = param.trade, swapInputError = param.swapInputError, currencyBalances = param.currencyBalances, recipient = param.recipient, allowedSlippage = param.allowedSlippage, parsedIndepentFieldAmount = param.parsedIndepentFieldAmount, onUserInput = param.onUserInput;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    var priceImpactWithoutFee = computeTradePriceBreakdown(trade).priceImpactWithoutFee;
    // the callback to execute the swap
    var swapCalls = useSwapCallArguments(trade, allowedSlippage, recipient);
    var ref1 = useSwapCallback(trade, allowedSlippage, recipient, swapCalls), swapCallback = ref1.callback, swapCallbackError = ref1.error;
    var ref2 = (0,react.useState)({
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined
    }), ref3 = ref2[0], tradeToConfirm = ref3.tradeToConfirm, swapErrorMessage = ref3.swapErrorMessage, attemptingTxn = ref3.attemptingTxn, txHash = ref3.txHash, setSwapState = ref2[1];
    // Handlers
    var handleSwap = (0,react.useCallback)(function() {
        if (priceImpactWithoutFee && !confirmPriceImpactWithoutFee(priceImpactWithoutFee, t)) {
            return;
        }
        if (!swapCallback) {
            return;
        }
        setSwapState({
            attemptingTxn: true,
            tradeToConfirm: tradeToConfirm,
            swapErrorMessage: undefined,
            txHash: undefined
        });
        swapCallback().then(function(hash) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm: tradeToConfirm,
                swapErrorMessage: undefined,
                txHash: hash
            });
        }).catch(function(error) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm: tradeToConfirm,
                swapErrorMessage: error.message,
                txHash: undefined
            });
        });
    }, [
        priceImpactWithoutFee,
        swapCallback,
        tradeToConfirm,
        t,
        setSwapState
    ]);
    var handleAcceptChanges = (0,react.useCallback)(function() {
        setSwapState({
            tradeToConfirm: trade,
            swapErrorMessage: swapErrorMessage,
            txHash: txHash,
            attemptingTxn: attemptingTxn
        });
    }, [
        attemptingTxn,
        swapErrorMessage,
        trade,
        txHash,
        setSwapState
    ]);
    var handleConfirmDismiss = (0,react.useCallback)(function() {
        setSwapState({
            tradeToConfirm: tradeToConfirm,
            attemptingTxn: attemptingTxn,
            swapErrorMessage: swapErrorMessage,
            txHash: txHash
        });
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(swap_actions/* Field.INPUT */.gN.INPUT, "");
        }
    }, [
        attemptingTxn,
        onUserInput,
        swapErrorMessage,
        tradeToConfirm,
        txHash,
        setSwapState
    ]);
    // End Handlers
    // Modals
    var ref4 = (0,react.useState)(false), indirectlyOpenConfirmModalState = ref4[0], setIndirectlyOpenConfirmModalState = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsModalWithCustomDismiss, {
        customOnDismiss: function() {
            return setIndirectlyOpenConfirmModalState(true);
        },
        mode: GlobalSettings_types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY
    })), 1), onPresentSettingsModal = ref5[0];
    var ref6 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmSwapModal, {
        trade: trade,
        originalTrade: tradeToConfirm,
        currencyBalances: currencyBalances,
        onAcceptChanges: handleAcceptChanges,
        attemptingTxn: attemptingTxn,
        txHash: txHash,
        recipient: recipient,
        allowedSlippage: allowedSlippage,
        onConfirm: handleSwap,
        swapErrorMessage: swapErrorMessage,
        customOnDismiss: handleConfirmDismiss,
        openSettingModal: onPresentSettingsModal
    }), true, true, "confirmSwapModal"), 1), onPresentConfirmModal = ref6[0];
    // End Modals
    var onSwapHandler = (0,react.useCallback)(function() {
        if (isExpertMode) {
            handleSwap();
        } else {
            setSwapState({
                tradeToConfirm: trade,
                attemptingTxn: false,
                swapErrorMessage: undefined,
                txHash: undefined
            });
            onPresentConfirmModal();
        }
    }, [
        isExpertMode,
        handleSwap,
        onPresentConfirmModal,
        trade
    ]);
    // useEffect
    (0,react.useEffect)(function() {
        if (indirectlyOpenConfirmModalState) {
            setIndirectlyOpenConfirmModalState(false);
            setSwapState(function(state) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                    swapErrorMessage: undefined
                });
            });
            onPresentConfirmModal();
        }
    }, [
        indirectlyOpenConfirmModalState,
        onPresentConfirmModal,
        setSwapState
    ]);
    // warnings on slippage
    var priceImpactSeverity = warningSeverity(priceImpactWithoutFee);
    if (swapIsUnsupported) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            disabled: true,
            children: t("Unsupported Asset")
        });
    }
    if (!account) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
            width: "100%"
        });
    }
    if (showWrap) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton, {
            width: "100%",
            disabled: Boolean(wrapInputError),
            onClick: onWrap,
            children: wrapInputError !== null && wrapInputError !== void 0 ? wrapInputError : wrapType === WrapType.WRAP ? "Wrap" : wrapType === WrapType.UNWRAP ? "Unwrap" : null
        });
    }
    var noRoute = !(trade === null || trade === void 0 ? void 0 : trade.route);
    var userHasSpecifiedInputOutput = Boolean(currencies[swap_actions/* Field.INPUT */.gN.INPUT] && currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT] && (parsedIndepentFieldAmount === null || parsedIndepentFieldAmount === void 0 ? void 0 : parsedIndepentFieldAmount.greaterThan(exchange/* BIG_INT_ZERO */.iV)));
    if (noRoute && userHasSpecifiedInputOutput) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GreyCard, {
            style: {
                textAlign: "center",
                padding: "0.75rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                    color: "textSubtle",
                    children: t("Insufficient liquidity for this trade.")
                }),
                singleHopOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                    color: "textSubtle",
                    children: t("Try enabling multi-hop trades.")
                })
            ]
        });
    }
    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    var showApproveFlow = !swapInputError && (approval === ApprovalState.NOT_APPROVED || approval === ApprovalState.PENDING || approvalSubmitted && approval === ApprovalState.APPROVED) && !(priceImpactSeverity > 3 && !isExpertMode);
    var isValid = !swapInputError;
    if (showApproveFlow) {
        var ref7;
        var ref8;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton, {
                            variant: approval === ApprovalState.APPROVED ? "success" : "primary",
                            onClick: approveCallback,
                            disabled: approval !== ApprovalState.NOT_APPROVED || approvalSubmitted,
                            width: "48%",
                            children: approval === ApprovalState.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                                gap: "6px",
                                justify: "center",
                                children: [
                                    t("Enabling"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleLoader, {
                                        stroke: "white"
                                    })
                                ]
                            }) : approvalSubmitted && approval === ApprovalState.APPROVED ? t("Enabled") : t("Enable %asset%", {
                                asset: (ref8 = (ref7 = currencies[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref7 === void 0 ? void 0 : ref7.symbol) !== null && ref8 !== void 0 ? ref8 : ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton, {
                            variant: isValid && priceImpactSeverity > 2 ? "danger" : "primary",
                            onClick: function() {
                                onSwapHandler();
                            },
                            width: "48%",
                            id: "swap-button",
                            disabled: !isValid || approval !== ApprovalState.APPROVED || priceImpactSeverity > 3 && !isExpertMode,
                            children: priceImpactSeverity > 3 && !isExpertMode ? t("Price Impact High") : priceImpactSeverity > 2 ? t("Swap Anyway") : t("Swap")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Column, {
                    style: {
                        marginTop: "1rem"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressCircles, {
                        steps: [
                            approval === ApprovalState.APPROVED
                        ]
                    })
                }),
                isExpertMode && swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                    error: swapErrorMessage
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton, {
                variant: isValid && priceImpactSeverity > 2 && !swapCallbackError ? "danger" : "primary",
                onClick: function() {
                    onSwapHandler();
                },
                id: "swap-button",
                width: "100%",
                disabled: !isValid || priceImpactSeverity > 3 && !isExpertMode || !!swapCallbackError,
                children: swapInputError || (priceImpactSeverity > 3 && !isExpertMode ? t("Price Impact Too High") : priceImpactSeverity > 2 ? t("Swap Anyway") : t("Swap"))
            }),
            isExpertMode && swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                error: swapErrorMessage
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/config/constants/warningTokens.ts

var bscWarningTokens = {
    pokemoney: new src/* Token */.WU(src/* ChainId.BSC */.a_.BSC, "0x32ff5b4C3B1744F0344D96fA2f87799Ed2805749", 18, "PMY", "Pokemoney Coin", ""),
    free: new src/* Token */.WU(src/* ChainId.BSC */.a_.BSC, "0x880BCe9321c79cAc1D290De6d31DDE722C606165", 8, "FREE", "Freedom Protocol Token", ""),
    safemoon: new src/* Token */.WU(src/* ChainId.BSC */.a_.BSC, "0x8076C74C5e3F5852037F31Ff0093Eeb8c8ADd8D3", 9, "SAFEMOON", "Safemoon Token", "https://safemoon.net/")
};
var bscTestnetWarningTokens = {};

;// CONCATENATED MODULE: ./src/config/constants/swapWarningTokens.ts


var bondly = tokens_src/* bscTokens.bondly */.ds.bondly, itam = tokens_src/* bscTokens.itam */.ds.itam, ccar = tokens_src/* bscTokens.ccar */.ds.ccar, bttold = tokens_src/* bscTokens.bttold */.ds.bttold;
var pokemoney = bscWarningTokens.pokemoney, free = bscWarningTokens.free, safemoon = bscWarningTokens.safemoon;
var SwapWarningTokens = {
    safemoon: safemoon,
    bondly: bondly,
    itam: itam,
    ccar: ccar,
    bttold: bttold,
    pokemoney: pokemoney,
    free: free
};
/* harmony default export */ var swapWarningTokens = (SwapWarningTokens);

;// CONCATENATED MODULE: ./src/utils/shouldShowSwapWarning.ts

var shouldShowSwapWarning_swapWarningTokens = Object.values(swapWarningTokens);
var shouldShowSwapWarning = function(swapCurrency) {
    return shouldShowSwapWarning_swapWarningTokens.some(function(warningToken) {
        return warningToken.equals(swapCurrency);
    });
};
/* harmony default export */ var utils_shouldShowSwapWarning = (shouldShowSwapWarning);

;// CONCATENATED MODULE: ./src/components/ImportTokenWarningModal.tsx




var ImportTokenWarningModal = function(param) {
    var tokens = param.tokens, onDismiss = param.onDismiss, onCancel = param.onCancel;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal/* default */.Z, {
        title: t("Import Token"),
        onDismiss: function() {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            onCancel();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            maxWidth: "380px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal_ImportToken, {
                tokens: tokens,
                handleCurrencySelect: onDismiss
            })
        })
    });
};
/* harmony default export */ var components_ImportTokenWarningModal = (ImportTokenWarningModal);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/SafemoonWarning.tsx



var SafemoonWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // Break translation sentences into pieces because the current translation approach doesn't support Link interpolation.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
            children: [
                t("SAFEMOON has been migrated to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://bscscan.com/address/0x42981d0bfbAf196529376EE702F2a9Eb9092fcB5",
                    children: t("a new contract address.")
                }),
                " ",
                t("Trading on the old address may result in the complete loss of your assets. For more information please refer to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link_Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://twitter.com/safemoon/status/1477770592031887360",
                    children: [
                        t("Safemoon's announcement"),
                        "."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_SafemoonWarning = (SafemoonWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/ItamWarning.tsx



var ItamWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
            children: [
                t("ITAM has been rebranded as ITAM CUBE."),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://itam.network/swap",
                    children: t("Please proceed to ITAM bridge to conduct a one-way swap of your ITAM tokens.")
                }),
                " ",
                t("All transfers of the old ITAM token will be disabled after the swap.")
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_ItamWarning = (ItamWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/BondlyWarning.tsx



var BondlyWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
        children: t("Warning: BONDLY has been compromised. Please remove liquidity until further notice.")
    });
};
/* harmony default export */ var SwapWarningModal_BondlyWarning = (BondlyWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/Acknowledgement.tsx




var Acknowledgement = function(param) {
    var handleContinueClick = param.handleContinueClick;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isConfirmed = ref[0], setIsConfirmed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            name: "confirmed",
                            type: "checkbox",
                            checked: isConfirmed,
                            onChange: function() {
                                return setIsConfirmed(!isConfirmed);
                            },
                            scale: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            ml: "10px",
                            style: {
                                userSelect: "none"
                            },
                            children: t("I understand")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: !isConfirmed,
                    onClick: handleContinueClick,
                    children: t("Continue")
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_Acknowledgement = (Acknowledgement);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/CcarWarning.tsx



var CcarWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
            children: [
                t("Crypto Cars (CCAR) has been migrated to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://bscscan.com/token/0x322e5015Cc464Ada7f99dE7131CE494dE1834396",
                    children: t("a new contract address.")
                }),
                " ",
                t("Trading on the old address may result in the complete loss of your assets. For more information please refer to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://t.me/Crypto_Cars_Official/465037",
                    children: t("the announcement.")
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_CcarWarning = (CcarWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/BTTWarning.tsx



var BTTWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                children: t("Please note that this is the old BTT token, which has been swapped to the new BTT tokens in the following ratio:")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                children: "1 BTT (OLD) = 1,000 BTT (NEW)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                mb: "8px",
                children: [
                    t("Trade the new BTT token"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_Link/* default */.Z, {
                        style: {
                            display: "inline"
                        },
                        href: "https://pancakeswap.finance/swap?outputCurrency=0x352Cb5E19b12FC216548a2677bD0fce83BaE434B",
                        children: t("here")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                href: "https://medium.com/@BitTorrent/tutorial-how-to-swap-bttold-to-btt-453264d7142",
                children: t("For more details on the swap, please refer here.")
            })
        ]
    });
};
/* harmony default export */ var SwapWarningModal_BTTWarning = (BTTWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/RugPullWarning.tsx



var RugPullWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
            children: t("Suspicious rugpull token")
        })
    });
};
/* harmony default export */ var SwapWarningModal_RugPullWarning = (RugPullWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/FREEWarning.tsx



var FREEWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
            children: t("Risk Warning: This token is subject to high price risk. Please do your own research before trading this token. Please also note that as of 24 June 2022 there is also a reflection fee for every transfer of FREE ranging from 2.5 to 5% per trade/transfer.")
        })
    });
};
/* harmony default export */ var SwapWarningModal_FREEWarning = (FREEWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/index.tsx


function SwapWarningModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 440px;\n"
    ]);
    SwapWarningModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwapWarningModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  justify-content: flex-start;\n"
    ]);
    SwapWarningModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var SwapWarningModal_StyledModalContainer = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-a6754440-0"
})(SwapWarningModal_templateObject());
var MessageContainer = (0,styled_components_browser_esm/* default */.ZP)(Message/* default */.Z).withConfig({
    componentId: "sc-a6754440-1"
})(SwapWarningModal_templateObject1());
var SwapWarningModal = function(param) {
    var swapCurrency = param.swapCurrency, onDismiss = param.onDismiss;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var _obj;
    var TOKEN_WARNINGS = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, swapWarningTokens.safemoon.address, {
        symbol: swapWarningTokens.safemoon.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_SafemoonWarning, {})
    }), (0,src_define_property/* default */.Z)(_obj, swapWarningTokens.bondly.address, {
        symbol: swapWarningTokens.bondly.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_BondlyWarning, {})
    }), (0,src_define_property/* default */.Z)(_obj, swapWarningTokens.itam.address, {
        symbol: swapWarningTokens.itam.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_ItamWarning, {})
    }), (0,src_define_property/* default */.Z)(_obj, swapWarningTokens.ccar.address, {
        symbol: swapWarningTokens.ccar.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_CcarWarning, {})
    }), (0,src_define_property/* default */.Z)(_obj, swapWarningTokens.bttold.address, {
        symbol: swapWarningTokens.bttold.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_BTTWarning, {})
    }), (0,src_define_property/* default */.Z)(_obj, swapWarningTokens.pokemoney.address, {
        symbol: swapWarningTokens.pokemoney.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_RugPullWarning, {})
    }), (0,src_define_property/* default */.Z)(_obj, swapWarningTokens.free.address, {
        symbol: swapWarningTokens.free.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_FREEWarning, {})
    }), _obj);
    var SWAP_WARNING = TOKEN_WARNINGS[swapCurrency.address];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwapWarningModal_StyledModalContainer, {
        $minWidth: "280px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalHeader */.xB, {
                background: theme.colors.gradientCardHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading_Heading/* default */.Z, {
                    p: "12px 24px",
                    children: t("Notice for trading %symbol%", {
                        symbol: SWAP_WARNING.symbol
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageContainer, {
                        variant: "warning",
                        mb: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: SWAP_WARNING.component
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_Acknowledgement, {
                        handleContinueClick: onDismiss
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SwapWarningModal = (SwapWarningModal);

;// CONCATENATED MODULE: ./src/views/Swap/hooks/useWarningImport.tsx











function useWarningImport() {
    var router = (0,next_router.useRouter)();
    var loadedUrlParams = hooks_useDefaultsFromURLSearch();
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    // swap warning state
    var ref = (0,react.useState)(null), swapWarningCurrency = ref[0], setSwapWarningCurrency = ref[1];
    // token warning stuff
    var ref1 = [
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.inputCurrencyId),
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.outputCurrencyId), 
    ], loadedInputCurrency = ref1[0], loadedOutputCurrency = ref1[1];
    var ref2;
    var urlLoadedTokens = (0,react.useMemo)(function() {
        var ref;
        return (ref2 = (ref = [
            loadedInputCurrency,
            loadedOutputCurrency
        ]) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
            return c === null || c === void 0 ? void 0 : c.isToken;
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        loadedInputCurrency,
        loadedOutputCurrency
    ]);
    var defaultTokens = (0,Tokens/* useAllTokens */.e_)();
    var importTokensNotInDefault = urlLoadedTokens && urlLoadedTokens.filter(function(token) {
        return !(token.address in defaultTokens) && token.chainId === chainId;
    });
    var ref3 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_SwapWarningModal, {
        swapCurrency: swapWarningCurrency
    }), false), 1), onPresentSwapWarningModal = ref3[0];
    var ref4 = (0,src_sliced_to_array/* default */.Z)((0,Modal_useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ImportTokenWarningModal, {
        tokens: importTokensNotInDefault,
        onCancel: function() {
            return router.push("/swap");
        }
    })), 1), onPresentImportTokenWarningModal = ref4[0];
    (0,react.useEffect)(function() {
        if (swapWarningCurrency) {
            onPresentSwapWarningModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        swapWarningCurrency
    ]);
    var swapWarningHandler = (0,react.useCallback)(function(currencyInput) {
        var showSwapWarning = utils_shouldShowSwapWarning(currencyInput);
        if (showSwapWarning) {
            setSwapWarningCurrency(currencyInput);
        } else {
            setSwapWarningCurrency(null);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (importTokensNotInDefault.length > 0) {
            onPresentImportTokenWarningModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        importTokensNotInDefault.length
    ]);
    return swapWarningHandler;
}

;// CONCATENATED MODULE: ./src/views/Swap/hooks/useRefreshBlockNumber.ts



var useRefreshBlockNumber = function() {
    var ref = (0,react.useState)(false), isLoading = ref[0], setFetch = ref[1];
    var refreshBlockNumber = (0,react.useCallback)(function() {
        if (!isLoading) {
            setFetch(true);
        }
    }, [
        isLoading
    ]);
    var mutate = (0,dist/* useSWRConfig */.kY)().mutate;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    (0,react.useEffect)(function() {
        if (!isLoading) return;
        mutate([
            "blockNumber",
            chainId
        ]);
        // setTimeout is used to demonstrate the loading
        // because the real loading state occurs on multicall state
        // we don't know when the fetch is finished.
        setTimeout(function() {
            return setFetch(false);
        }, 500);
    }, [
        mutate,
        isLoading,
        chainId
    ]);
    return {
        refreshBlockNumber: refreshBlockNumber,
        isLoading: isLoading
    };
};
/* harmony default export */ var hooks_useRefreshBlockNumber = (useRefreshBlockNumber);

;// CONCATENATED MODULE: ./src/views/Swap/components/AddressInputPanel.tsx

function AddressInputPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  border-radius: 1.25rem;\n  background-color: ",
        ";\n  z-index: 1;\n  width: 100%;\n"
    ]);
    AddressInputPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AddressInputPanel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 1.25rem;\n  border: 1px solid ",
        ";\n  transition: border-color 300ms ",
        ",\n    color 500ms ",
        ";\n  background-color: ",
        ";\n"
    ]);
    AddressInputPanel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AddressInputPanel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  padding: 1rem;\n"
    ]);
    AddressInputPanel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AddressInputPanel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.25rem;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: ",
        ";\n  transition: color 300ms ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n  width: 100%;\n  ::placeholder {\n    color: ",
        ";\n  }\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    AddressInputPanel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var AddressInputPanel_InputPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-966d56e6-0"
})(AddressInputPanel_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var ContainerRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-966d56e6-1"
})(AddressInputPanel_templateObject1(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.background;
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var InputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-966d56e6-2"
})(AddressInputPanel_templateObject2());
var AddressInputPanel_Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-966d56e6-3"
})(AddressInputPanel_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
function AddressInputPanel(param) {
    var id = param.id, value = param.value, onChange = param.onChange;
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var address = (0,utils/* isAddress */.UJ)(value) ? value : undefined;
    var handleInput = (0,react.useCallback)(function(event) {
        var input = event.target.value;
        var withoutSpaces = input.replace(/\s+/g, "");
        onChange(withoutSpaces);
    }, [
        onChange
    ]);
    var error = Boolean(value.length > 0 && !address);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputPanel_InputPanel, {
        id: id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerRow, {
            error: error,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                    gap: "md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                    children: t("Recipient")
                                }),
                                address && chainId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link_Link/* default */.Z, {
                                    external: true,
                                    small: true,
                                    href: (0,utils/* getBlockExploreLink */.C)(address, "address", chainId),
                                    children: [
                                        "(",
                                        t("View on %site%", {
                                            site: (0,utils/* getBlockExploreName */.X0)(chainId)
                                        }),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputPanel_Input, {
                            className: "recipient-address-input",
                            type: "text",
                            autoComplete: "off",
                            autoCorrect: "off",
                            autoCapitalize: "off",
                            spellCheck: "false",
                            placeholder: t("Wallet Address"),
                            error: error,
                            pattern: "^(0x[a-fA-F0-9]{40})$",
                            onChange: handleInput,
                            value: value
                        })
                    ]
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/hooks/useLast.ts

/**
 * Returns the last value of type T that passes a filter function
 * @param value changing value
 * @param filterFn function that determines whether a given value should be considered for the last value
 */ function useLast(value, filterFn) {
    var ref = (0,react.useState)(function() {
        return filterFn && filterFn(value) ? value : undefined;
    }), last = ref[0], setLast = ref[1];
    (0,react.useEffect)(function() {
        setLast(function(prev) {
            var shouldUse = filterFn ? filterFn(value) : true;
            if (shouldUse) return value;
            return prev;
        });
    }, [
        filterFn,
        value
    ]);
    return last;
}
function isDefined(x) {
    return x !== null && x !== undefined;
}
/**
 * Returns the last truthy value of type T
 * @param value changing value
 */ function useLastTruthy(value) {
    return useLast(value, isDefined);
}
/* harmony default export */ var hooks_useLast = (useLastTruthy);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(37303);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapRoute.tsx




/* harmony default export */ var SwapRoute = (/*#__PURE__*/(0,react.memo)(function SwapRoute(param) {
    var trade = param.trade;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
        flexWrap: "wrap",
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "center",
        children: trade.route.path.map(function(token, i, path) {
            var isLastItem = i === path.length - 1;
            var currency = (0,utils_wrappedCurrency/* unwrappedToken */.Bv)(token);
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                        alignItems: "end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "14px",
                            ml: "0.125rem",
                            mr: "0.125rem",
                            children: currency.symbol
                        })
                    }),
                    !isLastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                        width: "12px"
                    })
                ]
            }, i));
        })
    });
}));

;// CONCATENATED MODULE: ./src/views/Swap/components/AdvancedSwapDetails.tsx














function TradeSummary(param) {
    var trade = param.trade, allowedSlippage = param.allowedSlippage;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref2 = computeTradePriceBreakdown(trade), priceImpactWithoutFee = ref2.priceImpactWithoutFee, realizedLPFee = ref2.realizedLPFee;
    var isExactIn = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT;
    var slippageAdjustedAmounts = computeSlippageAdjustedAmounts(trade, allowedSlippage);
    var totalFeePercent = "".concat((TOTAL_FEE * 100).toFixed(2), "%");
    var lpHoldersFeePercent = "".concat((LP_HOLDERS_FEE * 100).toFixed(2), "%");
    var treasuryFeePercent = "".concat((TREASURY_FEE * 100).toFixed(4), "%");
    var buyBackFeePercent = "".concat((BUYBACK_FEE * 100).toFixed(4), "%");
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
        style: {
            padding: "0 16px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                color: "textSubtle",
                                children: isExactIn ? t("Minimum received") : t("Maximum sold")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHelper/* default */.Z, {
                                text: t("Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."),
                                ml: "4px",
                                placement: "top-start"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "14px",
                            children: isExactIn ? (ref3 = "".concat((ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(4), " ").concat(trade.outputAmount.currency.symbol)) !== null && ref3 !== void 0 ? ref3 : "-" : (ref4 = "".concat((ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(4), " ").concat(trade.inputAmount.currency.symbol)) !== null && ref4 !== void 0 ? ref4 : "-"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowFixed, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                fontSize: "14px",
                                color: "textSubtle",
                                children: t("Price Impact")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHelper/* default */.Z, {
                                text: t("The difference between the market price and estimated price due to trade size."),
                                ml: "4px",
                                placement: "top-start"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedPriceImpact, {
                        priceImpact: priceImpactWithoutFee
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowFixed, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                            fontSize: "14px",
                            color: "textSubtle",
                            children: t("Liquidity Provider Fee")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                        fontSize: "14px",
                        children: realizedLPFee ? "".concat(realizedLPFee.toSignificant(4), " ").concat(trade.inputAmount.currency.symbol) : "-"
                    })
                ]
            })
        ]
    });
}
function AdvancedSwapDetails(param) {
    var trade = param.trade;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref[0];
    var showRoute = Boolean(trade && trade.route.path.length > 2);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
        gap: "0px",
        children: trade && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeSummary, {
                    trade: trade,
                    allowedSlippage: allowedSlippage
                }),
                showRoute && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                        style: {
                            padding: "0 16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "textSubtle",
                                        children: t("Route")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHelper/* default */.Z, {
                                        text: t("Routing through these tokens resulted in the best price for your trade."),
                                        ml: "4px",
                                        placement: "top-start"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapRoute, {
                                trade: trade
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/AdvancedSwapDetailsDropdown.tsx




function AdvancedSwapDetailsDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  padding-top: 16px;\n  padding-bottom: 16px;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 20px;\n  background-color: ",
        ";\n\n  transform: ",
        ";\n  transition: transform 300ms ease-in-out;\n"
    ]);
    AdvancedSwapDetailsDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var AdvancedDetailsFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ddb625d1-0"
})(AdvancedSwapDetailsDropdown_templateObject(), function(param) {
    var show = param.show;
    return show ? "16px" : 0;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
}, function(param) {
    var show = param.show;
    return show ? "translateY(0%)" : "translateY(-100%)";
});
function AdvancedSwapDetailsDropdown(_param) {
    var trade = _param.trade, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "trade"
    ]);
    var lastTrade = hooks_useLast(trade);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedDetailsFooter, {
        show: Boolean(trade),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSwapDetails, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
            trade: (ref = trade !== null && trade !== void 0 ? trade : lastTrade) !== null && ref !== void 0 ? ref : undefined
        }))
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/TradePrice.tsx



function TradePrice(param) {
    var price = param.price, showInverted = param.showInverted, setShowInverted = param.setShowInverted;
    var ref, ref1, ref2, ref3, ref4;
    var formattedPrice = showInverted ? price === null || price === void 0 ? void 0 : price.toSignificant(6) : (ref = price === null || price === void 0 ? void 0 : price.invert()) === null || ref === void 0 ? void 0 : ref.toSignificant(6);
    var show = Boolean((price === null || price === void 0 ? void 0 : price.baseCurrency) && (price === null || price === void 0 ? void 0 : price.quoteCurrency));
    var label = showInverted ? "".concat(price === null || price === void 0 ? void 0 : (ref1 = price.quoteCurrency) === null || ref1 === void 0 ? void 0 : ref1.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref2 = price.baseCurrency) === null || ref2 === void 0 ? void 0 : ref2.symbol) : "".concat(price === null || price === void 0 ? void 0 : (ref3 = price.baseCurrency) === null || ref3 === void 0 ? void 0 : ref3.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref4 = price.quoteCurrency) === null || ref4 === void 0 ? void 0 : ref4.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_Text/* default */.Z, {
        style: {
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            fontSize: "14px"
        },
        children: show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                formattedPrice !== null && formattedPrice !== void 0 ? formattedPrice : "-",
                " ",
                label,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                    onClick: function() {
                        return setShowInverted(!showInverted);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        width: "14px"
                    })
                })
            ]
        }) : "-"
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapForm.tsx



function SwapForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    SwapForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwapForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: inset 0px -2px 0px rgba(0, 0, 0, 0.1);\n  .icon-up-down {\n    display: none;\n  }\n  &:hover {\n    background-color: ",
        ";\n    .icon-down {\n      display: none;\n      fill: white;\n    }\n    .icon-up-down {\n      display: block;\n      fill: white;\n    }\n  }\n"
    ]);
    SwapForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}































var Label = (0,styled_components_browser_esm/* default */.ZP)(Text_Text/* default */.Z).withConfig({
    componentId: "sc-478bf10d-0"
})(SwapForm_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
var SwitchIconButton = (0,styled_components_browser_esm/* default */.ZP)(Button_IconButton/* default */.Z).withConfig({
    componentId: "sc-478bf10d-1"
})(SwapForm_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
function SwapForm(param) {
    var setIsChartDisplayed = param.setIsChartDisplayed, isChartDisplayed = param.isChartDisplayed, isAccessTokenSupported = param.isAccessTokenSupported;
    var ref, ref1, ref2;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref3 = hooks_useRefreshBlockNumber(), refreshBlockNumber = ref3.refreshBlockNumber, isLoading = ref3.isLoading;
    var warningSwapHandler = useWarningImport();
    var ref4 = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref4.account, chainId = ref4.chainId;
    // for expert mode
    var ref5 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 1), isExpertMode = ref5[0];
    // get custom setting values for user
    var ref6 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 2), allowedSlippage = ref6[0], setUserSlippageTolerance = ref6[1];
    // swap state & price data
    var ref7 = useSwapState(), independentField = ref7.independentField, typedValue = ref7.typedValue, recipient = ref7.recipient, _INPUT = ref7[swap_actions/* Field.INPUT */.gN.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref7[swap_actions/* Field.OUTPUT */.gN.OUTPUT], outputCurrencyId = _OUTPUT.currencyId;
    var inputCurrency = (0,Tokens/* useCurrency */.U8)(inputCurrencyId);
    var outputCurrency = (0,Tokens/* useCurrency */.U8)(outputCurrencyId);
    (0,react.useEffect)(function() {
        if ((outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) === "TROLL") {
            setUserSlippageTolerance(800);
            return;
        }
        if ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) === "TROLL") {
            setUserSlippageTolerance(900);
            return;
        }
        setUserSlippageTolerance(50);
        if ((outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) === "Weed") {
            setUserSlippageTolerance(1200);
            return;
        }
        if ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) === "Weed") {
            setUserSlippageTolerance(1200);
            return;
        }
        setUserSlippageTolerance(50);
        if ((outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) === "Ken") {
            setUserSlippageTolerance(800);
            return;
        }
        if ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) === "Ken") {
            setUserSlippageTolerance(900);
            return;
        }
        setUserSlippageTolerance(50);
        if ((outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.symbol) === "THNDR") {
            setUserSlippageTolerance(800);
            return;
        }
        if ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.symbol) === "THNDR") {
            setUserSlippageTolerance(900);
            return;
        }
        setUserSlippageTolerance(50);
    }, [
        outputCurrency,
        inputCurrency,
        setUserSlippageTolerance
    ]);
    var currencies = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj;
    }, [
        inputCurrency,
        outputCurrency
    ]);
    var ref8 = useDerivedSwapInfo(independentField, typedValue, inputCurrency, outputCurrency, recipient), v2Trade = ref8.v2Trade, currencyBalances = ref8.currencyBalances, parsedAmount = ref8.parsedAmount, swapInputError = ref8.inputError;
    var ref9 = useWrapCallback(currencies[swap_actions/* Field.INPUT */.gN.INPUT], currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT], typedValue), wrapType = ref9.wrapType, onWrap = ref9.execute, wrapInputError = ref9.inputError;
    var showWrap = wrapType !== WrapType.NOT_APPLICABLE;
    var trade = showWrap ? undefined : v2Trade;
    var _obj, _obj1;
    var parsedAmounts = showWrap ? (_obj = {}, (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, parsedAmount), (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, parsedAmount), _obj) : (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, swap_actions/* Field.INPUT */.gN.INPUT, independentField === swap_actions/* Field.INPUT */.gN.INPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.inputAmount), (0,src_define_property/* default */.Z)(_obj1, swap_actions/* Field.OUTPUT */.gN.OUTPUT, independentField === swap_actions/* Field.OUTPUT */.gN.OUTPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.outputAmount), _obj1);
    var ref10 = (0,useSwapActionHandlers/* useSwapActionHandlers */._)(), onSwitchTokens = ref10.onSwitchTokens, onCurrencySelection = ref10.onCurrencySelection, onUserInput = ref10.onUserInput, onChangeRecipient = ref10.onChangeRecipient;
    var dependentField = independentField === swap_actions/* Field.INPUT */.gN.INPUT ? swap_actions/* Field.OUTPUT */.gN.OUTPUT : swap_actions/* Field.INPUT */.gN.INPUT;
    var handleTypeInput = (0,react.useCallback)(function(value) {
        onUserInput(swap_actions/* Field.INPUT */.gN.INPUT, value);
    }, [
        onUserInput
    ]);
    var handleTypeOutput = (0,react.useCallback)(function(value) {
        onUserInput(swap_actions/* Field.OUTPUT */.gN.OUTPUT, value);
    }, [
        onUserInput
    ]);
    var ref11, ref12;
    var _obj2;
    var formattedAmounts = (_obj2 = {}, (0,src_define_property/* default */.Z)(_obj2, independentField, typedValue), (0,src_define_property/* default */.Z)(_obj2, dependentField, showWrap ? (ref11 = (ref = parsedAmounts[independentField]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref11 !== void 0 ? ref11 : "" : (ref12 = (ref1 = parsedAmounts[dependentField]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)) !== null && ref12 !== void 0 ? ref12 : ""), _obj2);
    // check whether the user has approved the router on the input token
    var ref13 = (0,src_sliced_to_array/* default */.Z)(useApproveCallbackFromTrade(trade, allowedSlippage, chainId), 2), approval = ref13[0], approveCallback = ref13[1];
    // check if user has gone through approval process, used to show two step buttons, reset on token change
    var ref14 = (0,react.useState)(false), approvalSubmitted = ref14[0], setApprovalSubmitted = ref14[1];
    // mark when a user has submitted an approval, reset onTokenSelection for input field
    (0,react.useEffect)(function() {
        if (approval === ApprovalState.PENDING) {
            setApprovalSubmitted(true);
        }
    }, [
        approval,
        approvalSubmitted
    ]);
    var maxAmountInput = maxAmountSpend(currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT]);
    var atMaxAmountInput = Boolean(maxAmountInput && ((ref2 = parsedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref2 === void 0 ? void 0 : ref2.equalTo(maxAmountInput)));
    // errors
    var ref15 = (0,react.useState)(false), showInverted = ref15[0], setShowInverted = ref15[1];
    var handleInputSelect = (0,react.useCallback)(function(currencyInput) {
        setApprovalSubmitted(false) // reset 2 step UI for approvals
        ;
        onCurrencySelection(swap_actions/* Field.INPUT */.gN.INPUT, currencyInput);
        warningSwapHandler(currencyInput);
        (0,replaceBrowserHistory/* default */.Z)("inputCurrency", currencyId(currencyInput));
    }, [
        onCurrencySelection,
        warningSwapHandler
    ]);
    var handleMaxInput = (0,react.useCallback)(function() {
        if (maxAmountInput) {
            onUserInput(swap_actions/* Field.INPUT */.gN.INPUT, maxAmountInput.toExact());
        }
    }, [
        maxAmountInput,
        onUserInput
    ]);
    var handleOutputSelect = (0,react.useCallback)(function(currencyOutput) {
        onCurrencySelection(swap_actions/* Field.OUTPUT */.gN.OUTPUT, currencyOutput);
        warningSwapHandler(currencyOutput);
        (0,replaceBrowserHistory/* default */.Z)("outputCurrency", currencyId(currencyOutput));
    }, [
        onCurrencySelection,
        warningSwapHandler
    ]);
    var swapIsUnsupported = useIsTransactionUnsupported(currencies === null || currencies === void 0 ? void 0 : currencies.INPUT, currencies === null || currencies === void 0 ? void 0 : currencies.OUTPUT);
    var hasAmount = Boolean(parsedAmount);
    var onRefreshPrice = (0,react.useCallback)(function() {
        if (hasAmount) {
            refreshBlockNumber();
        }
    }, [
        hasAmount,
        refreshBlockNumber
    ]);
    var isShowAccessToken = (0,react.useMemo)(function() {
        var ref;
        return isAccessTokenSupported && !((ref = currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.isNative);
    }, [
        isAccessTokenSupported,
        currencies
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CurrencyInputHeader, {
                title: t("Trollswap"),
                subtitle: t("Trade tokens in an instant"),
                setIsChartDisplayed: setIsChartDisplayed,
                isChartDisplayed: isChartDisplayed,
                hasAmount: hasAmount,
                onRefreshPrice: onRefreshPrice
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styleds_Wrapper, {
                id: "swap-page",
                style: {
                    minHeight: "412px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                        gap: "sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel, {
                                label: independentField === swap_actions/* Field.OUTPUT */.gN.OUTPUT && !showWrap && trade ? t("From (estimated)") : t("From"),
                                value: formattedAmounts[swap_actions/* Field.INPUT */.gN.INPUT],
                                showMaxButton: !atMaxAmountInput,
                                currency: currencies[swap_actions/* Field.INPUT */.gN.INPUT],
                                onUserInput: handleTypeInput,
                                onMax: handleMaxInput,
                                onCurrencySelect: handleInputSelect,
                                otherCurrency: currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT],
                                id: "swap-currency-input",
                                showCommonBases: true,
                                commonBasesType: CommonBasesType.SWAP_LIMITORDER
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Column_AutoColumn, {
                                justify: "space-between",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                                    justify: isExpertMode ? "space-between" : "center",
                                    style: {
                                        padding: "0 1rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchIconButton, {
                                            variant: "light",
                                            scale: "sm",
                                            onClick: function() {
                                                setApprovalSubmitted(false) // reset 2 step UI for approvals
                                                ;
                                                onSwitchTokens();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                                    className: "icon-down",
                                                    color: currencies[swap_actions/* Field.INPUT */.gN.INPUT] && currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT] ? "primary" : "text"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpDown/* default */.Z, {
                                                    className: "icon-up-down",
                                                    color: currencies[swap_actions/* Field.INPUT */.gN.INPUT] && currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT] ? "primary" : "text"
                                                })
                                            ]
                                        }),
                                        recipient === null && !showWrap && isExpertMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "text",
                                            id: "add-recipient-button",
                                            onClick: function() {
                                                return onChangeRecipient("");
                                            },
                                            children: t("+ Add a send (optional)")
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel, {
                                value: formattedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT],
                                onUserInput: handleTypeOutput,
                                label: independentField === swap_actions/* Field.INPUT */.gN.INPUT && !showWrap && trade ? t("To (estimated)") : t("To"),
                                showMaxButton: false,
                                currency: currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT],
                                onCurrencySelect: handleOutputSelect,
                                otherCurrency: currencies[swap_actions/* Field.INPUT */.gN.INPUT],
                                id: "swap-currency-output",
                                showCommonBases: true,
                                commonBasesType: CommonBasesType.SWAP_LIMITORDER
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                style: {
                                    display: isShowAccessToken ? "block" : "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AccessRisk, {
                                    currency: currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT]
                                })
                            }),
                            isExpertMode && recipient !== null && !showWrap ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AutoRow, {
                                        justify: "space-between",
                                        style: {
                                            padding: "0 1rem"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, {
                                                clickable: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                                    width: "16px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                variant: "text",
                                                id: "remove-recipient-button",
                                                onClick: function() {
                                                    return onChangeRecipient(null);
                                                },
                                                children: t("- Remove send")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputPanel, {
                                        id: "recipient",
                                        value: recipient,
                                        onChange: onChangeRecipient
                                    })
                                ]
                            }) : null,
                            showWrap ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column_AutoColumn, {
                                gap: "7px",
                                style: {
                                    padding: "0 16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowBetween, {
                                        align: "center",
                                        children: Boolean(trade) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                    children: t("Price")
                                                }),
                                                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                    width: "100%",
                                                    ml: "8px",
                                                    height: "24px"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TradePrice, {
                                                    price: trade === null || trade === void 0 ? void 0 : trade.executionPrice,
                                                    showInverted: showInverted,
                                                    setShowInverted: setShowInverted
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowBetween, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                children: t("Slippage Tolerance")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text_Text/* default */.Z, {
                                                bold: true,
                                                color: "primary",
                                                children: [
                                                    allowedSlippage / 100,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        mt: "0.25rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCommitButton, {
                            swapIsUnsupported: swapIsUnsupported,
                            account: account,
                            showWrap: showWrap,
                            wrapInputError: wrapInputError,
                            onWrap: onWrap,
                            wrapType: wrapType,
                            parsedIndepentFieldAmount: parsedAmounts[independentField],
                            approval: approval,
                            approveCallback: approveCallback,
                            approvalSubmitted: approvalSubmitted,
                            currencies: currencies,
                            isExpertMode: isExpertMode,
                            trade: trade,
                            swapInputError: swapInputError,
                            currencyBalances: currencyBalances,
                            recipient: recipient,
                            allowedSlippage: allowedSlippage,
                            onUserInput: onUserInput
                        })
                    })
                ]
            }),
            !swapIsUnsupported ? trade && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSwapDetailsDropdown, {
                trade: trade
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsupportedCurrencyFooter, {
                currencies: [
                    currencies.INPUT,
                    currencies.OUTPUT
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  height: fit-content;\n  padding: 0 24px;\n\n  ",
        " {\n    padding: 0 40px;\n  }\n\n  ",
        " {\n    ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 328px;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSwapContainer = (0,styled_components_browser_esm/* default */.ZP)(Box_Flex/* default */.Z).withConfig({
    componentId: "sc-f3994e2-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
}, function(param) {
    var $isChartExpanded = param.$isChartExpanded;
    return $isChartExpanded ? "padding: 0 120px" : "padding: 0 40px";
});
var StyledInputCurrencyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-f3994e2-1"
})(styles_templateObject1());

;// CONCATENATED MODULE: ./src/views/Swap/index.tsx



function Swap_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 150px;\n  z-index: 2;\n  transform: translate(-45%, -34%);\n  @media screen and (max-width: 575px) {\n    display: none;\n  }\n  @media screen and (max-width: 968px) {\n    width: 80px;\n  }\n"
    ]);
    Swap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var ACCESS_TOKEN_SUPPORT_CHAIN_IDS = [
    src/* ChainId.BSC */.a_.BSC
];
var Swap_Logo = (0,styled_components_browser_esm/* default */.ZP)("img").withConfig({
    componentId: "sc-7f72095c-0"
})(Swap_templateObject());
function Swap() {
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var ref = (0,react.useState)(false), isChartExpanded = ref[0], setIsChartExpanded = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,hooks/* useExchangeChartManager */.vD)(isMobile), 2), userChartPreference = ref1[0], setUserChartPreference = ref1[1];
    var ref2 = (0,react.useState)(userChartPreference), isChartDisplayed = ref2[0], setIsChartDisplayed = ref2[1];
    useDefaultsFromURLSearch();
    (0,react.useEffect)(function() {
        setUserChartPreference(isChartDisplayed);
    }, [
        isChartDisplayed,
        setUserChartPreference
    ]);
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    // swap state & price data
    var ref3 = useSwapState(), _INPUT = ref3[swap_actions/* Field.INPUT */.gN.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref3[swap_actions/* Field.OUTPUT */.gN.OUTPUT], outputCurrencyId = _OUTPUT.currencyId;
    var inputCurrency = (0,Tokens/* useCurrency */.U8)(inputCurrencyId);
    var outputCurrency = (0,Tokens/* useCurrency */.U8)(outputCurrencyId);
    var _obj;
    var currencies = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,src_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj);
    var singleTokenPrice = useSingleTokenSwapInfo(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency);
    var isAccessTokenSupported = (0,react.useMemo)(function() {
        return ACCESS_TOKEN_SUPPORT_CHAIN_IDS.includes(chainId);
    }, [
        chainId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Page, {
        removePadding: false,
        hideFooterOnDesktop: isChartExpanded,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
            width: "100%",
            justifyContent: "center",
            position: "relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Flex/* default */.Z, {
                flexDirection: "column",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwapContainer, {
                    $isChartExpanded: isChartExpanded,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInputCurrencyWrapper, {
                        mt: isChartExpanded ? "24px" : "0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Swap_Logo, {
                                src: "/images/tokens/0x679f6863a653251C8C215e77205A7058b5bF676a.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBody, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapForm, {
                                    isAccessTokenSupported: isAccessTokenSupported,
                                    setIsChartDisplayed: setIsChartDisplayed,
                                    isChartDisplayed: isChartDisplayed
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Swap, {})
    });
};
IndexPage.chains = [];
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [21,299,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);